var Fa = Object.defineProperty;
var pa = (e, A, t) => A in e ? Fa(e, A, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[A] = t;
var h = (e, A, t) => (pa(e, typeof A != "symbol" ? A + "" : A, t), t);
let et;
const Ea = new Uint8Array(16);
function va() {
  if (!et && (et = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !et))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return et(Ea);
}
const j = [];
for (let e = 0; e < 256; ++e)
  j.push((e + 256).toString(16).slice(1));
function ma(e, A = 0) {
  return (j[e[A + 0]] + j[e[A + 1]] + j[e[A + 2]] + j[e[A + 3]] + "-" + j[e[A + 4]] + j[e[A + 5]] + "-" + j[e[A + 6]] + j[e[A + 7]] + "-" + j[e[A + 8]] + j[e[A + 9]] + "-" + j[e[A + 10]] + j[e[A + 11]] + j[e[A + 12]] + j[e[A + 13]] + j[e[A + 14]] + j[e[A + 15]]).toLowerCase();
}
const Ia = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), xn = {
  randomUUID: Ia
};
function Sn(e, A, t) {
  if (xn.randomUUID && !A && !e)
    return xn.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || va)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, A) {
    t = t || 0;
    for (let n = 0; n < 16; ++n)
      A[t + n] = r[n];
    return A;
  }
  return ma(r);
}
const un = "https://app.perceptinsight.com/track/v1/event", ji = "https://app.perceptinsight.com/track/v1/user", $i = "https://api.perceptinsight.com/experiment-service", Or = "https://api.perceptinsight.com/metadata-service/heatmap/screenshot", Ha = [
  un,
  ji,
  $i,
  Or
], ya = {
  autoTrackPageviews: !0,
  autoTrackRuntimeErrors: !0,
  autoTrackWebvitals: !1,
  autoTrackApiCalls: !1,
  autoTrackStaticResourceCalls: !1,
  autoFlushBatchSize: 50,
  autoFlushThresholdMs: 5e3,
  enableExperiment: !1,
  enableHeatmap: !1,
  enableHotspot: !1,
  autoAppOpened: !0,
  autoCaptureClicks: !1,
  apiTrackingBlocklist: []
}, Ie = "PERCEPT_GLOBAL_", ba = "pi_timed_event_duration";
var pA = /* @__PURE__ */ ((e) => (e.APP_OPENED = "App Opened", e.PAGE_VIEW = "$pageView", e.UNHANDLED_ERROR = "$unhandledError", e.FETCH = "$fetch", e.WEB_VITALS = "$webVitals", e.RESOURCE = "$resource", e.CLICK = "$click", e.SCROLL = "$scroll", e.EXPERIMENT_FECTH = "$pi_experiment_fetch", e))(pA || {}), _A = /* @__PURE__ */ ((e) => (e.FETCH_URL = "pi_fetch_url", e.FETCH_STATUS_CODE = "pi_fetch_status_code", e.FETCH_STATUS_TEXT = "pi_fetch_status_text", e.FETCH_REQUEST_TYPE = "pi_fetch_request_type", e.FETCH_SUCCESSFUL = "pi_fetch_successful", e.FETCH_TIME_TAKEN = "pi_fetch_time_taken", e.FETCH_DURATION = "pi_duration", e.FETCH_INITIATOR_TYPE = "pi_fetch_initiator_type", e))(_A || {}), VA = /* @__PURE__ */ ((e) => (e.UNHANDLED_ERROR_EVENT = "pi_unhandled_error_event", e.UNHANDLED_ERROR_URL = "pi_unhandled_error_url", e.UNHANDLED_ERROR_LINE = "pi_unhandled_error_line", e.UNHANDLED_ERROR_COL = "pi_unhandled_error_col", e.UNHANDLED_ERROR_STACK = "pi_unhandled_error_stack", e.UNHANDLED_ERROR_MSG = "pi_unhandled_error_msg", e.UNHANDLED_ERROR_NAME = "pi_unhandled_error_name", e))(VA || {}), La = /* @__PURE__ */ ((e) => (e.USER_ID = "user_id", e.PHONE = "phone", e.EMAIL = "email", e.DEVICE_TOKEN = "device_token", e.NAME = "name", e))(La || {}), Rr = /* @__PURE__ */ ((e) => (e.REFERRER = "pi_session_initial_referrer", e.REFERRER_DOMAIN = "pi_session_initial_referrer_domain", e))(Rr || {}), Mr = /* @__PURE__ */ ((e) => (e.SEARCH_ENGINE = "pi_search_engine", e.SEARCH_KEYWORD = "pi_search_keyword", e))(Mr || {}), bt = /* @__PURE__ */ ((e) => (e.DESKTOP = "desktop", e.MOBILE = "mobile", e.TABLET = "tablet", e))(bt || {});
const Ta = 1e4, Ka = { width: 365, height: 667 }, As = { width: 768, height: 1024 }, es = { width: 1280, height: 720 }, xa = {
  desktop: es,
  mobile: Ka,
  tablet: As
}, cA = {
  UNIQUE_ID_KEY: "percept_unique_id",
  USER_ID_KEY: "percept_user_id",
  PENDING_EVENTS: "percept_pending_events",
  // this key is used by retry flow
  EXPERIMENT_DATA_KEY: "percept_experiment_data",
  FAILED_BEACON_EVENTS: "percept_paending_beacon_events"
  // this key is used to retry the failed beacon evetns on page unload
};
class Sa {
  clear() {
    window == null || window.localStorage.clear();
  }
  getAll() {
    return { ...localStorage };
  }
  getItem(A) {
    return window == null ? void 0 : window.localStorage.getItem(A);
  }
  setItem(A, t) {
    window == null || window.localStorage.setItem(A, t);
  }
  multiGet(A) {
    return A.map((n) => this.getItem(n)).map((n, i) => [A[i], n]);
  }
  multiSet(A) {
    A.map((t) => this.setItem(t[0], t[1]));
  }
  removeItem(A) {
    return window == null ? void 0 : window.localStorage.removeItem(A);
  }
  multiRemove(A) {
    A.map((t) => this.removeItem(t));
  }
}
const oA = new Sa(), gn = (e = cA.PENDING_EVENTS) => {
  try {
    let A = oA.getItem(e), t = A ? JSON.parse(A) : [];
    return t.length > 1 && (t = t.sort(
      (r, n) => {
        var i, s;
        return ((i = r.data) == null ? void 0 : i.pi_client_ts) - ((s = n.data) == null ? void 0 : s.pi_client_ts);
      }
    )), t;
  } catch {
    return [];
  }
}, ts = (e = cA.PENDING_EVENTS) => oA.removeItem(e), wn = () => typeof window < "u" && typeof window.document < "u", _r = () => wn() ? window.location.origin + window.location.pathname : "", Da = (e) => {
  var A;
  (A = window == null ? void 0 : window.sessionStorage) == null || A.setItem("LAST_URL", e);
}, Oa = () => {
  var e;
  return (e = window == null ? void 0 : window.sessionStorage) == null ? void 0 : e.getItem("LAST_URL");
}, St = () => window.innerWidth <= As.width ? bt.MOBILE : window.innerWidth <= es.width ? bt.TABLET : bt.DESKTOP, rs = () => {
  const e = xa[St()];
  let A = e.width / window.innerWidth, t = e.height / window.innerHeight;
  return { xPosFactor: A, yPosFactor: t };
}, Ra = () => {
  if (!wn())
    return {};
  const { host: e, pathname: A, href: t } = window.location;
  return {
    href: t,
    pathname: A,
    host: e,
    url: _r()
  };
}, Ma = (e) => {
  let A = {};
  return Object.keys(e).forEach((t) => {
    e[t] === void 0 || e[t] === null || typeof e[t] == "string" && e[t].trim().length === 0 || (A[t] = e[t]);
  }), A;
}, _a = (e, A) => {
  let t = null, r = !0;
  return (...n) => {
    if (r) {
      r = !1;
      const i = e(...n);
      return t = setTimeout(() => {
        t = null, r = !0;
      }, A), i;
    } else if (!t)
      return t = setTimeout(() => {
        t = null, r = !0;
      }, A), e(...n);
  };
};
class Ga {
  constructor() {
    h(this, "isEnabled", !1);
  }
  info(...A) {
    this.isEnabled && console.info(A);
  }
  warn(...A) {
    this.isEnabled && console.warn(A);
  }
  log(...A) {
    this.isEnabled && console.log(A);
  }
  error(...A) {
    this.isEnabled && console.error(A);
  }
  setIsEnabled(A) {
    this.isEnabled = A;
  }
}
const I = new Ga(), Xe = (e) => {
  let A = oA.getItem(cA.UNIQUE_ID_KEY);
  return {
    "Content-Type": "application/json; charset=UTF-8",
    Authorization: e,
    "X-PI-Unique-Id": A || "",
    "X-PI-App": location.host
  };
}, cr = (e = {}) => {
  let A = {}, t = {};
  return Object.keys(e).forEach((r) => {
    let n = e[r];
    Array.isArray(n) ? t[r] = n : A[r] = n;
  }), {
    data: A,
    multiData: t
  };
}, Na = async (e, A) => {
  try {
    const t = Xe(`Bearer ${A}`);
    await fetch(un, {
      keepalive: !0,
      method: "POST",
      headers: { ...t },
      body: JSON.stringify({
        events: e
      })
    });
  } catch {
    I.warn("[PI] beacon failed"), Wt(e, cA.FAILED_BEACON_EVENTS);
  }
}, Pa = async (e) => {
  let A = gn(
    cA.FAILED_BEACON_EVENTS
  );
  if (Array.isArray(A) && A.length > 0)
    try {
      ts(cA.FAILED_BEACON_EVENTS), fn(A, e);
    } catch {
      Wt(A, cA.FAILED_BEACON_EVENTS);
    }
}, ka = (e) => encodeURI(e).split(/%..|./).length - 1, ns = (e) => (ka(JSON.stringify(e)) / 1e3 > 3e3 && (I.warn("[PI] event dropped as storage size  exceeded"), I.warn(`[PI] ${e[0]}`), e.shift(), ns(e)), e), Va = (e) => {
  const A = [];
  return e = e.filter((t) => {
    var n, i;
    if (!((n = t.data) != null && n.pi_client_ts) || !((i = t.data) != null && i.pi_client_unique_event_id))
      return !0;
    let r = t.data.pi_client_ts + t.data.pi_client_unique_event_id;
    return A.indexOf(r) > -1 ? !1 : (A.push(r), !0);
  }), e;
}, Wt = (e, A = cA.PENDING_EVENTS) => {
  try {
    let t = gn(), r = ns([
      ...t,
      ...e
    ]).sort(
      (n, i) => {
        var s, a;
        return ((s = n.data) == null ? void 0 : s.pi_client_ts) - ((a = i.data) == null ? void 0 : a.pi_client_ts);
      }
    );
    r.length > 0 && oA.setItem(A, JSON.stringify(r));
  } catch {
    I.error("[PI] events retry setup failed");
  }
}, fn = async (e, A) => {
  if (Va(e).length === 0)
    return;
  const r = Xe(`Bearer ${A}`);
  return fetch(un, {
    method: "POST",
    headers: { ...r },
    body: JSON.stringify({
      events: e
    })
  });
}, Xa = async (e, A, t = 2) => {
  if (e = e.filter(
    (i) => i.name && i.name.length > 0 && i.name.toLowerCase() !== "null"
  ), e.length === 0)
    return;
  let r = 0, n = !1;
  for (; r < t && !n; )
    try {
      await fn(e, A), n = !0;
    } catch (i) {
      if (r++, r === t)
        throw I.error(
          "[PI] api call failed. setting up retry with exponential backoff"
        ), I.error(`[PI]: api failure error: ${i}`), Wt(e), i;
    }
}, Ja = async (e, A) => {
  let t = 0, r = !1;
  for (; t < 2 && !r; )
    try {
      const n = Xe(`Bearer ${A}`);
      await fetch(ji, {
        method: "POST",
        headers: { ...n },
        body: JSON.stringify(e)
      }), r = !0;
    } catch {
      I.error("[PI] user properties api call failed."), I.error(`[PI] please try setting this after some time: ${e}`), t++;
    }
};
var YA, _e, is, Dt, Gr, Fe = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, Je = function(e) {
  if (document.readyState === "loading")
    return "loading";
  var A = Fe();
  if (A) {
    if (e < A.domInteractive)
      return "loading";
    if (A.domContentLoadedEventStart === 0 || e < A.domContentLoadedEventStart)
      return "dom-interactive";
    if (A.domComplete === 0 || e < A.domComplete)
      return "dom-content-loaded";
  }
  return "complete";
}, Wa = function(e) {
  var A = e.nodeName;
  return e.nodeType === 1 ? A.toLowerCase() : A.toUpperCase().replace(/^#/, "");
}, Yt = function(e, A) {
  var t = "";
  try {
    for (; e && e.nodeType !== 9; ) {
      var r = e, n = r.id ? "#" + r.id : Wa(r) + (r.classList && r.classList.value && r.classList.value.trim() && r.classList.value.trim().length ? "." + r.classList.value.trim().replace(/\s+/g, ".") : "");
      if (t.length + n.length > (A || 100) - 1)
        return t || n;
      if (t = t ? n + ">" + t : n, r.id)
        break;
      e = r.parentNode;
    }
  } catch {
  }
  return t;
}, ss = -1, as = function() {
  return ss;
}, se = function(e) {
  addEventListener("pageshow", function(A) {
    A.persisted && (ss = A.timeStamp, e(A));
  }, !0);
}, Zt = function() {
  var e = Fe();
  return e && e.activationStart || 0;
}, CA = function(e, A) {
  var t = Fe(), r = "navigate";
  return as() >= 0 ? r = "back-forward-cache" : t && (document.prerendering || Zt() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : t.type && (r = t.type.replace(/_/g, "-"))), { name: e, value: A === void 0 ? -1 : A, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: r };
}, pe = function(e, A, t) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var r = new PerformanceObserver(function(n) {
        Promise.resolve().then(function() {
          A(n.getEntries());
        });
      });
      return r.observe(Object.assign({ type: e, buffered: !0 }, t || {})), r;
    }
  } catch {
  }
}, UA = function(e, A, t, r) {
  var n, i;
  return function(s) {
    A.value >= 0 && (s || r) && ((i = A.value - (n || 0)) || n === void 0) && (n = A.value, A.delta = i, A.rating = function(a, o) {
      return a > o[1] ? "poor" : a > o[0] ? "needs-improvement" : "good";
    }(A.value, t), e(A));
  };
}, Qn = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, qt = function(e) {
  var A = function(t) {
    t.type !== "pagehide" && document.visibilityState !== "hidden" || e(t);
  };
  addEventListener("visibilitychange", A, !0), addEventListener("pagehide", A, !0);
}, hn = function(e) {
  var A = !1;
  return function(t) {
    A || (e(t), A = !0);
  };
}, he = -1, Dn = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, Ot = function(e) {
  document.visibilityState === "hidden" && he > -1 && (he = e.type === "visibilitychange" ? e.timeStamp : 0, Ya());
}, On = function() {
  addEventListener("visibilitychange", Ot, !0), addEventListener("prerenderingchange", Ot, !0);
}, Ya = function() {
  removeEventListener("visibilitychange", Ot, !0), removeEventListener("prerenderingchange", Ot, !0);
}, Cn = function() {
  return he < 0 && (he = Dn(), On(), se(function() {
    setTimeout(function() {
      he = Dn(), On();
    }, 0);
  })), { get firstHiddenTime() {
    return he;
  } };
}, qe = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, Rn = [1800, 3e3], os = function(e, A) {
  A = A || {}, qe(function() {
    var t, r = Cn(), n = CA("FCP"), i = pe("paint", function(s) {
      s.forEach(function(a) {
        a.name === "first-contentful-paint" && (i.disconnect(), a.startTime < r.firstHiddenTime && (n.value = Math.max(a.startTime - Zt(), 0), n.entries.push(a), t(!0)));
      });
    });
    i && (t = UA(e, n, Rn, A.reportAllChanges), se(function(s) {
      n = CA("FCP"), t = UA(e, n, Rn, A.reportAllChanges), Qn(function() {
        n.value = performance.now() - s.timeStamp, t(!0);
      });
    }));
  });
}, Mn = [0.1, 0.25], Za = function(e, A) {
  (function(t, r) {
    r = r || {}, os(hn(function() {
      var n, i = CA("CLS", 0), s = 0, a = [], o = function(l) {
        l.forEach(function(u) {
          if (!u.hadRecentInput) {
            var c = a[0], f = a[a.length - 1];
            s && u.startTime - f.startTime < 1e3 && u.startTime - c.startTime < 5e3 ? (s += u.value, a.push(u)) : (s = u.value, a = [u]);
          }
        }), s > i.value && (i.value = s, i.entries = a, n());
      }, B = pe("layout-shift", o);
      B && (n = UA(t, i, Mn, r.reportAllChanges), qt(function() {
        o(B.takeRecords()), n(!0);
      }), se(function() {
        s = 0, i = CA("CLS", 0), n = UA(t, i, Mn, r.reportAllChanges), Qn(function() {
          return n();
        });
      }), setTimeout(n, 0));
    }));
  })(function(t) {
    (function(r) {
      if (r.entries.length) {
        var n = r.entries.reduce(function(a, o) {
          return a && a.value > o.value ? a : o;
        });
        if (n && n.sources && n.sources.length) {
          var i = (s = n.sources).find(function(a) {
            return a.node && a.node.nodeType === 1;
          }) || s[0];
          if (i)
            return void (r.attribution = { largestShiftTarget: Yt(i.node), largestShiftTime: n.startTime, largestShiftValue: n.value, largestShiftSource: i, largestShiftEntry: n, loadState: Je(n.startTime) });
        }
      }
      var s;
      r.attribution = {};
    })(t), e(t);
  }, A);
}, qa = function(e, A) {
  os(function(t) {
    (function(r) {
      if (r.entries.length) {
        var n = Fe(), i = r.entries[r.entries.length - 1];
        if (n) {
          var s = n.activationStart || 0, a = Math.max(0, n.responseStart - s);
          return void (r.attribution = { timeToFirstByte: a, firstByteToFCP: r.value - a, loadState: Je(r.entries[0].startTime), navigationEntry: n, fcpEntry: i });
        }
      }
      r.attribution = { timeToFirstByte: 0, firstByteToFCP: r.value, loadState: Je(as()) };
    })(t), e(t);
  }, A);
}, Te = { passive: !0, capture: !0 }, za = /* @__PURE__ */ new Date(), _n = function(e, A) {
  YA || (YA = A, _e = e, is = /* @__PURE__ */ new Date(), cs(removeEventListener), Bs());
}, Bs = function() {
  if (_e >= 0 && _e < is - za) {
    var e = { entryType: "first-input", name: YA.type, target: YA.target, cancelable: YA.cancelable, startTime: YA.timeStamp, processingStart: YA.timeStamp + _e };
    Dt.forEach(function(A) {
      A(e);
    }), Dt = [];
  }
}, ja = function(e) {
  if (e.cancelable) {
    var A = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(t, r) {
      var n = function() {
        _n(t, r), s();
      }, i = function() {
        s();
      }, s = function() {
        removeEventListener("pointerup", n, Te), removeEventListener("pointercancel", i, Te);
      };
      addEventListener("pointerup", n, Te), addEventListener("pointercancel", i, Te);
    }(A, e) : _n(A, e);
  }
}, cs = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(A) {
    return e(A, ja, Te);
  });
}, Gn = [100, 300], $a = function(e, A) {
  A = A || {}, qe(function() {
    var t, r = Cn(), n = CA("FID"), i = function(o) {
      o.startTime < r.firstHiddenTime && (n.value = o.processingStart - o.startTime, n.entries.push(o), t(!0));
    }, s = function(o) {
      o.forEach(i);
    }, a = pe("first-input", s);
    t = UA(e, n, Gn, A.reportAllChanges), a && qt(hn(function() {
      s(a.takeRecords()), a.disconnect();
    })), a && se(function() {
      var o;
      n = CA("FID"), t = UA(e, n, Gn, A.reportAllChanges), Dt = [], _e = -1, YA = null, cs(addEventListener), o = i, Dt.push(o), Bs();
    });
  });
}, Ao = function(e, A) {
  $a(function(t) {
    (function(r) {
      var n = r.entries[0];
      r.attribution = { eventTarget: Yt(n.target), eventType: n.name, eventTime: n.startTime, eventEntry: n, loadState: Je(n.startTime) };
    })(t), e(t);
  }, A);
}, ls = 0, lr = 1 / 0, tt = 0, eo = function(e) {
  e.forEach(function(A) {
    A.interactionId && (lr = Math.min(lr, A.interactionId), tt = Math.max(tt, A.interactionId), ls = tt ? (tt - lr) / 7 + 1 : 0);
  });
}, us = function() {
  return Gr ? ls : performance.interactionCount || 0;
}, to = function() {
  "interactionCount" in performance || Gr || (Gr = pe("event", eo, { type: "event", buffered: !0, durationThreshold: 0 }));
}, Nn = [200, 500], gs = 0, Pn = function() {
  return us() - gs;
}, xA = [], ur = {}, kn = function(e) {
  var A = xA[xA.length - 1], t = ur[e.interactionId];
  if (t || xA.length < 10 || e.duration > A.latency) {
    if (t)
      t.entries.push(e), t.latency = Math.max(t.latency, e.duration);
    else {
      var r = { id: e.interactionId, latency: e.duration, entries: [e] };
      ur[r.id] = r, xA.push(r);
    }
    xA.sort(function(n, i) {
      return i.latency - n.latency;
    }), xA.splice(10).forEach(function(n) {
      delete ur[n.id];
    });
  }
}, ro = function(e, A) {
  A = A || {}, qe(function() {
    to();
    var t, r = CA("INP"), n = function(s) {
      s.forEach(function(B) {
        B.interactionId && kn(B), B.entryType === "first-input" && !xA.some(function(l) {
          return l.entries.some(function(u) {
            return B.duration === u.duration && B.startTime === u.startTime;
          });
        }) && kn(B);
      });
      var a, o = (a = Math.min(xA.length - 1, Math.floor(Pn() / 50)), xA[a]);
      o && o.latency !== r.value && (r.value = o.latency, r.entries = o.entries, t());
    }, i = pe("event", n, { durationThreshold: A.durationThreshold || 40 });
    t = UA(e, r, Nn, A.reportAllChanges), i && (i.observe({ type: "first-input", buffered: !0 }), qt(function() {
      n(i.takeRecords()), r.value < 0 && Pn() > 0 && (r.value = 0, r.entries = []), t(!0);
    }), se(function() {
      xA = [], gs = us(), r = CA("INP"), t = UA(e, r, Nn, A.reportAllChanges);
    }));
  });
}, no = function(e, A) {
  ro(function(t) {
    (function(r) {
      if (r.entries.length) {
        var n = r.entries.sort(function(i, s) {
          return s.duration - i.duration || s.processingEnd - s.processingStart - (i.processingEnd - i.processingStart);
        })[0];
        r.attribution = { eventTarget: Yt(n.target), eventType: n.name, eventTime: n.startTime, eventEntry: n, loadState: Je(n.startTime) };
      } else
        r.attribution = {};
    })(t), e(t);
  }, A);
}, Vn = [2500, 4e3], gr = {}, io = function(e, A) {
  (function(t, r) {
    r = r || {}, qe(function() {
      var n, i = Cn(), s = CA("LCP"), a = function(l) {
        var u = l[l.length - 1];
        u && u.startTime < i.firstHiddenTime && (s.value = Math.max(u.startTime - Zt(), 0), s.entries = [u], n());
      }, o = pe("largest-contentful-paint", a);
      if (o) {
        n = UA(t, s, Vn, r.reportAllChanges);
        var B = hn(function() {
          gr[s.id] || (a(o.takeRecords()), o.disconnect(), gr[s.id] = !0, n(!0));
        });
        ["keydown", "click"].forEach(function(l) {
          addEventListener(l, B, !0);
        }), qt(B), se(function(l) {
          s = CA("LCP"), n = UA(t, s, Vn, r.reportAllChanges), Qn(function() {
            s.value = performance.now() - l.timeStamp, gr[s.id] = !0, n(!0);
          });
        });
      }
    });
  })(function(t) {
    (function(r) {
      if (r.entries.length) {
        var n = Fe();
        if (n) {
          var i = n.activationStart || 0, s = r.entries[r.entries.length - 1], a = s.url && performance.getEntriesByType("resource").filter(function(f) {
            return f.name === s.url;
          })[0], o = Math.max(0, n.responseStart - i), B = Math.max(o, a ? (a.requestStart || a.startTime) - i : 0), l = Math.max(B, a ? a.responseEnd - i : 0), u = Math.max(l, s ? s.startTime - i : 0), c = { element: Yt(s.element), timeToFirstByte: o, resourceLoadDelay: B - o, resourceLoadTime: l - B, elementRenderDelay: u - l, navigationEntry: n, lcpEntry: s };
          return s.url && (c.url = s.url), a && (c.lcpResourceEntry = a), void (r.attribution = c);
        }
      }
      r.attribution = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadTime: 0, elementRenderDelay: r.value };
    })(t), e(t);
  }, A);
}, Xn = [800, 1800], so = function e(A) {
  document.prerendering ? qe(function() {
    return e(A);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(A);
  }, !0) : setTimeout(A, 0);
}, ao = function(e, A) {
  A = A || {};
  var t = CA("TTFB"), r = UA(e, t, Xn, A.reportAllChanges);
  so(function() {
    var n = Fe();
    if (n) {
      var i = n.responseStart;
      if (i <= 0 || i > performance.now())
        return;
      t.value = Math.max(i - Zt(), 0), t.entries = [n], r(!0), se(function() {
        t = CA("TTFB", 0), (r = UA(e, t, Xn, A.reportAllChanges))(!0);
      });
    }
  });
}, oo = function(e, A) {
  ao(function(t) {
    (function(r) {
      if (r.entries.length) {
        var n = r.entries[0], i = n.activationStart || 0, s = Math.max(n.domainLookupStart - i, 0), a = Math.max(n.connectStart - i, 0), o = Math.max(n.requestStart - i, 0);
        r.attribution = { waitingTime: s, dnsTime: a - s, connectionTime: o - a, requestTime: r.value - o, navigationEntry: n };
      } else
        r.attribution = { waitingTime: 0, dnsTime: 0, connectionTime: 0, requestTime: 0 };
    })(t), e(t);
  }, A);
};
const oe = pA.WEB_VITALS;
class Bo {
  constructor() {
    h(this, "tracker");
    h(this, "init", (A) => {
      this.tracker = A, Za(this.trackCLS), Ao(this.trackFID), io(this.trackLCP), oo(this.trackTTFB), qa(this.trackFCP), no(this.trackINP);
    });
    h(this, "trackCLS", (A) => {
      var i;
      const { attribution: t, ...r } = A, n = this.getGenericEventProps(r);
      n.pi_metric_debug_target = (i = t == null ? void 0 : t.largestShiftTarget) == null ? void 0 : i.toString(), this.tracker(oe, n);
    });
    h(this, "trackFID", (A) => {
      var i;
      const { attribution: t, ...r } = A, n = this.getGenericEventProps(r);
      n.pi_metric_debug_target = (i = t == null ? void 0 : t.eventTarget) == null ? void 0 : i.toString(), this.tracker(oe, n);
    });
    h(this, "trackLCP", (A) => {
      var i;
      const { attribution: t, ...r } = A, n = this.getGenericEventProps(r);
      n.pi_metric_debug_target = (i = t == null ? void 0 : t.element) == null ? void 0 : i.toString(), this.tracker(oe, n);
    });
    h(this, "trackTTFB", (A) => {
      const { attribution: t, ...r } = A, n = this.getGenericEventProps(r);
      this.tracker(oe, n);
    });
    h(this, "trackFCP", (A) => {
      const { attribution: t, ...r } = A, n = this.getGenericEventProps(r);
      this.tracker(oe, n);
    });
    h(this, "trackINP", (A) => {
      var i;
      const { attribution: t, ...r } = A, n = this.getGenericEventProps(r);
      n.pi_metric_debug_target = (i = t == null ? void 0 : t.eventTarget) == null ? void 0 : i.toString(), this.tracker(oe, n);
    });
    h(this, "getGenericEventProps", (A) => ({
      pi_metric_id: A.id,
      pi_metric_name: A.name,
      pi_metric_value: A.value.toString(),
      pi_metric_rating: A.rating,
      pi_metric_navigation_type: A.navigationType
    }));
  }
}
const co = new Bo();
class lo {
  constructor() {
    h(this, "eventTimers", {});
  }
  setEventTimer(A, t) {
    this.eventTimers[A] = t;
  }
  removeEventTimer(A) {
    let t = this.eventTimers[A];
    return t && delete this.eventTimers[A], t;
  }
  clearAllTimestamps() {
    this.eventTimers = {};
  }
}
const Jn = new lo(), Wn = (e) => e.entryType === "resource";
class uo {
  constructor() {
    h(this, "tracker");
    h(this, "blocklist");
    h(this, "perfObserver");
    h(this, "init", (A, t) => {
      this.tracker = A, this.blocklist = t.blocklist, wn() && "performance" in window && "PerformanceObserver" in window ? (t.autoTrackApiCalls && this.addNetworkObservers(), t.autoTrackStaticResourceCalls && this.initPerformanceObserver()) : I.warn("[PI] network tracking is not supported in the browser");
    });
    h(this, "isTrackingAllowedForUrl", (A) => Ha.indexOf(A) > -1 ? !1 : Array.isArray(this.blocklist) && this.blocklist.length > 0 ? this.blocklist.every((t) => t !== A) : typeof this.blocklist == "string" ? !new RegExp(this.blocklist).test(A) : !0);
    h(this, "getRequestPerformanceEntry", async (A, t, r, n, i = 0) => {
      try {
        if (i > 10)
          return I.warn("[PI] Failed to get performance entry for request", {
            url: A,
            initiatorType: t
          }), null;
        const a = performance.getEntriesByName(
          A
        ).find(
          (o) => Wn(o) && o.initiatorType === t && o.startTime >= r && o.startTime <= n
        );
        return a || (await new Promise((o) => setTimeout(o, 50 * i)), this.getRequestPerformanceEntry(
          A,
          t,
          r,
          n,
          i + 1
        ));
      } catch {
        return null;
      }
    });
    h(this, "trackStaticResource", async (A) => {
      if (this.tracker && this.isTrackingAllowedForUrl(A.name)) {
        let t = {
          ...A.toJSON(),
          initiatorType: A.initiatorType,
          resourceType: this.getResourceType(A.name)
        };
        this.tracker(pA.RESOURCE, t);
      }
    });
    h(this, "trackApiResponse", async (A) => {
      if (this.tracker && this.isTrackingAllowedForUrl(A.url))
        try {
          const t = await this.getRequestPerformanceEntry(
            A.url,
            A.initiatorType,
            performance.now() - A.timeTaken,
            performance.now()
          );
          let r = t ? { ...t.toJSON() } : {};
          r = {
            ...r,
            [_A.FETCH_URL]: A.url,
            [_A.FETCH_REQUEST_TYPE]: A.requestType,
            [_A.FETCH_SUCCESSFUL]: A.isSuccessful,
            [_A.FETCH_STATUS_CODE]: A.status,
            [_A.FETCH_STATUS_TEXT]: A.statusText,
            [_A.FETCH_TIME_TAKEN]: A.timeTaken,
            [_A.FETCH_DURATION]: t ? t.duration : A.timeTaken,
            [_A.FETCH_INITIATOR_TYPE]: A.initiatorType
          }, this.tracker(pA.FETCH, r);
        } catch (t) {
          I.error("[PI] Failed to track api event", t);
        }
    });
    h(this, "fetchProxyListener", async (A, t, r) => {
      const n = r[0].toString(), i = r[1] instanceof Request ? r[1].method : "GET", s = performance.now();
      try {
        let a = await A.apply(t, r);
        const o = performance.now();
        return this.trackApiResponse({
          requestType: i,
          url: a.url,
          status: a.status,
          statusText: a.statusText,
          isSuccessful: a.ok,
          timeTaken: o - s,
          initiatorType: "fetch",
          startTime: s,
          endTime: o
        }), a;
      } catch (a) {
        const o = performance.now();
        return this.trackApiResponse({
          requestType: i,
          url: n.toString(),
          status: 0,
          statusText: "ERR_NETWORK",
          isSuccessful: !1,
          timeTaken: o - s,
          initiatorType: "fetch",
          startTime: s,
          endTime: o
        }), Promise.reject(a);
      }
    });
    h(this, "xmlHttpRequestProxyListener", (A, t, r) => {
      const n = performance.now();
      t.addEventListener("readystatechange", () => {
        if (t.readyState === XMLHttpRequest.DONE) {
          const i = performance.now(), s = r[0], { responseURL: a, status: o, statusText: B } = t, l = t.status >= 200 && t.status < 300;
          let u = a || r[1].toString();
          this.trackApiResponse({
            timeTaken: i - n,
            url: u,
            status: o,
            statusText: B,
            requestType: s,
            isSuccessful: l,
            initiatorType: "xmlhttprequest",
            startTime: n,
            endTime: i
          });
        }
      }), Reflect.apply(A, t, r);
    });
    h(this, "addNetworkObservers", () => {
      window.fetch = new Proxy(window.fetch, {
        apply: this.fetchProxyListener
      }), window.XMLHttpRequest.prototype.open = new Proxy(
        window.XMLHttpRequest.prototype.open,
        {
          apply: this.xmlHttpRequestProxyListener
        }
      );
    });
    h(this, "getResourceType", (A) => {
      const t = /\.(jpe?g|png|gif|svg)$/i, r = /\.(js|jsx|ts|tsx)$/i, n = /\.css$/i;
      return t.test(A) ? "image" : r.test(A) ? "javascript" : n.test(A) ? "stylesheet" : "other";
    });
    h(this, "initPerformanceObserver", () => {
      "PerformanceObserver" in window && (this.perfObserver = new PerformanceObserver((A) => {
        A.getEntries().forEach((t) => {
          Wn(t) && t.initiatorType !== "fetch" && t.initiatorType !== "xmlhttprequest" && this.trackStaticResource(t);
        });
      }), this.perfObserver.observe({ type: "resource" }));
    });
  }
}
const go = new uo();
class wo {
  constructor() {
    h(this, "timer");
    h(this, "retryAttempt", 0);
    h(this, "maxDelay", 30 * 60 * 1e3);
    // 30 mins in milliseconds
    h(this, "token");
    h(this, "maxBatchSize", 100);
    h(this, "processingInProgress", !1);
    h(this, "init", (A) => {
      this.token = A, this.schedule();
    });
    h(this, "schedule", () => {
      this.timer || this.processingInProgress || (this.timer = setTimeout(
        this.send,
        Math.min(this.maxDelay, Math.pow(2, this.retryAttempt + 1) * 1e3)
      ));
    });
    h(this, "send", async () => {
      if (!this.token)
        return;
      let A = gn();
      if (A.length > 0)
        try {
          this.processingInProgress = !0, ts();
          let t = await this.batchSend([...A]);
          if (t.length > 0)
            throw Wt(t), new Error("[PI] batch processing of pending events failed");
          this.clear(), this.processingInProgress = !1;
        } catch {
          this.clear(), this.processingInProgress = !1, this.retryAttempt++, this.schedule();
        }
      else
        this.clear();
    });
    h(this, "batchSend", async (A) => new Promise(async (t) => {
      let r = 0, n = [], i = [];
      for (; r < A.length; ) {
        let s = A.slice(
          r,
          Math.min(
            r + this.maxBatchSize,
            A.length
          )
        ), a = (o) => new Promise((B) => {
          fn(o, this.token).then(B).catch((l) => {
            n = [...n, ...o], B();
          });
        });
        i.push(a([...s])), r = r + this.maxBatchSize;
      }
      await Promise.allSettled(i), t(n);
    }));
    h(this, "clear", () => {
      this.timer && (clearTimeout(this.timer), this.timer = void 0);
    });
  }
}
const Yn = new wo(), fo = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gclid",
  // google ads
  "gad_source",
  // google ads
  "gclsrc",
  // google ads 360
  "dclid",
  // google display ads
  "gbraid",
  // google ads, web to app
  "wbraid",
  // google ads, app to web
  "fbclid",
  // facebook
  "msclkid",
  // microsoft
  "twclid",
  // twitter
  "li_fat_id",
  // linkedin
  "mc_cid",
  // mailchimp campaign id
  "igshid",
  // instagram
  "ttclid"
  // tiktok
], rt = "https?://(.*)", kA = {
  IsSessionManagerInitialised: "pi_isSessionManagerInitialised",
  SessionParams: "pi_sessionParams",
  SessionInitialReferrerInfo: "pi_sessionInitialReferrerInfo",
  SessionSearchInfo: "pi_searchInfo"
}, nt = (e) => {
  try {
    let A = sessionStorage == null ? void 0 : sessionStorage.getItem(e);
    return A ? JSON.parse(A) : null;
  } catch {
    return null;
  }
};
class Qo {
  constructor() {
    h(this, "_isSessionManagerInitialised", !1);
    h(this, "_campaignParams", {});
    h(this, "_sessionInitialReferrerInfo", {
      referrer: "$direct",
      referrer_domain: "$direct"
    });
    h(this, "_searchInfo");
  }
  init() {
    this._isSessionManagerInitialised = nt(kA.IsSessionManagerInitialised) || !1, this._isSessionManagerInitialised ? this.setValuesFromSessionStorage() : (this.setCampaignParamsFromUrl(), this.setSessionInitialReferrerInfo(), this.setSearchEngineInfo(), this._isSessionManagerInitialised = !0, sessionStorage.setItem(
      kA.IsSessionManagerInitialised,
      JSON.stringify(!0)
    ));
  }
  setCampaignParamsFromUrl() {
    const A = new URL(window.location.href);
    let t = {};
    fo.forEach((r) => {
      let n = A.searchParams.get(r);
      n && (t[r] = n);
    }), this._campaignParams = { ...t }, this.updateValuesInSessionStorage;
  }
  setSessionInitialReferrerInfo() {
    if (document.referrer) {
      const A = new URL(document.referrer);
      this._sessionInitialReferrerInfo = {
        referrer: document.referrer,
        referrer_domain: A.host
      }, sessionStorage.setItem(
        kA.SessionInitialReferrerInfo,
        JSON.stringify(this._sessionInitialReferrerInfo)
      );
    }
  }
  getSearchEngine() {
    const A = document == null ? void 0 : document.referrer;
    return A ? A.search(rt + "google.([^/?]*)") === 0 ? "google" : A.search(rt + "bing.com") === 0 ? "bing" : A.search(rt + "yahoo.com") === 0 ? "yahoo" : A.search(rt + "duckduckgo.com") === 0 ? "duckduckgo" : null : null;
  }
  setSearchEngineInfo() {
    let A = this.getSearchEngine(), t = A != "yahoo" ? "q" : "p";
    if (A !== null) {
      let r = {
        search_engine: A,
        search_keyword: ""
      };
      const i = new URL(document.referrer).searchParams.get(t);
      r.search_keyword = i || "", this._searchInfo = { ...r }, sessionStorage.setItem(
        kA.SessionSearchInfo,
        JSON.stringify(r)
      );
    }
  }
  setValuesFromSessionStorage() {
    let A = nt(kA.SessionParams) || {};
    this._campaignParams = { ...A };
    let t = nt(
      kA.SessionInitialReferrerInfo
    ) || { referrer: "$direct", referrer_domain: "$direct" };
    this._sessionInitialReferrerInfo = { ...t };
    let r = nt(kA.SessionSearchInfo) || void 0;
    this._searchInfo = r;
  }
  updateValuesInSessionStorage() {
    sessionStorage.setItem(
      kA.SessionParams,
      JSON.stringify(this._campaignParams)
    );
  }
  getParams() {
    return { ...this._campaignParams };
  }
  getSessionInitialReferrerInfo() {
    return { ...this._sessionInitialReferrerInfo };
  }
  getReferrerInfo() {
    if (document.referrer) {
      const A = new URL(document.referrer);
      return {
        referrer: document.referrer,
        referrer_domain: A.host
      };
    }
    return { referrer: "$direct", referrer_domain: "$direct" };
  }
  getCompleteReferrerDataForTracking() {
    let A = this.getReferrerInfo(), t = this.getSessionInitialReferrerInfo();
    return {
      ...A,
      [Rr.REFERRER]: t.referrer,
      [Rr.REFERRER_DOMAIN]: t.referrer_domain
    };
  }
  getSearchInfo() {
    var t, r;
    return { ...{
      [Mr.SEARCH_ENGINE]: (t = this._searchInfo) == null ? void 0 : t.search_engine,
      [Mr.SEARCH_KEYWORD]: (r = this._searchInfo) == null ? void 0 : r.search_keyword
    } };
  }
}
const it = new Qo(), Zn = "1.1.2";
var ho = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Nr = { exports: {} };
(function(e, A) {
  (function(t, r) {
    var n = "1.0.37", i = "", s = "?", a = "function", o = "undefined", B = "object", l = "string", u = "major", c = "model", f = "name", g = "type", w = "vendor", Q = "version", d = "architecture", p = "console", E = "mobile", U = "tablet", m = "smarttv", C = "wearable", L = "embedded", T = 500, H = "Amazon", _ = "Apple", z = "ASUS", eA = "BlackBerry", K = "Browser", k = "Chrome", vA = "Edge", W = "Firefox", Y = "Google", mA = "Huawei", iA = "LG", uA = "Microsoft", IA = "Motorola", gA = "Opera", sA = "Samsung", HA = "Sharp", aA = "Sony", yA = "Xiaomi", OA = "Zebra", In = "Facebook", Hn = "Chromium OS", yn = "Mac OS", Ca = function(S, R) {
      var b = {};
      for (var G in S)
        R[G] && R[G].length % 2 === 0 ? b[G] = R[G].concat(S[G]) : b[G] = S[G];
      return b;
    }, $e = function(S) {
      for (var R = {}, b = 0; b < S.length; b++)
        R[S[b].toUpperCase()] = S[b];
      return R;
    }, bn = function(S, R) {
      return typeof S === l ? ve(R).indexOf(ve(S)) !== -1 : !1;
    }, ve = function(S) {
      return S.toLowerCase();
    }, Ua = function(S) {
      return typeof S === l ? S.replace(/[^\d\.]/g, i).split(".")[0] : r;
    }, ar = function(S, R) {
      if (typeof S === l)
        return S = S.replace(/^\s\s*/, i), typeof R === o ? S : S.substring(0, T);
    }, me = function(S, R) {
      for (var b = 0, G, PA, bA, D, y, LA; b < R.length && !y; ) {
        var Br = R[b], Kn = R[b + 1];
        for (G = PA = 0; G < Br.length && !y && Br[G]; )
          if (y = Br[G++].exec(S), y)
            for (bA = 0; bA < Kn.length; bA++)
              LA = y[++PA], D = Kn[bA], typeof D === B && D.length > 0 ? D.length === 2 ? typeof D[1] == a ? this[D[0]] = D[1].call(this, LA) : this[D[0]] = D[1] : D.length === 3 ? typeof D[1] === a && !(D[1].exec && D[1].test) ? this[D[0]] = LA ? D[1].call(this, LA, D[2]) : r : this[D[0]] = LA ? LA.replace(D[1], D[2]) : r : D.length === 4 && (this[D[0]] = LA ? D[3].call(this, LA.replace(D[1], D[2])) : r) : this[D] = LA || r;
        b += 2;
      }
    }, or = function(S, R) {
      for (var b in R)
        if (typeof R[b] === B && R[b].length > 0) {
          for (var G = 0; G < R[b].length; G++)
            if (bn(R[b][G], S))
              return b === s ? r : b;
        } else if (bn(R[b], S))
          return b === s ? r : b;
      return S;
    }, da = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, Ln = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, Tn = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [Q, [f, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [Q, [f, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [f, Q],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [Q, [f, gA + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [Q, [f, gA]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [Q, [f, "Baidu"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(heytap|ovi)browser\/([\d\.]+)/i,
          // Heytap/Ovi
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [f, Q],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [Q, [f, "UC" + K]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [Q, [f, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [Q, [f, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [Q, [f, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [Q, [f, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [Q, [f, "Smart Lenovo " + K]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[f, /(.+)/, "$1 Secure " + K], Q],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [Q, [f, W + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [Q, [f, gA + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [Q, [f, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [Q, [f, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [Q, [f, gA + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [Q, [f, "MIUI " + K]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [Q, [f, W]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[f, "360 " + K]],
        [
          /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
        ],
        [[f, /(.+)/, "$1 " + K], Q],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [Q, [f, sA + " Internet"]],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[f, /_/g, " "], Q],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [Q, [f, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[f, "Sogou Mobile"], Q],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/2345 Browser
        ],
        [f, Q],
        [
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [f],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[f, In], Q],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [f, Q],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [Q, [f, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [Q, [f, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [Q, [f, k + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[f, k + " WebView"], Q],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [Q, [f, "Android " + K]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [f, Q],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [Q, [f, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [Q, f],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [f, [Q, or, da]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [f, Q],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[f, "Netscape"], Q],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [Q, [f, W + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i,
          // Links
          /panasonic;(viera)/i
          // Panasonic Viera
        ],
        [f, Q],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [f, [Q, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[d, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[d, ve]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[d, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[d, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[d, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[d, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[d, /ower/, i, ve]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[d, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[d, ve]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [c, [w, sA], [g, U]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [c, [w, sA], [g, E]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [c, [w, _], [g, E]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [c, [w, _], [g, U]],
        [
          /(macintosh);/i
        ],
        [c, [w, _]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [c, [w, HA], [g, E]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [c, [w, mA], [g, U]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [c, [w, mA], [g, E]],
        [
          // Xiaomi
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[c, /_/g, " "], [w, yA], [g, E]],
        [
          /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
          // Redmi Pad
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[c, /_/g, " "], [w, yA], [g, U]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [c, [w, "OPPO"], [g, E]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [c, [w, "Vivo"], [g, E]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [c, [w, "Realme"], [g, E]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [c, [w, IA], [g, E]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [c, [w, IA], [g, U]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [c, [w, iA], [g, U]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [c, [w, iA], [g, E]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [c, [w, "Lenovo"], [g, U]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[c, /_/g, " "], [w, "Nokia"], [g, E]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [c, [w, Y], [g, U]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [c, [w, Y], [g, E]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [c, [w, aA], [g, E]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[c, "Xperia Tablet"], [w, aA], [g, U]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [c, [w, "OnePlus"], [g, E]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [c, [w, H], [g, U]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[c, /(.+)/g, "Fire Phone $1"], [w, H], [g, E]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [c, w, [g, U]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [c, [w, eA], [g, E]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [c, [w, z], [g, U]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [c, [w, z], [g, E]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [c, [w, "HTC"], [g, U]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [w, [c, /_/g, " "], [g, E]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [c, [w, "Acer"], [g, U]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [c, [w, "Meizu"], [g, E]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [c, [w, "Ulefone"], [g, E]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [w, c, [g, E]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [w, c, [g, U]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [c, [w, uA], [g, U]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [c, [w, "Fairphone"], [g, E]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [c, [w, "AT&T"], [g, E]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [c, [w, "Siemens"], [g, E]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [c, [w, "RCA"], [g, U]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [c, [w, "Dell"], [g, U]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [c, [w, "Verizon"], [g, U]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [c, [w, "Barnes & Noble"], [g, U]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [c, [w, "NuVision"], [g, U]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [c, [w, "ZTE"], [g, U]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [c, [w, "ZTE"], [g, E]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [c, [w, "Swiss"], [g, E]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [c, [w, "Swiss"], [g, U]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [c, [w, "Zeki"], [g, U]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[w, "Dragon Touch"], c, [g, U]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [c, [w, "Insignia"], [g, U]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [c, [w, "NextBook"], [g, U]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[w, "Voice"], c, [g, E]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[w, "LvTel"], c, [g, E]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [c, [w, "Essential"], [g, E]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [c, [w, "Envizen"], [g, U]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [c, [w, "MachSpeed"], [g, U]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [c, [w, "Rotor"], [g, U]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [c, [w, "Nvidia"], [g, U]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [w, c, [g, E]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[c, /\./g, " "], [w, uA], [g, E]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [c, [w, OA], [g, U]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [c, [w, OA], [g, E]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [w, [g, m]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[c, /^/, "SmartTV"], [w, sA], [g, m]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[w, iA], [g, m]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [w, [c, _ + " TV"], [g, m]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[c, k + "cast"], [w, Y], [g, m]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [c, [w, H], [g, m]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [c, [w, HA], [g, m]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [c, [w, aA], [g, m]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [c, [w, yA], [g, m]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [w, c, [g, m]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[w, ar], [c, ar], [g, m]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[g, m]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [w, c, [g, p]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [c, [w, "Nvidia"], [g, p]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [c, [w, aA], [g, p]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [c, [w, uA], [g, p]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [w, c, [g, C]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [c, [w, _], [g, C]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [c, [w, Y], [g, C]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [c, [w, OA], [g, C]],
        [
          /(quest( 2| pro)?)/i
          // Oculus Quest
        ],
        [c, [w, In], [g, C]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [w, [g, L]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [c, [w, H], [g, L]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [c, [g, E]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [c, [g, U]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[g, U]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[g, E]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [c, [w, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [Q, [f, vA + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [Q, [f, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [f, Q],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [Q, f]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [f, Q],
        [
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [f, [Q, or, Ln]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[Q, or, Ln], [f, "Windows"]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[Q, /_/g, "."], [f, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[f, yn], [Q, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [Q, f],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [f, Q],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [Q, [f, eA]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [Q, [f, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [Q, [f, W + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [Q, [f, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [Q, [f, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [Q, [f, k + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[f, Hn], Q],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [f, Q],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[f, "Solaris"], Q],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [f, Q]
      ]
    }, dA = function(S, R) {
      if (typeof S === B && (R = S, S = r), !(this instanceof dA))
        return new dA(S, R).getResult();
      var b = typeof t !== o && t.navigator ? t.navigator : r, G = S || (b && b.userAgent ? b.userAgent : i), PA = b && b.userAgentData ? b.userAgentData : r, bA = R ? Ca(Tn, R) : Tn, D = b && b.userAgent == G;
      return this.getBrowser = function() {
        var y = {};
        return y[f] = r, y[Q] = r, me.call(y, G, bA.browser), y[u] = Ua(y[Q]), D && b && b.brave && typeof b.brave.isBrave == a && (y[f] = "Brave"), y;
      }, this.getCPU = function() {
        var y = {};
        return y[d] = r, me.call(y, G, bA.cpu), y;
      }, this.getDevice = function() {
        var y = {};
        return y[w] = r, y[c] = r, y[g] = r, me.call(y, G, bA.device), D && !y[g] && PA && PA.mobile && (y[g] = E), D && y[c] == "Macintosh" && b && typeof b.standalone !== o && b.maxTouchPoints && b.maxTouchPoints > 2 && (y[c] = "iPad", y[g] = U), y;
      }, this.getEngine = function() {
        var y = {};
        return y[f] = r, y[Q] = r, me.call(y, G, bA.engine), y;
      }, this.getOS = function() {
        var y = {};
        return y[f] = r, y[Q] = r, me.call(y, G, bA.os), D && !y[f] && PA && PA.platform != "Unknown" && (y[f] = PA.platform.replace(/chrome os/i, Hn).replace(/macos/i, yn)), y;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return G;
      }, this.setUA = function(y) {
        return G = typeof y === l && y.length > T ? ar(y, T) : y, this;
      }, this.setUA(G), this;
    };
    dA.VERSION = n, dA.BROWSER = $e([f, Q, u]), dA.CPU = $e([d]), dA.DEVICE = $e([c, w, g, p, E, m, U, C, L]), dA.ENGINE = dA.OS = $e([f, Q]), e.exports && (A = e.exports = dA), A.UAParser = dA;
    var ae = typeof t !== o && (t.jQuery || t.Zepto);
    if (ae && !ae.ua) {
      var At = new dA();
      ae.ua = At.getResult(), ae.ua.get = function() {
        return At.getUA();
      }, ae.ua.set = function(S) {
        At.setUA(S);
        var R = At.getResult();
        for (var b in R)
          ae.ua[b] = R[b];
      };
    }
  })(typeof window == "object" ? window : ho);
})(Nr, Nr.exports);
var Co = Nr.exports;
class Uo {
  constructor() {
    h(this, "_deviceProps", {
      pi_sdk_type: "Web",
      pi_sdk_version: Zn
    });
  }
  init() {
    let A = {
      pi_sdk_type: "Web",
      pi_sdk_version: Zn,
      pi_client_height: document == null ? void 0 : document.body.clientHeight,
      pi_client_width: document == null ? void 0 : document.body.clientWidth,
      pi_screen_type: St()
    };
    if (navigator && navigator.userAgent) {
      let { ua: t, browser: r, device: n, os: i } = Co.UAParser();
      A.user_agent = (t == null ? void 0 : t.length) > 1e3 ? t.substring(0, 997) + "..." : t, r && (A.pi_browser = r.name, A.pi_browser_version = r.version), n && (A.pi_device_name = n.model, A.pi_device_manufacturer = n.vendor, A.pi_device_type = n.type), i && (A.pi_os = i.name, A.pi_os_version = i.version);
    }
    this._deviceProps = { ...A };
  }
  getDeviceProperties() {
    return { ...this._deviceProps };
  }
}
const qn = new Uo();
class Fo {
  constructor() {
    h(this, "token");
    h(this, "isExperimentEnabled", !1);
    h(this, "getUniqueId");
    h(this, "getUserId");
    h(this, "experimentFetchedCallback");
    h(this, "experimentRefetchIntervalMin");
    h(this, "isExperimentDataResolved", !1);
    h(this, "experimentData", null);
    h(this, "experimentUserType", null);
    h(this, "fetchExperimentPromise", null);
    h(this, "experimentRefetchTimer", null);
    h(this, "processTempEventQueue");
    h(this, "captureEvent");
  }
  init(A, t, r) {
    this.token = A, this.isExperimentEnabled = t.enableExperiment ?? !1, this.getUniqueId = r.getUniqueId, this.getUserId = r.getUserId, this.experimentFetchedCallback = t.experimentFetchedCb, this.experimentRefetchIntervalMin = t.experimentRefetchIntervalMin, this.processTempEventQueue = r.processTempEventQueue, this.captureEvent = r.captureEvent, this.experimentRefetchIntervalMin || (this.experimentRefetchIntervalMin = 5), this.initializeExperimentData(this.experimentRefetchIntervalMin);
  }
  async getExperiment(A) {
    return this.isExperimentEnabled ? (await this.waitForExperimentData(), this.experimentData && this.experimentData[A] ? this.experimentData[A] : null) : (I.warn(
      "[PI] Experiment Service: Experiments are not enabled. This call will be ignored"
    ), null);
  }
  async getAllActiveExperiments() {
    return this.isExperimentEnabled ? (await this.waitForExperimentData(), this.experimentData ? Object.values(this.experimentData) : []) : (I.warn(
      "[PI] Experiment Service: Experiments are not enabled. This call will be ignored"
    ), []);
  }
  async getExperimentUserType() {
    return this.isExperimentEnabled ? (await this.waitForExperimentData(), this.experimentUserType) : (I.warn(
      "[PI] Experiment Service: Experiments are not enabled. This call will be ignored"
    ), null);
  }
  getIsExperimentDataResolved() {
    return this.isExperimentDataResolved;
  }
  clearRefetchTimer() {
    this.experimentRefetchTimer && (clearInterval(this.experimentRefetchTimer), this.experimentRefetchTimer = null);
  }
  getExperimentProperties() {
    const A = {};
    if (this.experimentData) {
      const t = Object.keys(this.experimentData);
      A.pi_active_experiments = t, t.forEach((r) => {
        const n = this.experimentData[r];
        A[`pi_exp_${r}_var`] = n.variantName;
      });
    }
    return A;
  }
  async waitForExperimentData() {
    !this.isExperimentDataResolved && this.fetchExperimentPromise ? await this.fetchExperimentPromise : this.isExperimentDataResolved || await this.fetchExperimentData();
  }
  async initializeExperimentData(A) {
    var r, n;
    const t = this.getStaleExperimentData(60);
    t && (this.updateExperimentData(t), (r = this.processTempEventQueue) == null || r.call(this)), await this.fetchExperimentData(), (n = this.captureEvent) == null || n.call(this, pA.EXPERIMENT_FECTH, {}), this.setupExperimentRefetch(A);
  }
  async fetchExperimentData() {
    return this.fetchExperimentPromise = this.fetchExperimentDataFromAPI(), this.fetchExperimentPromise.then((A) => {
      A && this.updateExperimentData(A);
    }).catch((A) => {
      I.warn(
        "[PI] Experiment Service: Fetching experiment data failed.",
        A
      );
    }).finally(() => {
      var A;
      (A = this.processTempEventQueue) == null || A.call(this), this.fetchExperimentPromise = null;
    }), this.fetchExperimentPromise;
  }
  async fetchExperimentDataFromAPI() {
    if (!this.getUniqueId())
      return I.warn(
        "[PI] Experiment Service: No unique ID available, experiment data will be empty."
      ), this.getDefaultExperimentInfo();
    try {
      const r = await this.fetchExperimentRequest();
      if (r)
        return this.setStaleExperimentInfo(r), r;
    } catch (r) {
      I.error(
        `[PI] Experiment Service: Failed to fetch experiment data: ${r}`
      );
    }
    return this.getStaleExperimentData() ?? this.getDefaultExperimentInfo();
  }
  async fetchExperimentRequest() {
    const A = this.getUniqueId(), t = this.getUserId();
    if (!A || !this.token)
      return I.warn(
        "[PI] Experiment Service: Missing unique ID or token, experiment data will be empty."
      ), null;
    try {
      const r = await fetch(
        `${$i}/experiment/client/`,
        {
          signal: AbortSignal.timeout(Ta),
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, max-age=0, must-revalidate",
            Pragma: "no-cache",
            Expires: "Mon, 01 Jan 1990 00:00:00 GMT"
          },
          body: JSON.stringify({
            token: this.token,
            userId: t || null,
            uniqueId: A
          })
        }
      );
      if (!r.ok)
        throw new Error("[PI] Experiment Service: Failed to send data");
      const n = await r.json(), i = n.experiments.reduce(
        (s, a) => (s[a.experimentName] = a, s),
        {}
      );
      return {
        experimentUserType: n.userType,
        experimentData: i,
        timestamp: Date.now()
      };
    } catch (r) {
      return I.error("[PI] Experiment Service: ", r), null;
    }
  }
  updateExperimentData(A) {
    var t;
    this.experimentData = A.experimentData, this.experimentUserType = A.experimentUserType, this.isExperimentDataResolved = !0, (t = this.experimentFetchedCallback) == null || t.call(this, {
      experimentData: this.experimentData,
      experimentUserType: this.experimentUserType,
      isExperimentDataResolved: this.isExperimentDataResolved
    });
  }
  getDefaultExperimentInfo() {
    return {
      experimentData: {},
      experimentUserType: null,
      timestamp: Date.now()
    };
  }
  setupExperimentRefetch(A) {
    A < 5 && (I.warn(
      "[PI] Experiment Service: Refetch interval is less than 5 minutes. Setting it to 5 minutes."
    ), A = 5), this.clearRefetchTimer();
    const t = A * 60 * 1e3;
    this.experimentRefetchTimer = setInterval(
      () => this.refetchExperiment(),
      t
    );
  }
  async refetchExperiment() {
    var A;
    try {
      await this.fetchExperimentData(), (A = this.captureEvent) == null || A.call(this, pA.EXPERIMENT_FECTH, {});
    } catch {
      I.warn(
        "[PI] Experiment Service: Refetching experiment data timed out."
      );
    }
  }
  setStaleExperimentInfo(A) {
    oA.setItem(
      cA.EXPERIMENT_DATA_KEY,
      JSON.stringify(A)
    );
  }
  getStaleExperimentData(A) {
    const t = oA.getItem(
      cA.EXPERIMENT_DATA_KEY
    );
    if (!t)
      return null;
    const r = JSON.parse(
      t
    );
    if (A) {
      const n = A * 60 * 1e3;
      if (Date.now() - r.timestamp > n)
        return null;
    }
    return r;
  }
}
const TA = new Fo();
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Pr = function(e, A) {
  return Pr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }, Pr(e, A);
};
function EA(e, A) {
  if (typeof A != "function" && A !== null)
    throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
  Pr(e, A);
  function t() {
    this.constructor = e;
  }
  e.prototype = A === null ? Object.create(A) : (t.prototype = A.prototype, new t());
}
var kr = function() {
  return kr = Object.assign || function(A) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (A[i] = t[i]);
    }
    return A;
  }, kr.apply(this, arguments);
};
function nA(e, A, t, r) {
  function n(i) {
    return i instanceof t ? i : new t(function(s) {
      s(i);
    });
  }
  return new (t || (t = Promise))(function(i, s) {
    function a(l) {
      try {
        B(r.next(l));
      } catch (u) {
        s(u);
      }
    }
    function o(l) {
      try {
        B(r.throw(l));
      } catch (u) {
        s(u);
      }
    }
    function B(l) {
      l.done ? i(l.value) : n(l.value).then(a, o);
    }
    B((r = r.apply(e, A || [])).next());
  });
}
function tA(e, A) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, n, i, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(B) {
    return function(l) {
      return o([B, l]);
    };
  }
  function o(B) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (r = 1, n && (i = B[0] & 2 ? n.return : B[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, B[1])).done)
          return i;
        switch (n = 0, i && (B = [B[0] & 2, i.value]), B[0]) {
          case 0:
          case 1:
            i = B;
            break;
          case 4:
            return t.label++, { value: B[1], done: !1 };
          case 5:
            t.label++, n = B[1], B = [0];
            continue;
          case 7:
            B = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (B[0] === 6 || B[0] === 2)) {
              t = 0;
              continue;
            }
            if (B[0] === 3 && (!i || B[1] > i[0] && B[1] < i[3])) {
              t.label = B[1];
              break;
            }
            if (B[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = B;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(B);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        B = A.call(e, t);
      } catch (l) {
        B = [6, l], n = 0;
      } finally {
        r = i = 0;
      }
    if (B[0] & 5)
      throw B[1];
    return { value: B[0] ? B[1] : void 0, done: !0 };
  }
}
function st(e, A, t) {
  if (t || arguments.length === 2)
    for (var r = 0, n = A.length, i; r < n; r++)
      (i || !(r in A)) && (i || (i = Array.prototype.slice.call(A, 0, r)), i[r] = A[r]);
  return e.concat(i || A);
}
var NA = (
  /** @class */
  function() {
    function e(A, t, r, n) {
      this.left = A, this.top = t, this.width = r, this.height = n;
    }
    return e.prototype.add = function(A, t, r, n) {
      return new e(this.left + A, this.top + t, this.width + r, this.height + n);
    }, e.fromClientRect = function(A, t) {
      return new e(t.left + A.windowBounds.left, t.top + A.windowBounds.top, t.width, t.height);
    }, e.fromDOMRectList = function(A, t) {
      var r = Array.from(t).find(function(n) {
        return n.width !== 0;
      });
      return r ? new e(r.left + A.windowBounds.left, r.top + A.windowBounds.top, r.width, r.height) : e.EMPTY;
    }, e.EMPTY = new e(0, 0, 0, 0), e;
  }()
), zt = function(e, A) {
  return NA.fromClientRect(e, A.getBoundingClientRect());
}, po = function(e) {
  var A = e.body, t = e.documentElement;
  if (!A || !t)
    throw new Error("Unable to get document size");
  var r = Math.max(Math.max(A.scrollWidth, t.scrollWidth), Math.max(A.offsetWidth, t.offsetWidth), Math.max(A.clientWidth, t.clientWidth)), n = Math.max(Math.max(A.scrollHeight, t.scrollHeight), Math.max(A.offsetHeight, t.offsetHeight), Math.max(A.clientHeight, t.clientHeight));
  return new NA(0, 0, r, n);
}, jt = function(e) {
  for (var A = [], t = 0, r = e.length; t < r; ) {
    var n = e.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < r) {
      var i = e.charCodeAt(t++);
      (i & 64512) === 56320 ? A.push(((n & 1023) << 10) + (i & 1023) + 65536) : (A.push(n), t--);
    } else
      A.push(n);
  }
  return A;
}, X = function() {
  for (var e = [], A = 0; A < arguments.length; A++)
    e[A] = arguments[A];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, e);
  var t = e.length;
  if (!t)
    return "";
  for (var r = [], n = -1, i = ""; ++n < t; ) {
    var s = e[n];
    s <= 65535 ? r.push(s) : (s -= 65536, r.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === t || r.length > 16384) && (i += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return i;
}, zn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Eo = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var at = 0; at < zn.length; at++)
  Eo[zn.charCodeAt(at)] = at;
var jn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Ke = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var ot = 0; ot < jn.length; ot++)
  Ke[jn.charCodeAt(ot)] = ot;
var vo = function(e) {
  var A = e.length * 0.75, t = e.length, r, n = 0, i, s, a, o;
  e[e.length - 1] === "=" && (A--, e[e.length - 2] === "=" && A--);
  var B = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), l = Array.isArray(B) ? B : new Uint8Array(B);
  for (r = 0; r < t; r += 4)
    i = Ke[e.charCodeAt(r)], s = Ke[e.charCodeAt(r + 1)], a = Ke[e.charCodeAt(r + 2)], o = Ke[e.charCodeAt(r + 3)], l[n++] = i << 2 | s >> 4, l[n++] = (s & 15) << 4 | a >> 2, l[n++] = (a & 3) << 6 | o & 63;
  return B;
}, mo = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 2)
    t.push(e[r + 1] << 8 | e[r]);
  return t;
}, Io = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 4)
    t.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
  return t;
}, ne = 5, Un = 6 + 5, wr = 2, Ho = Un - ne, ws = 65536 >> ne, yo = 1 << ne, fr = yo - 1, bo = 1024 >> ne, Lo = ws + bo, To = Lo, Ko = 32, xo = To + Ko, So = 65536 >> Un, Do = 1 << Ho, Oo = Do - 1, $n = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint16Array(Array.prototype.slice.call(e, A, t));
}, Ro = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint32Array(Array.prototype.slice.call(e, A, t));
}, Mo = function(e, A) {
  var t = vo(e), r = Array.isArray(t) ? Io(t) : new Uint32Array(t), n = Array.isArray(t) ? mo(t) : new Uint16Array(t), i = 24, s = $n(n, i / 2, r[4] / 2), a = r[5] === 2 ? $n(n, (i + r[4]) / 2) : Ro(r, Math.ceil((i + r[4]) / 4));
  return new _o(r[0], r[1], r[2], r[3], s, a);
}, _o = (
  /** @class */
  function() {
    function e(A, t, r, n, i, s) {
      this.initialValue = A, this.errorValue = t, this.highStart = r, this.highValueIndex = n, this.index = i, this.data = s;
    }
    return e.prototype.get = function(A) {
      var t;
      if (A >= 0) {
        if (A < 55296 || A > 56319 && A <= 65535)
          return t = this.index[A >> ne], t = (t << wr) + (A & fr), this.data[t];
        if (A <= 65535)
          return t = this.index[ws + (A - 55296 >> ne)], t = (t << wr) + (A & fr), this.data[t];
        if (A < this.highStart)
          return t = xo - So + (A >> Un), t = this.index[t], t += A >> ne & Oo, t = this.index[t], t = (t << wr) + (A & fr), this.data[t];
        if (A <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, e;
  }()
), Ai = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Go = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Bt = 0; Bt < Ai.length; Bt++)
  Go[Ai.charCodeAt(Bt)] = Bt;
var No = "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", ei = 50, Po = 1, fs = 2, Qs = 3, ko = 4, Vo = 5, ti = 7, hs = 8, ri = 9, ZA = 10, Vr = 11, ni = 12, Xr = 13, Xo = 14, xe = 15, Jr = 16, ct = 17, He = 18, Jo = 19, ii = 20, Wr = 21, ye = 22, Qr = 23, Be = 24, lA = 25, Se = 26, De = 27, ce = 28, Wo = 29, te = 30, Yo = 31, lt = 32, ut = 33, Yr = 34, Zr = 35, qr = 36, We = 37, zr = 38, Lt = 39, Tt = 40, hr = 41, Cs = 42, Zo = 43, qo = [9001, 65288], Us = "!", x = "×", gt = "÷", jr = Mo(No), RA = [te, qr], $r = [Po, fs, Qs, Vo], ds = [ZA, hs], si = [De, Se], zo = $r.concat(ds), ai = [zr, Lt, Tt, Yr, Zr], jo = [xe, Xr], $o = function(e, A) {
  A === void 0 && (A = "strict");
  var t = [], r = [], n = [];
  return e.forEach(function(i, s) {
    var a = jr.get(i);
    if (a > ei ? (n.push(!0), a -= ei) : n.push(!1), ["normal", "auto", "loose"].indexOf(A) !== -1 && [8208, 8211, 12316, 12448].indexOf(i) !== -1)
      return r.push(s), t.push(Jr);
    if (a === ko || a === Vr) {
      if (s === 0)
        return r.push(s), t.push(te);
      var o = t[s - 1];
      return zo.indexOf(o) === -1 ? (r.push(r[s - 1]), t.push(o)) : (r.push(s), t.push(te));
    }
    if (r.push(s), a === Yo)
      return t.push(A === "strict" ? Wr : We);
    if (a === Cs || a === Wo)
      return t.push(te);
    if (a === Zo)
      return i >= 131072 && i <= 196605 || i >= 196608 && i <= 262141 ? t.push(We) : t.push(te);
    t.push(a);
  }), [r, t, n];
}, Cr = function(e, A, t, r) {
  var n = r[t];
  if (Array.isArray(e) ? e.indexOf(n) !== -1 : e === n)
    for (var i = t; i <= r.length; ) {
      i++;
      var s = r[i];
      if (s === A)
        return !0;
      if (s !== ZA)
        break;
    }
  if (n === ZA)
    for (var i = t; i > 0; ) {
      i--;
      var a = r[i];
      if (Array.isArray(e) ? e.indexOf(a) !== -1 : e === a)
        for (var o = t; o <= r.length; ) {
          o++;
          var s = r[o];
          if (s === A)
            return !0;
          if (s !== ZA)
            break;
        }
      if (a !== ZA)
        break;
    }
  return !1;
}, oi = function(e, A) {
  for (var t = e; t >= 0; ) {
    var r = A[t];
    if (r === ZA)
      t--;
    else
      return r;
  }
  return 0;
}, AB = function(e, A, t, r, n) {
  if (t[r] === 0)
    return x;
  var i = r - 1;
  if (Array.isArray(n) && n[i] === !0)
    return x;
  var s = i - 1, a = i + 1, o = A[i], B = s >= 0 ? A[s] : 0, l = A[a];
  if (o === fs && l === Qs)
    return x;
  if ($r.indexOf(o) !== -1)
    return Us;
  if ($r.indexOf(l) !== -1 || ds.indexOf(l) !== -1)
    return x;
  if (oi(i, A) === hs)
    return gt;
  if (jr.get(e[i]) === Vr || (o === lt || o === ut) && jr.get(e[a]) === Vr || o === ti || l === ti || o === ri || [ZA, Xr, xe].indexOf(o) === -1 && l === ri || [ct, He, Jo, Be, ce].indexOf(l) !== -1 || oi(i, A) === ye || Cr(Qr, ye, i, A) || Cr([ct, He], Wr, i, A) || Cr(ni, ni, i, A))
    return x;
  if (o === ZA)
    return gt;
  if (o === Qr || l === Qr)
    return x;
  if (l === Jr || o === Jr)
    return gt;
  if ([Xr, xe, Wr].indexOf(l) !== -1 || o === Xo || B === qr && jo.indexOf(o) !== -1 || o === ce && l === qr || l === ii || RA.indexOf(l) !== -1 && o === lA || RA.indexOf(o) !== -1 && l === lA || o === De && [We, lt, ut].indexOf(l) !== -1 || [We, lt, ut].indexOf(o) !== -1 && l === Se || RA.indexOf(o) !== -1 && si.indexOf(l) !== -1 || si.indexOf(o) !== -1 && RA.indexOf(l) !== -1 || // (PR | PO) × ( OP | HY )? NU
  [De, Se].indexOf(o) !== -1 && (l === lA || [ye, xe].indexOf(l) !== -1 && A[a + 1] === lA) || // ( OP | HY ) × NU
  [ye, xe].indexOf(o) !== -1 && l === lA || // NU ×	(NU | SY | IS)
  o === lA && [lA, ce, Be].indexOf(l) !== -1)
    return x;
  if ([lA, ce, Be, ct, He].indexOf(l) !== -1)
    for (var u = i; u >= 0; ) {
      var c = A[u];
      if (c === lA)
        return x;
      if ([ce, Be].indexOf(c) !== -1)
        u--;
      else
        break;
    }
  if ([De, Se].indexOf(l) !== -1)
    for (var u = [ct, He].indexOf(o) !== -1 ? s : i; u >= 0; ) {
      var c = A[u];
      if (c === lA)
        return x;
      if ([ce, Be].indexOf(c) !== -1)
        u--;
      else
        break;
    }
  if (zr === o && [zr, Lt, Yr, Zr].indexOf(l) !== -1 || [Lt, Yr].indexOf(o) !== -1 && [Lt, Tt].indexOf(l) !== -1 || [Tt, Zr].indexOf(o) !== -1 && l === Tt || ai.indexOf(o) !== -1 && [ii, Se].indexOf(l) !== -1 || ai.indexOf(l) !== -1 && o === De || RA.indexOf(o) !== -1 && RA.indexOf(l) !== -1 || o === Be && RA.indexOf(l) !== -1 || RA.concat(lA).indexOf(o) !== -1 && l === ye && qo.indexOf(e[a]) === -1 || RA.concat(lA).indexOf(l) !== -1 && o === He)
    return x;
  if (o === hr && l === hr) {
    for (var f = t[i], g = 1; f > 0 && (f--, A[f] === hr); )
      g++;
    if (g % 2 !== 0)
      return x;
  }
  return o === lt && l === ut ? x : gt;
}, eB = function(e, A) {
  A || (A = { lineBreak: "normal", wordBreak: "normal" });
  var t = $o(e, A.lineBreak), r = t[0], n = t[1], i = t[2];
  (A.wordBreak === "break-all" || A.wordBreak === "break-word") && (n = n.map(function(a) {
    return [lA, te, Cs].indexOf(a) !== -1 ? We : a;
  }));
  var s = A.wordBreak === "keep-all" ? i.map(function(a, o) {
    return a && e[o] >= 19968 && e[o] <= 40959;
  }) : void 0;
  return [r, n, s];
}, tB = (
  /** @class */
  function() {
    function e(A, t, r, n) {
      this.codePoints = A, this.required = t === Us, this.start = r, this.end = n;
    }
    return e.prototype.slice = function() {
      return X.apply(void 0, this.codePoints.slice(this.start, this.end));
    }, e;
  }()
), rB = function(e, A) {
  var t = jt(e), r = eB(t, A), n = r[0], i = r[1], s = r[2], a = t.length, o = 0, B = 0;
  return {
    next: function() {
      if (B >= a)
        return { done: !0, value: null };
      for (var l = x; B < a && (l = AB(t, i, n, ++B, s)) === x; )
        ;
      if (l !== x || B === a) {
        var u = new tB(t, l, o, B);
        return o = B, { value: u, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, nB = 1, iB = 2, ze = 4, Bi = 8, Rt = 10, ci = 47, Ge = 92, sB = 9, aB = 32, wt = 34, be = 61, oB = 35, BB = 36, cB = 37, ft = 39, Qt = 40, Le = 41, lB = 95, BA = 45, uB = 33, gB = 60, wB = 62, fB = 64, QB = 91, hB = 93, CB = 61, UB = 123, ht = 63, dB = 125, li = 124, FB = 126, pB = 128, ui = 65533, Ur = 42, re = 43, EB = 44, vB = 58, mB = 59, Ye = 46, IB = 0, HB = 8, yB = 11, bB = 14, LB = 31, TB = 127, KA = -1, Fs = 48, ps = 97, Es = 101, KB = 102, xB = 117, SB = 122, vs = 65, ms = 69, Is = 70, DB = 85, OB = 90, rA = function(e) {
  return e >= Fs && e <= 57;
}, RB = function(e) {
  return e >= 55296 && e <= 57343;
}, le = function(e) {
  return rA(e) || e >= vs && e <= Is || e >= ps && e <= KB;
}, MB = function(e) {
  return e >= ps && e <= SB;
}, _B = function(e) {
  return e >= vs && e <= OB;
}, GB = function(e) {
  return MB(e) || _B(e);
}, NB = function(e) {
  return e >= pB;
}, Ct = function(e) {
  return e === Rt || e === sB || e === aB;
}, Mt = function(e) {
  return GB(e) || NB(e) || e === lB;
}, gi = function(e) {
  return Mt(e) || rA(e) || e === BA;
}, PB = function(e) {
  return e >= IB && e <= HB || e === yB || e >= bB && e <= LB || e === TB;
}, WA = function(e, A) {
  return e !== Ge ? !1 : A !== Rt;
}, Ut = function(e, A, t) {
  return e === BA ? Mt(A) || WA(A, t) : Mt(e) ? !0 : !!(e === Ge && WA(e, A));
}, dr = function(e, A, t) {
  return e === re || e === BA ? rA(A) ? !0 : A === Ye && rA(t) : rA(e === Ye ? A : e);
}, kB = function(e) {
  var A = 0, t = 1;
  (e[A] === re || e[A] === BA) && (e[A] === BA && (t = -1), A++);
  for (var r = []; rA(e[A]); )
    r.push(e[A++]);
  var n = r.length ? parseInt(X.apply(void 0, r), 10) : 0;
  e[A] === Ye && A++;
  for (var i = []; rA(e[A]); )
    i.push(e[A++]);
  var s = i.length, a = s ? parseInt(X.apply(void 0, i), 10) : 0;
  (e[A] === ms || e[A] === Es) && A++;
  var o = 1;
  (e[A] === re || e[A] === BA) && (e[A] === BA && (o = -1), A++);
  for (var B = []; rA(e[A]); )
    B.push(e[A++]);
  var l = B.length ? parseInt(X.apply(void 0, B), 10) : 0;
  return t * (n + a * Math.pow(10, -s)) * Math.pow(10, o * l);
}, VB = {
  type: 2
  /* LEFT_PARENTHESIS_TOKEN */
}, XB = {
  type: 3
  /* RIGHT_PARENTHESIS_TOKEN */
}, JB = {
  type: 4
  /* COMMA_TOKEN */
}, WB = {
  type: 13
  /* SUFFIX_MATCH_TOKEN */
}, YB = {
  type: 8
  /* PREFIX_MATCH_TOKEN */
}, ZB = {
  type: 21
  /* COLUMN_TOKEN */
}, qB = {
  type: 9
  /* DASH_MATCH_TOKEN */
}, zB = {
  type: 10
  /* INCLUDE_MATCH_TOKEN */
}, jB = {
  type: 11
  /* LEFT_CURLY_BRACKET_TOKEN */
}, $B = {
  type: 12
  /* RIGHT_CURLY_BRACKET_TOKEN */
}, Ac = {
  type: 14
  /* SUBSTRING_MATCH_TOKEN */
}, dt = {
  type: 23
  /* BAD_URL_TOKEN */
}, ec = {
  type: 1
  /* BAD_STRING_TOKEN */
}, tc = {
  type: 25
  /* CDO_TOKEN */
}, rc = {
  type: 24
  /* CDC_TOKEN */
}, nc = {
  type: 26
  /* COLON_TOKEN */
}, ic = {
  type: 27
  /* SEMICOLON_TOKEN */
}, sc = {
  type: 28
  /* LEFT_SQUARE_BRACKET_TOKEN */
}, ac = {
  type: 29
  /* RIGHT_SQUARE_BRACKET_TOKEN */
}, oc = {
  type: 31
  /* WHITESPACE_TOKEN */
}, An = {
  type: 32
  /* EOF_TOKEN */
}, Hs = (
  /** @class */
  function() {
    function e() {
      this._value = [];
    }
    return e.prototype.write = function(A) {
      this._value = this._value.concat(jt(A));
    }, e.prototype.read = function() {
      for (var A = [], t = this.consumeToken(); t !== An; )
        A.push(t), t = this.consumeToken();
      return A;
    }, e.prototype.consumeToken = function() {
      var A = this.consumeCodePoint();
      switch (A) {
        case wt:
          return this.consumeStringToken(wt);
        case oB:
          var t = this.peekCodePoint(0), r = this.peekCodePoint(1), n = this.peekCodePoint(2);
          if (gi(t) || WA(r, n)) {
            var i = Ut(t, r, n) ? iB : nB, s = this.consumeName();
            return { type: 5, value: s, flags: i };
          }
          break;
        case BB:
          if (this.peekCodePoint(0) === be)
            return this.consumeCodePoint(), WB;
          break;
        case ft:
          return this.consumeStringToken(ft);
        case Qt:
          return VB;
        case Le:
          return XB;
        case Ur:
          if (this.peekCodePoint(0) === be)
            return this.consumeCodePoint(), Ac;
          break;
        case re:
          if (dr(A, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case EB:
          return JB;
        case BA:
          var a = A, o = this.peekCodePoint(0), B = this.peekCodePoint(1);
          if (dr(a, o, B))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          if (Ut(a, o, B))
            return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          if (o === BA && B === wB)
            return this.consumeCodePoint(), this.consumeCodePoint(), rc;
          break;
        case Ye:
          if (dr(A, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case ci:
          if (this.peekCodePoint(0) === Ur)
            for (this.consumeCodePoint(); ; ) {
              var l = this.consumeCodePoint();
              if (l === Ur && (l = this.consumeCodePoint(), l === ci))
                return this.consumeToken();
              if (l === KA)
                return this.consumeToken();
            }
          break;
        case vB:
          return nc;
        case mB:
          return ic;
        case gB:
          if (this.peekCodePoint(0) === uB && this.peekCodePoint(1) === BA && this.peekCodePoint(2) === BA)
            return this.consumeCodePoint(), this.consumeCodePoint(), tc;
          break;
        case fB:
          var u = this.peekCodePoint(0), c = this.peekCodePoint(1), f = this.peekCodePoint(2);
          if (Ut(u, c, f)) {
            var s = this.consumeName();
            return { type: 7, value: s };
          }
          break;
        case QB:
          return sc;
        case Ge:
          if (WA(A, this.peekCodePoint(0)))
            return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          break;
        case hB:
          return ac;
        case CB:
          if (this.peekCodePoint(0) === be)
            return this.consumeCodePoint(), YB;
          break;
        case UB:
          return jB;
        case dB:
          return $B;
        case xB:
        case DB:
          var g = this.peekCodePoint(0), w = this.peekCodePoint(1);
          return g === re && (le(w) || w === ht) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
        case li:
          if (this.peekCodePoint(0) === be)
            return this.consumeCodePoint(), qB;
          if (this.peekCodePoint(0) === li)
            return this.consumeCodePoint(), ZB;
          break;
        case FB:
          if (this.peekCodePoint(0) === be)
            return this.consumeCodePoint(), zB;
          break;
        case KA:
          return An;
      }
      return Ct(A) ? (this.consumeWhiteSpace(), oc) : rA(A) ? (this.reconsumeCodePoint(A), this.consumeNumericToken()) : Mt(A) ? (this.reconsumeCodePoint(A), this.consumeIdentLikeToken()) : { type: 6, value: X(A) };
    }, e.prototype.consumeCodePoint = function() {
      var A = this._value.shift();
      return typeof A > "u" ? -1 : A;
    }, e.prototype.reconsumeCodePoint = function(A) {
      this._value.unshift(A);
    }, e.prototype.peekCodePoint = function(A) {
      return A >= this._value.length ? -1 : this._value[A];
    }, e.prototype.consumeUnicodeRangeToken = function() {
      for (var A = [], t = this.consumeCodePoint(); le(t) && A.length < 6; )
        A.push(t), t = this.consumeCodePoint();
      for (var r = !1; t === ht && A.length < 6; )
        A.push(t), t = this.consumeCodePoint(), r = !0;
      if (r) {
        var n = parseInt(X.apply(void 0, A.map(function(o) {
          return o === ht ? Fs : o;
        })), 16), i = parseInt(X.apply(void 0, A.map(function(o) {
          return o === ht ? Is : o;
        })), 16);
        return { type: 30, start: n, end: i };
      }
      var s = parseInt(X.apply(void 0, A), 16);
      if (this.peekCodePoint(0) === BA && le(this.peekCodePoint(1))) {
        this.consumeCodePoint(), t = this.consumeCodePoint();
        for (var a = []; le(t) && a.length < 6; )
          a.push(t), t = this.consumeCodePoint();
        var i = parseInt(X.apply(void 0, a), 16);
        return { type: 30, start: s, end: i };
      } else
        return { type: 30, start: s, end: s };
    }, e.prototype.consumeIdentLikeToken = function() {
      var A = this.consumeName();
      return A.toLowerCase() === "url" && this.peekCodePoint(0) === Qt ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === Qt ? (this.consumeCodePoint(), { type: 19, value: A }) : { type: 20, value: A };
    }, e.prototype.consumeUrlToken = function() {
      var A = [];
      if (this.consumeWhiteSpace(), this.peekCodePoint(0) === KA)
        return { type: 22, value: "" };
      var t = this.peekCodePoint(0);
      if (t === ft || t === wt) {
        var r = this.consumeStringToken(this.consumeCodePoint());
        return r.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === KA || this.peekCodePoint(0) === Le) ? (this.consumeCodePoint(), { type: 22, value: r.value }) : (this.consumeBadUrlRemnants(), dt);
      }
      for (; ; ) {
        var n = this.consumeCodePoint();
        if (n === KA || n === Le)
          return { type: 22, value: X.apply(void 0, A) };
        if (Ct(n))
          return this.consumeWhiteSpace(), this.peekCodePoint(0) === KA || this.peekCodePoint(0) === Le ? (this.consumeCodePoint(), { type: 22, value: X.apply(void 0, A) }) : (this.consumeBadUrlRemnants(), dt);
        if (n === wt || n === ft || n === Qt || PB(n))
          return this.consumeBadUrlRemnants(), dt;
        if (n === Ge)
          if (WA(n, this.peekCodePoint(0)))
            A.push(this.consumeEscapedCodePoint());
          else
            return this.consumeBadUrlRemnants(), dt;
        else
          A.push(n);
      }
    }, e.prototype.consumeWhiteSpace = function() {
      for (; Ct(this.peekCodePoint(0)); )
        this.consumeCodePoint();
    }, e.prototype.consumeBadUrlRemnants = function() {
      for (; ; ) {
        var A = this.consumeCodePoint();
        if (A === Le || A === KA)
          return;
        WA(A, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
      }
    }, e.prototype.consumeStringSlice = function(A) {
      for (var t = 5e4, r = ""; A > 0; ) {
        var n = Math.min(t, A);
        r += X.apply(void 0, this._value.splice(0, n)), A -= n;
      }
      return this._value.shift(), r;
    }, e.prototype.consumeStringToken = function(A) {
      var t = "", r = 0;
      do {
        var n = this._value[r];
        if (n === KA || n === void 0 || n === A)
          return t += this.consumeStringSlice(r), { type: 0, value: t };
        if (n === Rt)
          return this._value.splice(0, r), ec;
        if (n === Ge) {
          var i = this._value[r + 1];
          i !== KA && i !== void 0 && (i === Rt ? (t += this.consumeStringSlice(r), r = -1, this._value.shift()) : WA(n, i) && (t += this.consumeStringSlice(r), t += X(this.consumeEscapedCodePoint()), r = -1));
        }
        r++;
      } while (!0);
    }, e.prototype.consumeNumber = function() {
      var A = [], t = ze, r = this.peekCodePoint(0);
      for ((r === re || r === BA) && A.push(this.consumeCodePoint()); rA(this.peekCodePoint(0)); )
        A.push(this.consumeCodePoint());
      r = this.peekCodePoint(0);
      var n = this.peekCodePoint(1);
      if (r === Ye && rA(n))
        for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), t = Bi; rA(this.peekCodePoint(0)); )
          A.push(this.consumeCodePoint());
      r = this.peekCodePoint(0), n = this.peekCodePoint(1);
      var i = this.peekCodePoint(2);
      if ((r === ms || r === Es) && ((n === re || n === BA) && rA(i) || rA(n)))
        for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), t = Bi; rA(this.peekCodePoint(0)); )
          A.push(this.consumeCodePoint());
      return [kB(A), t];
    }, e.prototype.consumeNumericToken = function() {
      var A = this.consumeNumber(), t = A[0], r = A[1], n = this.peekCodePoint(0), i = this.peekCodePoint(1), s = this.peekCodePoint(2);
      if (Ut(n, i, s)) {
        var a = this.consumeName();
        return { type: 15, number: t, flags: r, unit: a };
      }
      return n === cB ? (this.consumeCodePoint(), { type: 16, number: t, flags: r }) : { type: 17, number: t, flags: r };
    }, e.prototype.consumeEscapedCodePoint = function() {
      var A = this.consumeCodePoint();
      if (le(A)) {
        for (var t = X(A); le(this.peekCodePoint(0)) && t.length < 6; )
          t += X(this.consumeCodePoint());
        Ct(this.peekCodePoint(0)) && this.consumeCodePoint();
        var r = parseInt(t, 16);
        return r === 0 || RB(r) || r > 1114111 ? ui : r;
      }
      return A === KA ? ui : A;
    }, e.prototype.consumeName = function() {
      for (var A = ""; ; ) {
        var t = this.consumeCodePoint();
        if (gi(t))
          A += X(t);
        else if (WA(t, this.peekCodePoint(0)))
          A += X(this.consumeEscapedCodePoint());
        else
          return this.reconsumeCodePoint(t), A;
      }
    }, e;
  }()
), ys = (
  /** @class */
  function() {
    function e(A) {
      this._tokens = A;
    }
    return e.create = function(A) {
      var t = new Hs();
      return t.write(A), new e(t.read());
    }, e.parseValue = function(A) {
      return e.create(A).parseComponentValue();
    }, e.parseValues = function(A) {
      return e.create(A).parseComponentValues();
    }, e.prototype.parseComponentValue = function() {
      for (var A = this.consumeToken(); A.type === 31; )
        A = this.consumeToken();
      if (A.type === 32)
        throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
      this.reconsumeToken(A);
      var t = this.consumeComponentValue();
      do
        A = this.consumeToken();
      while (A.type === 31);
      if (A.type === 32)
        return t;
      throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
    }, e.prototype.parseComponentValues = function() {
      for (var A = []; ; ) {
        var t = this.consumeComponentValue();
        if (t.type === 32)
          return A;
        A.push(t), A.push();
      }
    }, e.prototype.consumeComponentValue = function() {
      var A = this.consumeToken();
      switch (A.type) {
        case 11:
        case 28:
        case 2:
          return this.consumeSimpleBlock(A.type);
        case 19:
          return this.consumeFunction(A);
      }
      return A;
    }, e.prototype.consumeSimpleBlock = function(A) {
      for (var t = { type: A, values: [] }, r = this.consumeToken(); ; ) {
        if (r.type === 32 || cc(r, A))
          return t;
        this.reconsumeToken(r), t.values.push(this.consumeComponentValue()), r = this.consumeToken();
      }
    }, e.prototype.consumeFunction = function(A) {
      for (var t = {
        name: A.value,
        values: [],
        type: 18
        /* FUNCTION */
      }; ; ) {
        var r = this.consumeToken();
        if (r.type === 32 || r.type === 3)
          return t;
        this.reconsumeToken(r), t.values.push(this.consumeComponentValue());
      }
    }, e.prototype.consumeToken = function() {
      var A = this._tokens.shift();
      return typeof A > "u" ? An : A;
    }, e.prototype.reconsumeToken = function(A) {
      this._tokens.unshift(A);
    }, e;
  }()
), je = function(e) {
  return e.type === 15;
}, Ee = function(e) {
  return e.type === 17;
}, M = function(e) {
  return e.type === 20;
}, Bc = function(e) {
  return e.type === 0;
}, en = function(e, A) {
  return M(e) && e.value === A;
}, bs = function(e) {
  return e.type !== 31;
}, de = function(e) {
  return e.type !== 31 && e.type !== 4;
}, SA = function(e) {
  var A = [], t = [];
  return e.forEach(function(r) {
    if (r.type === 4) {
      if (t.length === 0)
        throw new Error("Error parsing function args, zero tokens for arg");
      A.push(t), t = [];
      return;
    }
    r.type !== 31 && t.push(r);
  }), t.length && A.push(t), A;
}, cc = function(e, A) {
  return A === 11 && e.type === 12 || A === 28 && e.type === 29 ? !0 : A === 2 && e.type === 3;
}, Ae = function(e) {
  return e.type === 17 || e.type === 15;
}, J = function(e) {
  return e.type === 16 || Ae(e);
}, Ls = function(e) {
  return e.length > 1 ? [e[0], e[1]] : [e[0]];
}, AA = {
  type: 17,
  number: 0,
  flags: ze
}, dn = {
  type: 16,
  number: 50,
  flags: ze
}, qA = {
  type: 16,
  number: 100,
  flags: ze
}, Oe = function(e, A, t) {
  var r = e[0], n = e[1];
  return [N(r, A), N(typeof n < "u" ? n : r, t)];
}, N = function(e, A) {
  if (e.type === 16)
    return e.number / 100 * A;
  if (je(e))
    switch (e.unit) {
      case "rem":
      case "em":
        return 16 * e.number;
      case "px":
      default:
        return e.number;
    }
  return e.number;
}, Ts = "deg", Ks = "grad", xs = "rad", Ss = "turn", $t = {
  name: "angle",
  parse: function(e, A) {
    if (A.type === 15)
      switch (A.unit) {
        case Ts:
          return Math.PI * A.number / 180;
        case Ks:
          return Math.PI / 200 * A.number;
        case xs:
          return A.number;
        case Ss:
          return Math.PI * 2 * A.number;
      }
    throw new Error("Unsupported angle type");
  }
}, Ds = function(e) {
  return e.type === 15 && (e.unit === Ts || e.unit === Ks || e.unit === xs || e.unit === Ss);
}, Os = function(e) {
  var A = e.filter(M).map(function(t) {
    return t.value;
  }).join(" ");
  switch (A) {
    case "to bottom right":
    case "to right bottom":
    case "left top":
    case "top left":
      return [AA, AA];
    case "to top":
    case "bottom":
      return QA(0);
    case "to bottom left":
    case "to left bottom":
    case "right top":
    case "top right":
      return [AA, qA];
    case "to right":
    case "left":
      return QA(90);
    case "to top left":
    case "to left top":
    case "right bottom":
    case "bottom right":
      return [qA, qA];
    case "to bottom":
    case "top":
      return QA(180);
    case "to top right":
    case "to right top":
    case "left bottom":
    case "bottom left":
      return [qA, AA];
    case "to left":
    case "right":
      return QA(270);
  }
  return 0;
}, QA = function(e) {
  return Math.PI * e / 180;
}, jA = {
  name: "color",
  parse: function(e, A) {
    if (A.type === 18) {
      var t = lc[A.name];
      if (typeof t > "u")
        throw new Error('Attempting to parse an unsupported color function "' + A.name + '"');
      return t(e, A.values);
    }
    if (A.type === 5) {
      if (A.value.length === 3) {
        var r = A.value.substring(0, 1), n = A.value.substring(1, 2), i = A.value.substring(2, 3);
        return zA(parseInt(r + r, 16), parseInt(n + n, 16), parseInt(i + i, 16), 1);
      }
      if (A.value.length === 4) {
        var r = A.value.substring(0, 1), n = A.value.substring(1, 2), i = A.value.substring(2, 3), s = A.value.substring(3, 4);
        return zA(parseInt(r + r, 16), parseInt(n + n, 16), parseInt(i + i, 16), parseInt(s + s, 16) / 255);
      }
      if (A.value.length === 6) {
        var r = A.value.substring(0, 2), n = A.value.substring(2, 4), i = A.value.substring(4, 6);
        return zA(parseInt(r, 16), parseInt(n, 16), parseInt(i, 16), 1);
      }
      if (A.value.length === 8) {
        var r = A.value.substring(0, 2), n = A.value.substring(2, 4), i = A.value.substring(4, 6), s = A.value.substring(6, 8);
        return zA(parseInt(r, 16), parseInt(n, 16), parseInt(i, 16), parseInt(s, 16) / 255);
      }
    }
    if (A.type === 20) {
      var a = GA[A.value.toUpperCase()];
      if (typeof a < "u")
        return a;
    }
    return GA.TRANSPARENT;
  }
}, $A = function(e) {
  return (255 & e) === 0;
}, q = function(e) {
  var A = 255 & e, t = 255 & e >> 8, r = 255 & e >> 16, n = 255 & e >> 24;
  return A < 255 ? "rgba(" + n + "," + r + "," + t + "," + A / 255 + ")" : "rgb(" + n + "," + r + "," + t + ")";
}, zA = function(e, A, t, r) {
  return (e << 24 | A << 16 | t << 8 | Math.round(r * 255) << 0) >>> 0;
}, wi = function(e, A) {
  if (e.type === 17)
    return e.number;
  if (e.type === 16) {
    var t = A === 3 ? 1 : 255;
    return A === 3 ? e.number / 100 * t : Math.round(e.number / 100 * t);
  }
  return 0;
}, fi = function(e, A) {
  var t = A.filter(de);
  if (t.length === 3) {
    var r = t.map(wi), n = r[0], i = r[1], s = r[2];
    return zA(n, i, s, 1);
  }
  if (t.length === 4) {
    var a = t.map(wi), n = a[0], i = a[1], s = a[2], o = a[3];
    return zA(n, i, s, o);
  }
  return 0;
};
function Fr(e, A, t) {
  return t < 0 && (t += 1), t >= 1 && (t -= 1), t < 1 / 6 ? (A - e) * t * 6 + e : t < 1 / 2 ? A : t < 2 / 3 ? (A - e) * 6 * (2 / 3 - t) + e : e;
}
var Qi = function(e, A) {
  var t = A.filter(de), r = t[0], n = t[1], i = t[2], s = t[3], a = (r.type === 17 ? QA(r.number) : $t.parse(e, r)) / (Math.PI * 2), o = J(n) ? n.number / 100 : 0, B = J(i) ? i.number / 100 : 0, l = typeof s < "u" && J(s) ? N(s, 1) : 1;
  if (o === 0)
    return zA(B * 255, B * 255, B * 255, 1);
  var u = B <= 0.5 ? B * (o + 1) : B + o - B * o, c = B * 2 - u, f = Fr(c, u, a + 1 / 3), g = Fr(c, u, a), w = Fr(c, u, a - 1 / 3);
  return zA(f * 255, g * 255, w * 255, l);
}, lc = {
  hsl: Qi,
  hsla: Qi,
  rgb: fi,
  rgba: fi
}, Ne = function(e, A) {
  return jA.parse(e, ys.create(A).parseComponentValue());
}, GA = {
  ALICEBLUE: 4042850303,
  ANTIQUEWHITE: 4209760255,
  AQUA: 16777215,
  AQUAMARINE: 2147472639,
  AZURE: 4043309055,
  BEIGE: 4126530815,
  BISQUE: 4293182719,
  BLACK: 255,
  BLANCHEDALMOND: 4293643775,
  BLUE: 65535,
  BLUEVIOLET: 2318131967,
  BROWN: 2771004159,
  BURLYWOOD: 3736635391,
  CADETBLUE: 1604231423,
  CHARTREUSE: 2147418367,
  CHOCOLATE: 3530104575,
  CORAL: 4286533887,
  CORNFLOWERBLUE: 1687547391,
  CORNSILK: 4294499583,
  CRIMSON: 3692313855,
  CYAN: 16777215,
  DARKBLUE: 35839,
  DARKCYAN: 9145343,
  DARKGOLDENROD: 3095837695,
  DARKGRAY: 2846468607,
  DARKGREEN: 6553855,
  DARKGREY: 2846468607,
  DARKKHAKI: 3182914559,
  DARKMAGENTA: 2332068863,
  DARKOLIVEGREEN: 1433087999,
  DARKORANGE: 4287365375,
  DARKORCHID: 2570243327,
  DARKRED: 2332033279,
  DARKSALMON: 3918953215,
  DARKSEAGREEN: 2411499519,
  DARKSLATEBLUE: 1211993087,
  DARKSLATEGRAY: 793726975,
  DARKSLATEGREY: 793726975,
  DARKTURQUOISE: 13554175,
  DARKVIOLET: 2483082239,
  DEEPPINK: 4279538687,
  DEEPSKYBLUE: 12582911,
  DIMGRAY: 1768516095,
  DIMGREY: 1768516095,
  DODGERBLUE: 512819199,
  FIREBRICK: 2988581631,
  FLORALWHITE: 4294635775,
  FORESTGREEN: 579543807,
  FUCHSIA: 4278255615,
  GAINSBORO: 3705462015,
  GHOSTWHITE: 4177068031,
  GOLD: 4292280575,
  GOLDENROD: 3668254975,
  GRAY: 2155905279,
  GREEN: 8388863,
  GREENYELLOW: 2919182335,
  GREY: 2155905279,
  HONEYDEW: 4043305215,
  HOTPINK: 4285117695,
  INDIANRED: 3445382399,
  INDIGO: 1258324735,
  IVORY: 4294963455,
  KHAKI: 4041641215,
  LAVENDER: 3873897215,
  LAVENDERBLUSH: 4293981695,
  LAWNGREEN: 2096890111,
  LEMONCHIFFON: 4294626815,
  LIGHTBLUE: 2916673279,
  LIGHTCORAL: 4034953471,
  LIGHTCYAN: 3774873599,
  LIGHTGOLDENRODYELLOW: 4210742015,
  LIGHTGRAY: 3553874943,
  LIGHTGREEN: 2431553791,
  LIGHTGREY: 3553874943,
  LIGHTPINK: 4290167295,
  LIGHTSALMON: 4288707327,
  LIGHTSEAGREEN: 548580095,
  LIGHTSKYBLUE: 2278488831,
  LIGHTSLATEGRAY: 2005441023,
  LIGHTSLATEGREY: 2005441023,
  LIGHTSTEELBLUE: 2965692159,
  LIGHTYELLOW: 4294959359,
  LIME: 16711935,
  LIMEGREEN: 852308735,
  LINEN: 4210091775,
  MAGENTA: 4278255615,
  MAROON: 2147483903,
  MEDIUMAQUAMARINE: 1724754687,
  MEDIUMBLUE: 52735,
  MEDIUMORCHID: 3126187007,
  MEDIUMPURPLE: 2473647103,
  MEDIUMSEAGREEN: 1018393087,
  MEDIUMSLATEBLUE: 2070474495,
  MEDIUMSPRINGGREEN: 16423679,
  MEDIUMTURQUOISE: 1221709055,
  MEDIUMVIOLETRED: 3340076543,
  MIDNIGHTBLUE: 421097727,
  MINTCREAM: 4127193855,
  MISTYROSE: 4293190143,
  MOCCASIN: 4293178879,
  NAVAJOWHITE: 4292783615,
  NAVY: 33023,
  OLDLACE: 4260751103,
  OLIVE: 2155872511,
  OLIVEDRAB: 1804477439,
  ORANGE: 4289003775,
  ORANGERED: 4282712319,
  ORCHID: 3664828159,
  PALEGOLDENROD: 4008225535,
  PALEGREEN: 2566625535,
  PALETURQUOISE: 2951671551,
  PALEVIOLETRED: 3681588223,
  PAPAYAWHIP: 4293907967,
  PEACHPUFF: 4292524543,
  PERU: 3448061951,
  PINK: 4290825215,
  PLUM: 3718307327,
  POWDERBLUE: 2967529215,
  PURPLE: 2147516671,
  REBECCAPURPLE: 1714657791,
  RED: 4278190335,
  ROSYBROWN: 3163525119,
  ROYALBLUE: 1097458175,
  SADDLEBROWN: 2336560127,
  SALMON: 4202722047,
  SANDYBROWN: 4104413439,
  SEAGREEN: 780883967,
  SEASHELL: 4294307583,
  SIENNA: 2689740287,
  SILVER: 3233857791,
  SKYBLUE: 2278484991,
  SLATEBLUE: 1784335871,
  SLATEGRAY: 1887473919,
  SLATEGREY: 1887473919,
  SNOW: 4294638335,
  SPRINGGREEN: 16744447,
  STEELBLUE: 1182971135,
  TAN: 3535047935,
  TEAL: 8421631,
  THISTLE: 3636451583,
  TOMATO: 4284696575,
  TRANSPARENT: 0,
  TURQUOISE: 1088475391,
  VIOLET: 4001558271,
  WHEAT: 4125012991,
  WHITE: 4294967295,
  WHITESMOKE: 4126537215,
  YELLOW: 4294902015,
  YELLOWGREEN: 2597139199
}, uc = {
  name: "background-clip",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.map(function(t) {
      if (M(t))
        switch (t.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, gc = {
  name: "background-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, Ar = function(e, A) {
  var t = jA.parse(e, A[0]), r = A[1];
  return r && J(r) ? { color: t, stop: r } : { color: t, stop: null };
}, hi = function(e, A) {
  var t = e[0], r = e[e.length - 1];
  t.stop === null && (t.stop = AA), r.stop === null && (r.stop = qA);
  for (var n = [], i = 0, s = 0; s < e.length; s++) {
    var a = e[s].stop;
    if (a !== null) {
      var o = N(a, A);
      o > i ? n.push(o) : n.push(i), i = o;
    } else
      n.push(null);
  }
  for (var B = null, s = 0; s < n.length; s++) {
    var l = n[s];
    if (l === null)
      B === null && (B = s);
    else if (B !== null) {
      for (var u = s - B, c = n[B - 1], f = (l - c) / (u + 1), g = 1; g <= u; g++)
        n[B + g - 1] = f * g;
      B = null;
    }
  }
  return e.map(function(w, Q) {
    var d = w.color;
    return { color: d, stop: Math.max(Math.min(1, n[Q] / A), 0) };
  });
}, wc = function(e, A, t) {
  var r = A / 2, n = t / 2, i = N(e[0], A) - r, s = n - N(e[1], t);
  return (Math.atan2(s, i) + Math.PI * 2) % (Math.PI * 2);
}, fc = function(e, A, t) {
  var r = typeof e == "number" ? e : wc(e, A, t), n = Math.abs(A * Math.sin(r)) + Math.abs(t * Math.cos(r)), i = A / 2, s = t / 2, a = n / 2, o = Math.sin(r - Math.PI / 2) * a, B = Math.cos(r - Math.PI / 2) * a;
  return [n, i - B, i + B, s - o, s + o];
}, FA = function(e, A) {
  return Math.sqrt(e * e + A * A);
}, Ci = function(e, A, t, r, n) {
  var i = [
    [0, 0],
    [0, A],
    [e, 0],
    [e, A]
  ];
  return i.reduce(function(s, a) {
    var o = a[0], B = a[1], l = FA(t - o, r - B);
    return (n ? l < s.optimumDistance : l > s.optimumDistance) ? {
      optimumCorner: a,
      optimumDistance: l
    } : s;
  }, {
    optimumDistance: n ? 1 / 0 : -1 / 0,
    optimumCorner: null
  }).optimumCorner;
}, Qc = function(e, A, t, r, n) {
  var i = 0, s = 0;
  switch (e.size) {
    case 0:
      e.shape === 0 ? i = s = Math.min(Math.abs(A), Math.abs(A - r), Math.abs(t), Math.abs(t - n)) : e.shape === 1 && (i = Math.min(Math.abs(A), Math.abs(A - r)), s = Math.min(Math.abs(t), Math.abs(t - n)));
      break;
    case 2:
      if (e.shape === 0)
        i = s = Math.min(FA(A, t), FA(A, t - n), FA(A - r, t), FA(A - r, t - n));
      else if (e.shape === 1) {
        var a = Math.min(Math.abs(t), Math.abs(t - n)) / Math.min(Math.abs(A), Math.abs(A - r)), o = Ci(r, n, A, t, !0), B = o[0], l = o[1];
        i = FA(B - A, (l - t) / a), s = a * i;
      }
      break;
    case 1:
      e.shape === 0 ? i = s = Math.max(Math.abs(A), Math.abs(A - r), Math.abs(t), Math.abs(t - n)) : e.shape === 1 && (i = Math.max(Math.abs(A), Math.abs(A - r)), s = Math.max(Math.abs(t), Math.abs(t - n)));
      break;
    case 3:
      if (e.shape === 0)
        i = s = Math.max(FA(A, t), FA(A, t - n), FA(A - r, t), FA(A - r, t - n));
      else if (e.shape === 1) {
        var a = Math.max(Math.abs(t), Math.abs(t - n)) / Math.max(Math.abs(A), Math.abs(A - r)), u = Ci(r, n, A, t, !1), B = u[0], l = u[1];
        i = FA(B - A, (l - t) / a), s = a * i;
      }
      break;
  }
  return Array.isArray(e.size) && (i = N(e.size[0], r), s = e.size.length === 2 ? N(e.size[1], n) : i), [i, s];
}, hc = function(e, A) {
  var t = QA(180), r = [];
  return SA(A).forEach(function(n, i) {
    if (i === 0) {
      var s = n[0];
      if (s.type === 20 && s.value === "to") {
        t = Os(n);
        return;
      } else if (Ds(s)) {
        t = $t.parse(e, s);
        return;
      }
    }
    var a = Ar(e, n);
    r.push(a);
  }), {
    angle: t,
    stops: r,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, Ft = function(e, A) {
  var t = QA(180), r = [];
  return SA(A).forEach(function(n, i) {
    if (i === 0) {
      var s = n[0];
      if (s.type === 20 && ["top", "left", "right", "bottom"].indexOf(s.value) !== -1) {
        t = Os(n);
        return;
      } else if (Ds(s)) {
        t = ($t.parse(e, s) + QA(270)) % QA(360);
        return;
      }
    }
    var a = Ar(e, n);
    r.push(a);
  }), {
    angle: t,
    stops: r,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, Cc = function(e, A) {
  var t = QA(180), r = [], n = 1, i = 0, s = 3, a = [];
  return SA(A).forEach(function(o, B) {
    var l = o[0];
    if (B === 0) {
      if (M(l) && l.value === "linear") {
        n = 1;
        return;
      } else if (M(l) && l.value === "radial") {
        n = 2;
        return;
      }
    }
    if (l.type === 18) {
      if (l.name === "from") {
        var u = jA.parse(e, l.values[0]);
        r.push({ stop: AA, color: u });
      } else if (l.name === "to") {
        var u = jA.parse(e, l.values[0]);
        r.push({ stop: qA, color: u });
      } else if (l.name === "color-stop") {
        var c = l.values.filter(de);
        if (c.length === 2) {
          var u = jA.parse(e, c[1]), f = c[0];
          Ee(f) && r.push({
            stop: { type: 16, number: f.number * 100, flags: f.flags },
            color: u
          });
        }
      }
    }
  }), n === 1 ? {
    angle: (t + QA(180)) % QA(360),
    stops: r,
    type: n
  } : { size: s, shape: i, stops: r, position: a, type: n };
}, Rs = "closest-side", Ms = "farthest-side", _s = "closest-corner", Gs = "farthest-corner", Ns = "circle", Ps = "ellipse", ks = "cover", Vs = "contain", Uc = function(e, A) {
  var t = 0, r = 3, n = [], i = [];
  return SA(A).forEach(function(s, a) {
    var o = !0;
    if (a === 0) {
      var B = !1;
      o = s.reduce(function(u, c) {
        if (B)
          if (M(c))
            switch (c.value) {
              case "center":
                return i.push(dn), u;
              case "top":
              case "left":
                return i.push(AA), u;
              case "right":
              case "bottom":
                return i.push(qA), u;
            }
          else
            (J(c) || Ae(c)) && i.push(c);
        else if (M(c))
          switch (c.value) {
            case Ns:
              return t = 0, !1;
            case Ps:
              return t = 1, !1;
            case "at":
              return B = !0, !1;
            case Rs:
              return r = 0, !1;
            case ks:
            case Ms:
              return r = 1, !1;
            case Vs:
            case _s:
              return r = 2, !1;
            case Gs:
              return r = 3, !1;
          }
        else if (Ae(c) || J(c))
          return Array.isArray(r) || (r = []), r.push(c), !1;
        return u;
      }, o);
    }
    if (o) {
      var l = Ar(e, s);
      n.push(l);
    }
  }), {
    size: r,
    shape: t,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, pt = function(e, A) {
  var t = 0, r = 3, n = [], i = [];
  return SA(A).forEach(function(s, a) {
    var o = !0;
    if (a === 0 ? o = s.reduce(function(l, u) {
      if (M(u))
        switch (u.value) {
          case "center":
            return i.push(dn), !1;
          case "top":
          case "left":
            return i.push(AA), !1;
          case "right":
          case "bottom":
            return i.push(qA), !1;
        }
      else if (J(u) || Ae(u))
        return i.push(u), !1;
      return l;
    }, o) : a === 1 && (o = s.reduce(function(l, u) {
      if (M(u))
        switch (u.value) {
          case Ns:
            return t = 0, !1;
          case Ps:
            return t = 1, !1;
          case Vs:
          case Rs:
            return r = 0, !1;
          case Ms:
            return r = 1, !1;
          case _s:
            return r = 2, !1;
          case ks:
          case Gs:
            return r = 3, !1;
        }
      else if (Ae(u) || J(u))
        return Array.isArray(r) || (r = []), r.push(u), !1;
      return l;
    }, o)), o) {
      var B = Ar(e, s);
      n.push(B);
    }
  }), {
    size: r,
    shape: t,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, dc = function(e) {
  return e.type === 1;
}, Fc = function(e) {
  return e.type === 2;
}, Fn = {
  name: "image",
  parse: function(e, A) {
    if (A.type === 22) {
      var t = {
        url: A.value,
        type: 0
        /* URL */
      };
      return e.cache.addImage(A.value), t;
    }
    if (A.type === 18) {
      var r = Xs[A.name];
      if (typeof r > "u")
        throw new Error('Attempting to parse an unsupported image function "' + A.name + '"');
      return r(e, A.values);
    }
    throw new Error("Unsupported image type " + A.type);
  }
};
function pc(e) {
  return !(e.type === 20 && e.value === "none") && (e.type !== 18 || !!Xs[e.name]);
}
var Xs = {
  "linear-gradient": hc,
  "-moz-linear-gradient": Ft,
  "-ms-linear-gradient": Ft,
  "-o-linear-gradient": Ft,
  "-webkit-linear-gradient": Ft,
  "radial-gradient": Uc,
  "-moz-radial-gradient": pt,
  "-ms-radial-gradient": pt,
  "-o-radial-gradient": pt,
  "-webkit-radial-gradient": pt,
  "-webkit-gradient": Cc
}, Ec = {
  name: "background-image",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    if (A.length === 0)
      return [];
    var t = A[0];
    return t.type === 20 && t.value === "none" ? [] : A.filter(function(r) {
      return de(r) && pc(r);
    }).map(function(r) {
      return Fn.parse(e, r);
    });
  }
}, vc = {
  name: "background-origin",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.map(function(t) {
      if (M(t))
        switch (t.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, mc = {
  name: "background-position",
  initialValue: "0% 0%",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return SA(A).map(function(t) {
      return t.filter(J);
    }).map(Ls);
  }
}, Ic = {
  name: "background-repeat",
  initialValue: "repeat",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return SA(A).map(function(t) {
      return t.filter(M).map(function(r) {
        return r.value;
      }).join(" ");
    }).map(Hc);
  }
}, Hc = function(e) {
  switch (e) {
    case "no-repeat":
      return 1;
    case "repeat-x":
    case "repeat no-repeat":
      return 2;
    case "repeat-y":
    case "no-repeat repeat":
      return 3;
    case "repeat":
    default:
      return 0;
  }
}, Ue;
(function(e) {
  e.AUTO = "auto", e.CONTAIN = "contain", e.COVER = "cover";
})(Ue || (Ue = {}));
var yc = {
  name: "background-size",
  initialValue: "0",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return SA(A).map(function(t) {
      return t.filter(bc);
    });
  }
}, bc = function(e) {
  return M(e) || J(e);
}, er = function(e) {
  return {
    name: "border-" + e + "-color",
    initialValue: "transparent",
    prefix: !1,
    type: 3,
    format: "color"
  };
}, Lc = er("top"), Tc = er("right"), Kc = er("bottom"), xc = er("left"), tr = function(e) {
  return {
    name: "border-radius-" + e,
    initialValue: "0 0",
    prefix: !1,
    type: 1,
    parse: function(A, t) {
      return Ls(t.filter(J));
    }
  };
}, Sc = tr("top-left"), Dc = tr("top-right"), Oc = tr("bottom-right"), Rc = tr("bottom-left"), rr = function(e) {
  return {
    name: "border-" + e + "-style",
    initialValue: "solid",
    prefix: !1,
    type: 2,
    parse: function(A, t) {
      switch (t) {
        case "none":
          return 0;
        case "dashed":
          return 2;
        case "dotted":
          return 3;
        case "double":
          return 4;
      }
      return 1;
    }
  };
}, Mc = rr("top"), _c = rr("right"), Gc = rr("bottom"), Nc = rr("left"), nr = function(e) {
  return {
    name: "border-" + e + "-width",
    initialValue: "0",
    type: 0,
    prefix: !1,
    parse: function(A, t) {
      return je(t) ? t.number : 0;
    }
  };
}, Pc = nr("top"), kc = nr("right"), Vc = nr("bottom"), Xc = nr("left"), Jc = {
  name: "color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, Wc = {
  name: "direction",
  initialValue: "ltr",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "rtl":
        return 1;
      case "ltr":
      default:
        return 0;
    }
  }
}, Yc = {
  name: "display",
  initialValue: "inline-block",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(M).reduce(
      function(t, r) {
        return t | Zc(r.value);
      },
      0
      /* NONE */
    );
  }
}, Zc = function(e) {
  switch (e) {
    case "block":
    case "-webkit-box":
      return 2;
    case "inline":
      return 4;
    case "run-in":
      return 8;
    case "flow":
      return 16;
    case "flow-root":
      return 32;
    case "table":
      return 64;
    case "flex":
    case "-webkit-flex":
      return 128;
    case "grid":
    case "-ms-grid":
      return 256;
    case "ruby":
      return 512;
    case "subgrid":
      return 1024;
    case "list-item":
      return 2048;
    case "table-row-group":
      return 4096;
    case "table-header-group":
      return 8192;
    case "table-footer-group":
      return 16384;
    case "table-row":
      return 32768;
    case "table-cell":
      return 65536;
    case "table-column-group":
      return 131072;
    case "table-column":
      return 262144;
    case "table-caption":
      return 524288;
    case "ruby-base":
      return 1048576;
    case "ruby-text":
      return 2097152;
    case "ruby-base-container":
      return 4194304;
    case "ruby-text-container":
      return 8388608;
    case "contents":
      return 16777216;
    case "inline-block":
      return 33554432;
    case "inline-list-item":
      return 67108864;
    case "inline-table":
      return 134217728;
    case "inline-flex":
      return 268435456;
    case "inline-grid":
      return 536870912;
  }
  return 0;
}, qc = {
  name: "float",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "left":
        return 1;
      case "right":
        return 2;
      case "inline-start":
        return 3;
      case "inline-end":
        return 4;
    }
    return 0;
  }
}, zc = {
  name: "letter-spacing",
  initialValue: "0",
  prefix: !1,
  type: 0,
  parse: function(e, A) {
    return A.type === 20 && A.value === "normal" ? 0 : A.type === 17 || A.type === 15 ? A.number : 0;
  }
}, _t;
(function(e) {
  e.NORMAL = "normal", e.STRICT = "strict";
})(_t || (_t = {}));
var jc = {
  name: "line-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "strict":
        return _t.STRICT;
      case "normal":
      default:
        return _t.NORMAL;
    }
  }
}, $c = {
  name: "line-height",
  initialValue: "normal",
  prefix: !1,
  type: 4
  /* TOKEN_VALUE */
}, Ui = function(e, A) {
  return M(e) && e.value === "normal" ? 1.2 * A : e.type === 17 ? A * e.number : J(e) ? N(e, A) : A;
}, Al = {
  name: "list-style-image",
  initialValue: "none",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    return A.type === 20 && A.value === "none" ? null : Fn.parse(e, A);
  }
}, el = {
  name: "list-style-position",
  initialValue: "outside",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "inside":
        return 0;
      case "outside":
      default:
        return 1;
    }
  }
}, tn = {
  name: "list-style-type",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "disc":
        return 0;
      case "circle":
        return 1;
      case "square":
        return 2;
      case "decimal":
        return 3;
      case "cjk-decimal":
        return 4;
      case "decimal-leading-zero":
        return 5;
      case "lower-roman":
        return 6;
      case "upper-roman":
        return 7;
      case "lower-greek":
        return 8;
      case "lower-alpha":
        return 9;
      case "upper-alpha":
        return 10;
      case "arabic-indic":
        return 11;
      case "armenian":
        return 12;
      case "bengali":
        return 13;
      case "cambodian":
        return 14;
      case "cjk-earthly-branch":
        return 15;
      case "cjk-heavenly-stem":
        return 16;
      case "cjk-ideographic":
        return 17;
      case "devanagari":
        return 18;
      case "ethiopic-numeric":
        return 19;
      case "georgian":
        return 20;
      case "gujarati":
        return 21;
      case "gurmukhi":
        return 22;
      case "hebrew":
        return 22;
      case "hiragana":
        return 23;
      case "hiragana-iroha":
        return 24;
      case "japanese-formal":
        return 25;
      case "japanese-informal":
        return 26;
      case "kannada":
        return 27;
      case "katakana":
        return 28;
      case "katakana-iroha":
        return 29;
      case "khmer":
        return 30;
      case "korean-hangul-formal":
        return 31;
      case "korean-hanja-formal":
        return 32;
      case "korean-hanja-informal":
        return 33;
      case "lao":
        return 34;
      case "lower-armenian":
        return 35;
      case "malayalam":
        return 36;
      case "mongolian":
        return 37;
      case "myanmar":
        return 38;
      case "oriya":
        return 39;
      case "persian":
        return 40;
      case "simp-chinese-formal":
        return 41;
      case "simp-chinese-informal":
        return 42;
      case "tamil":
        return 43;
      case "telugu":
        return 44;
      case "thai":
        return 45;
      case "tibetan":
        return 46;
      case "trad-chinese-formal":
        return 47;
      case "trad-chinese-informal":
        return 48;
      case "upper-armenian":
        return 49;
      case "disclosure-open":
        return 50;
      case "disclosure-closed":
        return 51;
      case "none":
      default:
        return -1;
    }
  }
}, ir = function(e) {
  return {
    name: "margin-" + e,
    initialValue: "0",
    prefix: !1,
    type: 4
    /* TOKEN_VALUE */
  };
}, tl = ir("top"), rl = ir("right"), nl = ir("bottom"), il = ir("left"), sl = {
  name: "overflow",
  initialValue: "visible",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(M).map(function(t) {
      switch (t.value) {
        case "hidden":
          return 1;
        case "scroll":
          return 2;
        case "clip":
          return 3;
        case "auto":
          return 4;
        case "visible":
        default:
          return 0;
      }
    });
  }
}, al = {
  name: "overflow-wrap",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "break-word":
        return "break-word";
      case "normal":
      default:
        return "normal";
    }
  }
}, sr = function(e) {
  return {
    name: "padding-" + e,
    initialValue: "0",
    prefix: !1,
    type: 3,
    format: "length-percentage"
  };
}, ol = sr("top"), Bl = sr("right"), cl = sr("bottom"), ll = sr("left"), ul = {
  name: "text-align",
  initialValue: "left",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "right":
        return 2;
      case "center":
      case "justify":
        return 1;
      case "left":
      default:
        return 0;
    }
  }
}, gl = {
  name: "position",
  initialValue: "static",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "relative":
        return 1;
      case "absolute":
        return 2;
      case "fixed":
        return 3;
      case "sticky":
        return 4;
    }
    return 0;
  }
}, wl = {
  name: "text-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return A.length === 1 && en(A[0], "none") ? [] : SA(A).map(function(t) {
      for (var r = {
        color: GA.TRANSPARENT,
        offsetX: AA,
        offsetY: AA,
        blur: AA
      }, n = 0, i = 0; i < t.length; i++) {
        var s = t[i];
        Ae(s) ? (n === 0 ? r.offsetX = s : n === 1 ? r.offsetY = s : r.blur = s, n++) : r.color = jA.parse(e, s);
      }
      return r;
    });
  }
}, fl = {
  name: "text-transform",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "uppercase":
        return 2;
      case "lowercase":
        return 1;
      case "capitalize":
        return 3;
    }
    return 0;
  }
}, Ql = {
  name: "transform",
  initialValue: "none",
  prefix: !0,
  type: 0,
  parse: function(e, A) {
    if (A.type === 20 && A.value === "none")
      return null;
    if (A.type === 18) {
      var t = Ul[A.name];
      if (typeof t > "u")
        throw new Error('Attempting to parse an unsupported transform function "' + A.name + '"');
      return t(A.values);
    }
    return null;
  }
}, hl = function(e) {
  var A = e.filter(function(t) {
    return t.type === 17;
  }).map(function(t) {
    return t.number;
  });
  return A.length === 6 ? A : null;
}, Cl = function(e) {
  var A = e.filter(function(o) {
    return o.type === 17;
  }).map(function(o) {
    return o.number;
  }), t = A[0], r = A[1];
  A[2], A[3];
  var n = A[4], i = A[5];
  A[6], A[7], A[8], A[9], A[10], A[11];
  var s = A[12], a = A[13];
  return A[14], A[15], A.length === 16 ? [t, r, n, i, s, a] : null;
}, Ul = {
  matrix: hl,
  matrix3d: Cl
}, di = {
  type: 16,
  number: 50,
  flags: ze
}, dl = [di, di], Fl = {
  name: "transform-origin",
  initialValue: "50% 50%",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    var t = A.filter(J);
    return t.length !== 2 ? dl : [t[0], t[1]];
  }
}, pl = {
  name: "visible",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "hidden":
        return 1;
      case "collapse":
        return 2;
      case "visible":
      default:
        return 0;
    }
  }
}, Pe;
(function(e) {
  e.NORMAL = "normal", e.BREAK_ALL = "break-all", e.KEEP_ALL = "keep-all";
})(Pe || (Pe = {}));
var El = {
  name: "word-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "break-all":
        return Pe.BREAK_ALL;
      case "keep-all":
        return Pe.KEEP_ALL;
      case "normal":
      default:
        return Pe.NORMAL;
    }
  }
}, vl = {
  name: "z-index",
  initialValue: "auto",
  prefix: !1,
  type: 0,
  parse: function(e, A) {
    if (A.type === 20)
      return { auto: !0, order: 0 };
    if (Ee(A))
      return { auto: !1, order: A.number };
    throw new Error("Invalid z-index number parsed");
  }
}, Js = {
  name: "time",
  parse: function(e, A) {
    if (A.type === 15)
      switch (A.unit.toLowerCase()) {
        case "s":
          return 1e3 * A.number;
        case "ms":
          return A.number;
      }
    throw new Error("Unsupported time type");
  }
}, ml = {
  name: "opacity",
  initialValue: "1",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    return Ee(A) ? A.number : 1;
  }
}, Il = {
  name: "text-decoration-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, Hl = {
  name: "text-decoration-line",
  initialValue: "none",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(M).map(function(t) {
      switch (t.value) {
        case "underline":
          return 1;
        case "overline":
          return 2;
        case "line-through":
          return 3;
        case "none":
          return 4;
      }
      return 0;
    }).filter(function(t) {
      return t !== 0;
    });
  }
}, yl = {
  name: "font-family",
  initialValue: "",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    var t = [], r = [];
    return A.forEach(function(n) {
      switch (n.type) {
        case 20:
        case 0:
          t.push(n.value);
          break;
        case 17:
          t.push(n.number.toString());
          break;
        case 4:
          r.push(t.join(" ")), t.length = 0;
          break;
      }
    }), t.length && r.push(t.join(" ")), r.map(function(n) {
      return n.indexOf(" ") === -1 ? n : "'" + n + "'";
    });
  }
}, bl = {
  name: "font-size",
  initialValue: "0",
  prefix: !1,
  type: 3,
  format: "length"
}, Ll = {
  name: "font-weight",
  initialValue: "normal",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    if (Ee(A))
      return A.number;
    if (M(A))
      switch (A.value) {
        case "bold":
          return 700;
        case "normal":
        default:
          return 400;
      }
    return 400;
  }
}, Tl = {
  name: "font-variant",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return A.filter(M).map(function(t) {
      return t.value;
    });
  }
}, Kl = {
  name: "font-style",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "oblique":
        return "oblique";
      case "italic":
        return "italic";
      case "normal":
      default:
        return "normal";
    }
  }
}, Z = function(e, A) {
  return (e & A) !== 0;
}, xl = {
  name: "content",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    if (A.length === 0)
      return [];
    var t = A[0];
    return t.type === 20 && t.value === "none" ? [] : A;
  }
}, Sl = {
  name: "counter-increment",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    if (A.length === 0)
      return null;
    var t = A[0];
    if (t.type === 20 && t.value === "none")
      return null;
    for (var r = [], n = A.filter(bs), i = 0; i < n.length; i++) {
      var s = n[i], a = n[i + 1];
      if (s.type === 20) {
        var o = a && Ee(a) ? a.number : 1;
        r.push({ counter: s.value, increment: o });
      }
    }
    return r;
  }
}, Dl = {
  name: "counter-reset",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    if (A.length === 0)
      return [];
    for (var t = [], r = A.filter(bs), n = 0; n < r.length; n++) {
      var i = r[n], s = r[n + 1];
      if (M(i) && i.value !== "none") {
        var a = s && Ee(s) ? s.number : 0;
        t.push({ counter: i.value, reset: a });
      }
    }
    return t;
  }
}, Ol = {
  name: "duration",
  initialValue: "0s",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(je).map(function(t) {
      return Js.parse(e, t);
    });
  }
}, Rl = {
  name: "quotes",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    if (A.length === 0)
      return null;
    var t = A[0];
    if (t.type === 20 && t.value === "none")
      return null;
    var r = [], n = A.filter(Bc);
    if (n.length % 2 !== 0)
      return null;
    for (var i = 0; i < n.length; i += 2) {
      var s = n[i].value, a = n[i + 1].value;
      r.push({ open: s, close: a });
    }
    return r;
  }
}, Fi = function(e, A, t) {
  if (!e)
    return "";
  var r = e[Math.min(A, e.length - 1)];
  return r ? t ? r.open : r.close : "";
}, Ml = {
  name: "box-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return A.length === 1 && en(A[0], "none") ? [] : SA(A).map(function(t) {
      for (var r = {
        color: 255,
        offsetX: AA,
        offsetY: AA,
        blur: AA,
        spread: AA,
        inset: !1
      }, n = 0, i = 0; i < t.length; i++) {
        var s = t[i];
        en(s, "inset") ? r.inset = !0 : Ae(s) ? (n === 0 ? r.offsetX = s : n === 1 ? r.offsetY = s : n === 2 ? r.blur = s : r.spread = s, n++) : r.color = jA.parse(e, s);
      }
      return r;
    });
  }
}, _l = {
  name: "paint-order",
  initialValue: "normal",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    var t = [
      0,
      1,
      2
      /* MARKERS */
    ], r = [];
    return A.filter(M).forEach(function(n) {
      switch (n.value) {
        case "stroke":
          r.push(
            1
            /* STROKE */
          );
          break;
        case "fill":
          r.push(
            0
            /* FILL */
          );
          break;
        case "markers":
          r.push(
            2
            /* MARKERS */
          );
          break;
      }
    }), t.forEach(function(n) {
      r.indexOf(n) === -1 && r.push(n);
    }), r;
  }
}, Gl = {
  name: "-webkit-text-stroke-color",
  initialValue: "currentcolor",
  prefix: !1,
  type: 3,
  format: "color"
}, Nl = {
  name: "-webkit-text-stroke-width",
  initialValue: "0",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    return je(A) ? A.number : 0;
  }
}, Pl = (
  /** @class */
  function() {
    function e(A, t) {
      var r, n;
      this.animationDuration = v(A, Ol, t.animationDuration), this.backgroundClip = v(A, uc, t.backgroundClip), this.backgroundColor = v(A, gc, t.backgroundColor), this.backgroundImage = v(A, Ec, t.backgroundImage), this.backgroundOrigin = v(A, vc, t.backgroundOrigin), this.backgroundPosition = v(A, mc, t.backgroundPosition), this.backgroundRepeat = v(A, Ic, t.backgroundRepeat), this.backgroundSize = v(A, yc, t.backgroundSize), this.borderTopColor = v(A, Lc, t.borderTopColor), this.borderRightColor = v(A, Tc, t.borderRightColor), this.borderBottomColor = v(A, Kc, t.borderBottomColor), this.borderLeftColor = v(A, xc, t.borderLeftColor), this.borderTopLeftRadius = v(A, Sc, t.borderTopLeftRadius), this.borderTopRightRadius = v(A, Dc, t.borderTopRightRadius), this.borderBottomRightRadius = v(A, Oc, t.borderBottomRightRadius), this.borderBottomLeftRadius = v(A, Rc, t.borderBottomLeftRadius), this.borderTopStyle = v(A, Mc, t.borderTopStyle), this.borderRightStyle = v(A, _c, t.borderRightStyle), this.borderBottomStyle = v(A, Gc, t.borderBottomStyle), this.borderLeftStyle = v(A, Nc, t.borderLeftStyle), this.borderTopWidth = v(A, Pc, t.borderTopWidth), this.borderRightWidth = v(A, kc, t.borderRightWidth), this.borderBottomWidth = v(A, Vc, t.borderBottomWidth), this.borderLeftWidth = v(A, Xc, t.borderLeftWidth), this.boxShadow = v(A, Ml, t.boxShadow), this.color = v(A, Jc, t.color), this.direction = v(A, Wc, t.direction), this.display = v(A, Yc, t.display), this.float = v(A, qc, t.cssFloat), this.fontFamily = v(A, yl, t.fontFamily), this.fontSize = v(A, bl, t.fontSize), this.fontStyle = v(A, Kl, t.fontStyle), this.fontVariant = v(A, Tl, t.fontVariant), this.fontWeight = v(A, Ll, t.fontWeight), this.letterSpacing = v(A, zc, t.letterSpacing), this.lineBreak = v(A, jc, t.lineBreak), this.lineHeight = v(A, $c, t.lineHeight), this.listStyleImage = v(A, Al, t.listStyleImage), this.listStylePosition = v(A, el, t.listStylePosition), this.listStyleType = v(A, tn, t.listStyleType), this.marginTop = v(A, tl, t.marginTop), this.marginRight = v(A, rl, t.marginRight), this.marginBottom = v(A, nl, t.marginBottom), this.marginLeft = v(A, il, t.marginLeft), this.opacity = v(A, ml, t.opacity);
      var i = v(A, sl, t.overflow);
      this.overflowX = i[0], this.overflowY = i[i.length > 1 ? 1 : 0], this.overflowWrap = v(A, al, t.overflowWrap), this.paddingTop = v(A, ol, t.paddingTop), this.paddingRight = v(A, Bl, t.paddingRight), this.paddingBottom = v(A, cl, t.paddingBottom), this.paddingLeft = v(A, ll, t.paddingLeft), this.paintOrder = v(A, _l, t.paintOrder), this.position = v(A, gl, t.position), this.textAlign = v(A, ul, t.textAlign), this.textDecorationColor = v(A, Il, (r = t.textDecorationColor) !== null && r !== void 0 ? r : t.color), this.textDecorationLine = v(A, Hl, (n = t.textDecorationLine) !== null && n !== void 0 ? n : t.textDecoration), this.textShadow = v(A, wl, t.textShadow), this.textTransform = v(A, fl, t.textTransform), this.transform = v(A, Ql, t.transform), this.transformOrigin = v(A, Fl, t.transformOrigin), this.visibility = v(A, pl, t.visibility), this.webkitTextStrokeColor = v(A, Gl, t.webkitTextStrokeColor), this.webkitTextStrokeWidth = v(A, Nl, t.webkitTextStrokeWidth), this.wordBreak = v(A, El, t.wordBreak), this.zIndex = v(A, vl, t.zIndex);
    }
    return e.prototype.isVisible = function() {
      return this.display > 0 && this.opacity > 0 && this.visibility === 0;
    }, e.prototype.isTransparent = function() {
      return $A(this.backgroundColor);
    }, e.prototype.isTransformed = function() {
      return this.transform !== null;
    }, e.prototype.isPositioned = function() {
      return this.position !== 0;
    }, e.prototype.isPositionedWithZIndex = function() {
      return this.isPositioned() && !this.zIndex.auto;
    }, e.prototype.isFloating = function() {
      return this.float !== 0;
    }, e.prototype.isInlineLevel = function() {
      return Z(
        this.display,
        4
        /* INLINE */
      ) || Z(
        this.display,
        33554432
        /* INLINE_BLOCK */
      ) || Z(
        this.display,
        268435456
        /* INLINE_FLEX */
      ) || Z(
        this.display,
        536870912
        /* INLINE_GRID */
      ) || Z(
        this.display,
        67108864
        /* INLINE_LIST_ITEM */
      ) || Z(
        this.display,
        134217728
        /* INLINE_TABLE */
      );
    }, e;
  }()
), kl = (
  /** @class */
  function() {
    function e(A, t) {
      this.content = v(A, xl, t.content), this.quotes = v(A, Rl, t.quotes);
    }
    return e;
  }()
), pi = (
  /** @class */
  function() {
    function e(A, t) {
      this.counterIncrement = v(A, Sl, t.counterIncrement), this.counterReset = v(A, Dl, t.counterReset);
    }
    return e;
  }()
), v = function(e, A, t) {
  var r = new Hs(), n = t !== null && typeof t < "u" ? t.toString() : A.initialValue;
  r.write(n);
  var i = new ys(r.read());
  switch (A.type) {
    case 2:
      var s = i.parseComponentValue();
      return A.parse(e, M(s) ? s.value : A.initialValue);
    case 0:
      return A.parse(e, i.parseComponentValue());
    case 1:
      return A.parse(e, i.parseComponentValues());
    case 4:
      return i.parseComponentValue();
    case 3:
      switch (A.format) {
        case "angle":
          return $t.parse(e, i.parseComponentValue());
        case "color":
          return jA.parse(e, i.parseComponentValue());
        case "image":
          return Fn.parse(e, i.parseComponentValue());
        case "length":
          var a = i.parseComponentValue();
          return Ae(a) ? a : AA;
        case "length-percentage":
          var o = i.parseComponentValue();
          return J(o) ? o : AA;
        case "time":
          return Js.parse(e, i.parseComponentValue());
      }
      break;
  }
}, Vl = "data-html2canvas-debug", Xl = function(e) {
  var A = e.getAttribute(Vl);
  switch (A) {
    case "all":
      return 1;
    case "clone":
      return 2;
    case "parse":
      return 3;
    case "render":
      return 4;
    default:
      return 0;
  }
}, rn = function(e, A) {
  var t = Xl(e);
  return t === 1 || A === t;
}, DA = (
  /** @class */
  function() {
    function e(A, t) {
      if (this.context = A, this.textNodes = [], this.elements = [], this.flags = 0, rn(
        t,
        3
        /* PARSE */
      ))
        debugger;
      this.styles = new Pl(A, window.getComputedStyle(t, null)), an(t) && (this.styles.animationDuration.some(function(r) {
        return r > 0;
      }) && (t.style.animationDuration = "0s"), this.styles.transform !== null && (t.style.transform = "none")), this.bounds = zt(this.context, t), rn(
        t,
        4
        /* RENDER */
      ) && (this.flags |= 16);
    }
    return e;
  }()
), Jl = "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", Ei = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Re = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Et = 0; Et < Ei.length; Et++)
  Re[Ei.charCodeAt(Et)] = Et;
var Wl = function(e) {
  var A = e.length * 0.75, t = e.length, r, n = 0, i, s, a, o;
  e[e.length - 1] === "=" && (A--, e[e.length - 2] === "=" && A--);
  var B = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), l = Array.isArray(B) ? B : new Uint8Array(B);
  for (r = 0; r < t; r += 4)
    i = Re[e.charCodeAt(r)], s = Re[e.charCodeAt(r + 1)], a = Re[e.charCodeAt(r + 2)], o = Re[e.charCodeAt(r + 3)], l[n++] = i << 2 | s >> 4, l[n++] = (s & 15) << 4 | a >> 2, l[n++] = (a & 3) << 6 | o & 63;
  return B;
}, Yl = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 2)
    t.push(e[r + 1] << 8 | e[r]);
  return t;
}, Zl = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 4)
    t.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
  return t;
}, ie = 5, pn = 6 + 5, pr = 2, ql = pn - ie, Ws = 65536 >> ie, zl = 1 << ie, Er = zl - 1, jl = 1024 >> ie, $l = Ws + jl, Au = $l, eu = 32, tu = Au + eu, ru = 65536 >> pn, nu = 1 << ql, iu = nu - 1, vi = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint16Array(Array.prototype.slice.call(e, A, t));
}, su = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint32Array(Array.prototype.slice.call(e, A, t));
}, au = function(e, A) {
  var t = Wl(e), r = Array.isArray(t) ? Zl(t) : new Uint32Array(t), n = Array.isArray(t) ? Yl(t) : new Uint16Array(t), i = 24, s = vi(n, i / 2, r[4] / 2), a = r[5] === 2 ? vi(n, (i + r[4]) / 2) : su(r, Math.ceil((i + r[4]) / 4));
  return new ou(r[0], r[1], r[2], r[3], s, a);
}, ou = (
  /** @class */
  function() {
    function e(A, t, r, n, i, s) {
      this.initialValue = A, this.errorValue = t, this.highStart = r, this.highValueIndex = n, this.index = i, this.data = s;
    }
    return e.prototype.get = function(A) {
      var t;
      if (A >= 0) {
        if (A < 55296 || A > 56319 && A <= 65535)
          return t = this.index[A >> ie], t = (t << pr) + (A & Er), this.data[t];
        if (A <= 65535)
          return t = this.index[Ws + (A - 55296 >> ie)], t = (t << pr) + (A & Er), this.data[t];
        if (A < this.highStart)
          return t = tu - ru + (A >> pn), t = this.index[t], t += A >> ie & iu, t = this.index[t], t = (t << pr) + (A & Er), this.data[t];
        if (A <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, e;
  }()
), mi = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Bu = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var vt = 0; vt < mi.length; vt++)
  Bu[mi.charCodeAt(vt)] = vt;
var cu = 1, vr = 2, mr = 3, Ii = 4, Hi = 5, lu = 7, yi = 8, Ir = 9, Hr = 10, bi = 11, Li = 12, Ti = 13, Ki = 14, yr = 15, uu = function(e) {
  for (var A = [], t = 0, r = e.length; t < r; ) {
    var n = e.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < r) {
      var i = e.charCodeAt(t++);
      (i & 64512) === 56320 ? A.push(((n & 1023) << 10) + (i & 1023) + 65536) : (A.push(n), t--);
    } else
      A.push(n);
  }
  return A;
}, gu = function() {
  for (var e = [], A = 0; A < arguments.length; A++)
    e[A] = arguments[A];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, e);
  var t = e.length;
  if (!t)
    return "";
  for (var r = [], n = -1, i = ""; ++n < t; ) {
    var s = e[n];
    s <= 65535 ? r.push(s) : (s -= 65536, r.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === t || r.length > 16384) && (i += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return i;
}, wu = au(Jl), wA = "×", br = "÷", fu = function(e) {
  return wu.get(e);
}, Qu = function(e, A, t) {
  var r = t - 2, n = A[r], i = A[t - 1], s = A[t];
  if (i === vr && s === mr)
    return wA;
  if (i === vr || i === mr || i === Ii || s === vr || s === mr || s === Ii)
    return br;
  if (i === yi && [yi, Ir, bi, Li].indexOf(s) !== -1 || (i === bi || i === Ir) && (s === Ir || s === Hr) || (i === Li || i === Hr) && s === Hr || s === Ti || s === Hi || s === lu || i === cu)
    return wA;
  if (i === Ti && s === Ki) {
    for (; n === Hi; )
      n = A[--r];
    if (n === Ki)
      return wA;
  }
  if (i === yr && s === yr) {
    for (var a = 0; n === yr; )
      a++, n = A[--r];
    if (a % 2 === 0)
      return wA;
  }
  return br;
}, hu = function(e) {
  var A = uu(e), t = A.length, r = 0, n = 0, i = A.map(fu);
  return {
    next: function() {
      if (r >= t)
        return { done: !0, value: null };
      for (var s = wA; r < t && (s = Qu(A, i, ++r)) === wA; )
        ;
      if (s !== wA || r === t) {
        var a = gu.apply(null, A.slice(n, r));
        return n = r, { value: a, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, Cu = function(e) {
  for (var A = hu(e), t = [], r; !(r = A.next()).done; )
    r.value && t.push(r.value.slice());
  return t;
}, Uu = function(e) {
  var A = 123;
  if (e.createRange) {
    var t = e.createRange();
    if (t.getBoundingClientRect) {
      var r = e.createElement("boundtest");
      r.style.height = A + "px", r.style.display = "block", e.body.appendChild(r), t.selectNode(r);
      var n = t.getBoundingClientRect(), i = Math.round(n.height);
      if (e.body.removeChild(r), i === A)
        return !0;
    }
  }
  return !1;
}, du = function(e) {
  var A = e.createElement("boundtest");
  A.style.width = "50px", A.style.display = "block", A.style.fontSize = "12px", A.style.letterSpacing = "0px", A.style.wordSpacing = "0px", e.body.appendChild(A);
  var t = e.createRange();
  A.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
  var r = A.firstChild, n = jt(r.data).map(function(o) {
    return X(o);
  }), i = 0, s = {}, a = n.every(function(o, B) {
    t.setStart(r, i), t.setEnd(r, i + o.length);
    var l = t.getBoundingClientRect();
    i += o.length;
    var u = l.x > s.x || l.y > s.y;
    return s = l, B === 0 ? !0 : u;
  });
  return e.body.removeChild(A), a;
}, Fu = function() {
  return typeof new Image().crossOrigin < "u";
}, pu = function() {
  return typeof new XMLHttpRequest().responseType == "string";
}, Eu = function(e) {
  var A = new Image(), t = e.createElement("canvas"), r = t.getContext("2d");
  if (!r)
    return !1;
  A.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
  try {
    r.drawImage(A, 0, 0), t.toDataURL();
  } catch {
    return !1;
  }
  return !0;
}, xi = function(e) {
  return e[0] === 0 && e[1] === 255 && e[2] === 0 && e[3] === 255;
}, vu = function(e) {
  var A = e.createElement("canvas"), t = 100;
  A.width = t, A.height = t;
  var r = A.getContext("2d");
  if (!r)
    return Promise.reject(!1);
  r.fillStyle = "rgb(0, 255, 0)", r.fillRect(0, 0, t, t);
  var n = new Image(), i = A.toDataURL();
  n.src = i;
  var s = nn(t, t, 0, 0, n);
  return r.fillStyle = "red", r.fillRect(0, 0, t, t), Si(s).then(function(a) {
    r.drawImage(a, 0, 0);
    var o = r.getImageData(0, 0, t, t).data;
    r.fillStyle = "red", r.fillRect(0, 0, t, t);
    var B = e.createElement("div");
    return B.style.backgroundImage = "url(" + i + ")", B.style.height = t + "px", xi(o) ? Si(nn(t, t, 0, 0, B)) : Promise.reject(!1);
  }).then(function(a) {
    return r.drawImage(a, 0, 0), xi(r.getImageData(0, 0, t, t).data);
  }).catch(function() {
    return !1;
  });
}, nn = function(e, A, t, r, n) {
  var i = "http://www.w3.org/2000/svg", s = document.createElementNS(i, "svg"), a = document.createElementNS(i, "foreignObject");
  return s.setAttributeNS(null, "width", e.toString()), s.setAttributeNS(null, "height", A.toString()), a.setAttributeNS(null, "width", "100%"), a.setAttributeNS(null, "height", "100%"), a.setAttributeNS(null, "x", t.toString()), a.setAttributeNS(null, "y", r.toString()), a.setAttributeNS(null, "externalResourcesRequired", "true"), s.appendChild(a), a.appendChild(n), s;
}, Si = function(e) {
  return new Promise(function(A, t) {
    var r = new Image();
    r.onload = function() {
      return A(r);
    }, r.onerror = t, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(e));
  });
}, $ = {
  get SUPPORT_RANGE_BOUNDS() {
    var e = Uu(document);
    return Object.defineProperty($, "SUPPORT_RANGE_BOUNDS", { value: e }), e;
  },
  get SUPPORT_WORD_BREAKING() {
    var e = $.SUPPORT_RANGE_BOUNDS && du(document);
    return Object.defineProperty($, "SUPPORT_WORD_BREAKING", { value: e }), e;
  },
  get SUPPORT_SVG_DRAWING() {
    var e = Eu(document);
    return Object.defineProperty($, "SUPPORT_SVG_DRAWING", { value: e }), e;
  },
  get SUPPORT_FOREIGNOBJECT_DRAWING() {
    var e = typeof Array.from == "function" && typeof window.fetch == "function" ? vu(document) : Promise.resolve(!1);
    return Object.defineProperty($, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: e }), e;
  },
  get SUPPORT_CORS_IMAGES() {
    var e = Fu();
    return Object.defineProperty($, "SUPPORT_CORS_IMAGES", { value: e }), e;
  },
  get SUPPORT_RESPONSE_TYPE() {
    var e = pu();
    return Object.defineProperty($, "SUPPORT_RESPONSE_TYPE", { value: e }), e;
  },
  get SUPPORT_CORS_XHR() {
    var e = "withCredentials" in new XMLHttpRequest();
    return Object.defineProperty($, "SUPPORT_CORS_XHR", { value: e }), e;
  },
  get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
    var e = !!(typeof Intl < "u" && Intl.Segmenter);
    return Object.defineProperty($, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: e }), e;
  }
}, ke = (
  /** @class */
  function() {
    function e(A, t) {
      this.text = A, this.bounds = t;
    }
    return e;
  }()
), mu = function(e, A, t, r) {
  var n = yu(A, t), i = [], s = 0;
  return n.forEach(function(a) {
    if (t.textDecorationLine.length || a.trim().length > 0)
      if ($.SUPPORT_RANGE_BOUNDS) {
        var o = Di(r, s, a.length).getClientRects();
        if (o.length > 1) {
          var B = En(a), l = 0;
          B.forEach(function(c) {
            i.push(new ke(c, NA.fromDOMRectList(e, Di(r, l + s, c.length).getClientRects()))), l += c.length;
          });
        } else
          i.push(new ke(a, NA.fromDOMRectList(e, o)));
      } else {
        var u = r.splitText(a.length);
        i.push(new ke(a, Iu(e, r))), r = u;
      }
    else
      $.SUPPORT_RANGE_BOUNDS || (r = r.splitText(a.length));
    s += a.length;
  }), i;
}, Iu = function(e, A) {
  var t = A.ownerDocument;
  if (t) {
    var r = t.createElement("html2canvaswrapper");
    r.appendChild(A.cloneNode(!0));
    var n = A.parentNode;
    if (n) {
      n.replaceChild(r, A);
      var i = zt(e, r);
      return r.firstChild && n.replaceChild(r.firstChild, r), i;
    }
  }
  return NA.EMPTY;
}, Di = function(e, A, t) {
  var r = e.ownerDocument;
  if (!r)
    throw new Error("Node has no owner document");
  var n = r.createRange();
  return n.setStart(e, A), n.setEnd(e, A + t), n;
}, En = function(e) {
  if ($.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var A = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    return Array.from(A.segment(e)).map(function(t) {
      return t.segment;
    });
  }
  return Cu(e);
}, Hu = function(e, A) {
  if ($.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var t = new Intl.Segmenter(void 0, {
      granularity: "word"
    });
    return Array.from(t.segment(e)).map(function(r) {
      return r.segment;
    });
  }
  return Lu(e, A);
}, yu = function(e, A) {
  return A.letterSpacing !== 0 ? En(e) : Hu(e, A);
}, bu = [32, 160, 4961, 65792, 65793, 4153, 4241], Lu = function(e, A) {
  for (var t = rB(e, {
    lineBreak: A.lineBreak,
    wordBreak: A.overflowWrap === "break-word" ? "break-word" : A.wordBreak
  }), r = [], n, i = function() {
    if (n.value) {
      var s = n.value.slice(), a = jt(s), o = "";
      a.forEach(function(B) {
        bu.indexOf(B) === -1 ? o += X(B) : (o.length && r.push(o), r.push(X(B)), o = "");
      }), o.length && r.push(o);
    }
  }; !(n = t.next()).done; )
    i();
  return r;
}, Tu = (
  /** @class */
  function() {
    function e(A, t, r) {
      this.text = Ku(t.data, r.textTransform), this.textBounds = mu(A, this.text, r, t);
    }
    return e;
  }()
), Ku = function(e, A) {
  switch (A) {
    case 1:
      return e.toLowerCase();
    case 3:
      return e.replace(xu, Su);
    case 2:
      return e.toUpperCase();
    default:
      return e;
  }
}, xu = /(^|\s|:|-|\(|\))([a-z])/g, Su = function(e, A, t) {
  return e.length > 0 ? A + t.toUpperCase() : e;
}, Ys = (
  /** @class */
  function(e) {
    EA(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.src = r.currentSrc || r.src, n.intrinsicWidth = r.naturalWidth, n.intrinsicHeight = r.naturalHeight, n.context.cache.addImage(n.src), n;
    }
    return A;
  }(DA)
), Zs = (
  /** @class */
  function(e) {
    EA(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.canvas = r, n.intrinsicWidth = r.width, n.intrinsicHeight = r.height, n;
    }
    return A;
  }(DA)
), qs = (
  /** @class */
  function(e) {
    EA(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this, i = new XMLSerializer(), s = zt(t, r);
      return r.setAttribute("width", s.width + "px"), r.setAttribute("height", s.height + "px"), n.svg = "data:image/svg+xml," + encodeURIComponent(i.serializeToString(r)), n.intrinsicWidth = r.width.baseVal.value, n.intrinsicHeight = r.height.baseVal.value, n.context.cache.addImage(n.svg), n;
    }
    return A;
  }(DA)
), zs = (
  /** @class */
  function(e) {
    EA(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.value = r.value, n;
    }
    return A;
  }(DA)
), sn = (
  /** @class */
  function(e) {
    EA(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.start = r.start, n.reversed = typeof r.reversed == "boolean" && r.reversed === !0, n;
    }
    return A;
  }(DA)
), Du = [
  {
    type: 15,
    flags: 0,
    unit: "px",
    number: 3
  }
], Ou = [
  {
    type: 16,
    flags: 0,
    number: 50
  }
], Ru = function(e) {
  return e.width > e.height ? new NA(e.left + (e.width - e.height) / 2, e.top, e.height, e.height) : e.width < e.height ? new NA(e.left, e.top + (e.height - e.width) / 2, e.width, e.width) : e;
}, Mu = function(e) {
  var A = e.type === _u ? new Array(e.value.length + 1).join("•") : e.value;
  return A.length === 0 ? e.placeholder || "" : A;
}, Gt = "checkbox", Nt = "radio", _u = "password", Oi = 707406591, vn = (
  /** @class */
  function(e) {
    EA(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      switch (n.type = r.type.toLowerCase(), n.checked = r.checked, n.value = Mu(r), (n.type === Gt || n.type === Nt) && (n.styles.backgroundColor = 3739148031, n.styles.borderTopColor = n.styles.borderRightColor = n.styles.borderBottomColor = n.styles.borderLeftColor = 2779096575, n.styles.borderTopWidth = n.styles.borderRightWidth = n.styles.borderBottomWidth = n.styles.borderLeftWidth = 1, n.styles.borderTopStyle = n.styles.borderRightStyle = n.styles.borderBottomStyle = n.styles.borderLeftStyle = 1, n.styles.backgroundClip = [
        0
        /* BORDER_BOX */
      ], n.styles.backgroundOrigin = [
        0
        /* BORDER_BOX */
      ], n.bounds = Ru(n.bounds)), n.type) {
        case Gt:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = Du;
          break;
        case Nt:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = Ou;
          break;
      }
      return n;
    }
    return A;
  }(DA)
), js = (
  /** @class */
  function(e) {
    EA(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this, i = r.options[r.selectedIndex || 0];
      return n.value = i && i.text || "", n;
    }
    return A;
  }(DA)
), $s = (
  /** @class */
  function(e) {
    EA(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.value = r.value, n;
    }
    return A;
  }(DA)
), Aa = (
  /** @class */
  function(e) {
    EA(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      n.src = r.src, n.width = parseInt(r.width, 10) || 0, n.height = parseInt(r.height, 10) || 0, n.backgroundColor = n.styles.backgroundColor;
      try {
        if (r.contentWindow && r.contentWindow.document && r.contentWindow.document.documentElement) {
          n.tree = ta(t, r.contentWindow.document.documentElement);
          var i = r.contentWindow.document.documentElement ? Ne(t, getComputedStyle(r.contentWindow.document.documentElement).backgroundColor) : GA.TRANSPARENT, s = r.contentWindow.document.body ? Ne(t, getComputedStyle(r.contentWindow.document.body).backgroundColor) : GA.TRANSPARENT;
          n.backgroundColor = $A(i) ? $A(s) ? n.styles.backgroundColor : s : i;
        }
      } catch {
      }
      return n;
    }
    return A;
  }(DA)
), Gu = ["OL", "UL", "MENU"], Kt = function(e, A, t, r) {
  for (var n = A.firstChild, i = void 0; n; n = i)
    if (i = n.nextSibling, ra(n) && n.data.trim().length > 0)
      t.textNodes.push(new Tu(e, n, t.styles));
    else if (Ce(n))
      if (aa(n) && n.assignedNodes)
        n.assignedNodes().forEach(function(a) {
          return Kt(e, a, t, r);
        });
      else {
        var s = ea(e, n);
        s.styles.isVisible() && (Nu(n, s, r) ? s.flags |= 4 : Pu(s.styles) && (s.flags |= 2), Gu.indexOf(n.tagName) !== -1 && (s.flags |= 8), t.elements.push(s), n.slot, n.shadowRoot ? Kt(e, n.shadowRoot, s, r) : !Pt(n) && !na(n) && !kt(n) && Kt(e, n, s, r));
      }
}, ea = function(e, A) {
  return on(A) ? new Ys(e, A) : ia(A) ? new Zs(e, A) : na(A) ? new qs(e, A) : ku(A) ? new zs(e, A) : Vu(A) ? new sn(e, A) : Xu(A) ? new vn(e, A) : kt(A) ? new js(e, A) : Pt(A) ? new $s(e, A) : sa(A) ? new Aa(e, A) : new DA(e, A);
}, ta = function(e, A) {
  var t = ea(e, A);
  return t.flags |= 4, Kt(e, A, t, t), t;
}, Nu = function(e, A, t) {
  return A.styles.isPositionedWithZIndex() || A.styles.opacity < 1 || A.styles.isTransformed() || mn(e) && t.styles.isTransparent();
}, Pu = function(e) {
  return e.isPositioned() || e.isFloating();
}, ra = function(e) {
  return e.nodeType === Node.TEXT_NODE;
}, Ce = function(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}, an = function(e) {
  return Ce(e) && typeof e.style < "u" && !xt(e);
}, xt = function(e) {
  return typeof e.className == "object";
}, ku = function(e) {
  return e.tagName === "LI";
}, Vu = function(e) {
  return e.tagName === "OL";
}, Xu = function(e) {
  return e.tagName === "INPUT";
}, Ju = function(e) {
  return e.tagName === "HTML";
}, na = function(e) {
  return e.tagName === "svg";
}, mn = function(e) {
  return e.tagName === "BODY";
}, ia = function(e) {
  return e.tagName === "CANVAS";
}, Ri = function(e) {
  return e.tagName === "VIDEO";
}, on = function(e) {
  return e.tagName === "IMG";
}, sa = function(e) {
  return e.tagName === "IFRAME";
}, Mi = function(e) {
  return e.tagName === "STYLE";
}, Wu = function(e) {
  return e.tagName === "SCRIPT";
}, Pt = function(e) {
  return e.tagName === "TEXTAREA";
}, kt = function(e) {
  return e.tagName === "SELECT";
}, aa = function(e) {
  return e.tagName === "SLOT";
}, _i = function(e) {
  return e.tagName.indexOf("-") > 0;
}, Yu = (
  /** @class */
  function() {
    function e() {
      this.counters = {};
    }
    return e.prototype.getCounterValue = function(A) {
      var t = this.counters[A];
      return t && t.length ? t[t.length - 1] : 1;
    }, e.prototype.getCounterValues = function(A) {
      var t = this.counters[A];
      return t || [];
    }, e.prototype.pop = function(A) {
      var t = this;
      A.forEach(function(r) {
        return t.counters[r].pop();
      });
    }, e.prototype.parse = function(A) {
      var t = this, r = A.counterIncrement, n = A.counterReset, i = !0;
      r !== null && r.forEach(function(a) {
        var o = t.counters[a.counter];
        o && a.increment !== 0 && (i = !1, o.length || o.push(1), o[Math.max(0, o.length - 1)] += a.increment);
      });
      var s = [];
      return i && n.forEach(function(a) {
        var o = t.counters[a.counter];
        s.push(a.counter), o || (o = t.counters[a.counter] = []), o.push(a.reset);
      }), s;
    }, e;
  }()
), Gi = {
  integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
  values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
}, Ni = {
  integers: [
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "Ք",
    "Փ",
    "Ւ",
    "Ց",
    "Ր",
    "Տ",
    "Վ",
    "Ս",
    "Ռ",
    "Ջ",
    "Պ",
    "Չ",
    "Ո",
    "Շ",
    "Ն",
    "Յ",
    "Մ",
    "Ճ",
    "Ղ",
    "Ձ",
    "Հ",
    "Կ",
    "Ծ",
    "Խ",
    "Լ",
    "Ի",
    "Ժ",
    "Թ",
    "Ը",
    "Է",
    "Զ",
    "Ե",
    "Դ",
    "Գ",
    "Բ",
    "Ա"
  ]
}, Zu = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    19,
    18,
    17,
    16,
    15,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "י׳",
    "ט׳",
    "ח׳",
    "ז׳",
    "ו׳",
    "ה׳",
    "ד׳",
    "ג׳",
    "ב׳",
    "א׳",
    "ת",
    "ש",
    "ר",
    "ק",
    "צ",
    "פ",
    "ע",
    "ס",
    "נ",
    "מ",
    "ל",
    "כ",
    "יט",
    "יח",
    "יז",
    "טז",
    "טו",
    "י",
    "ט",
    "ח",
    "ז",
    "ו",
    "ה",
    "ד",
    "ג",
    "ב",
    "א"
  ]
}, qu = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "ჵ",
    "ჰ",
    "ჯ",
    "ჴ",
    "ხ",
    "ჭ",
    "წ",
    "ძ",
    "ც",
    "ჩ",
    "შ",
    "ყ",
    "ღ",
    "ქ",
    "ფ",
    "ჳ",
    "ტ",
    "ს",
    "რ",
    "ჟ",
    "პ",
    "ო",
    "ჲ",
    "ნ",
    "მ",
    "ლ",
    "კ",
    "ი",
    "თ",
    "ჱ",
    "ზ",
    "ვ",
    "ე",
    "დ",
    "გ",
    "ბ",
    "ა"
  ]
}, ue = function(e, A, t, r, n, i) {
  return e < A || e > t ? Ze(e, n, i.length > 0) : r.integers.reduce(function(s, a, o) {
    for (; e >= a; )
      e -= a, s += r.values[o];
    return s;
  }, "") + i;
}, oa = function(e, A, t, r) {
  var n = "";
  do
    t || e--, n = r(e) + n, e /= A;
  while (e * A >= A);
  return n;
}, V = function(e, A, t, r, n) {
  var i = t - A + 1;
  return (e < 0 ? "-" : "") + (oa(Math.abs(e), i, r, function(s) {
    return X(Math.floor(s % i) + A);
  }) + n);
}, ee = function(e, A, t) {
  t === void 0 && (t = ". ");
  var r = A.length;
  return oa(Math.abs(e), r, !1, function(n) {
    return A[Math.floor(n % r)];
  }) + t;
}, fe = 1, XA = 2, JA = 4, Me = 8, MA = function(e, A, t, r, n, i) {
  if (e < -9999 || e > 9999)
    return Ze(e, 4, n.length > 0);
  var s = Math.abs(e), a = n;
  if (s === 0)
    return A[0] + a;
  for (var o = 0; s > 0 && o <= 4; o++) {
    var B = s % 10;
    B === 0 && Z(i, fe) && a !== "" ? a = A[B] + a : B > 1 || B === 1 && o === 0 || B === 1 && o === 1 && Z(i, XA) || B === 1 && o === 1 && Z(i, JA) && e > 100 || B === 1 && o > 1 && Z(i, Me) ? a = A[B] + (o > 0 ? t[o - 1] : "") + a : B === 1 && o > 0 && (a = t[o - 1] + a), s = Math.floor(s / 10);
  }
  return (e < 0 ? r : "") + a;
}, Pi = "十百千萬", ki = "拾佰仟萬", Vi = "マイナス", Lr = "마이너스", Ze = function(e, A, t) {
  var r = t ? ". " : "", n = t ? "、" : "", i = t ? ", " : "", s = t ? " " : "";
  switch (A) {
    case 0:
      return "•" + s;
    case 1:
      return "◦" + s;
    case 2:
      return "◾" + s;
    case 5:
      var a = V(e, 48, 57, !0, r);
      return a.length < 4 ? "0" + a : a;
    case 4:
      return ee(e, "〇一二三四五六七八九", n);
    case 6:
      return ue(e, 1, 3999, Gi, 3, r).toLowerCase();
    case 7:
      return ue(e, 1, 3999, Gi, 3, r);
    case 8:
      return V(e, 945, 969, !1, r);
    case 9:
      return V(e, 97, 122, !1, r);
    case 10:
      return V(e, 65, 90, !1, r);
    case 11:
      return V(e, 1632, 1641, !0, r);
    case 12:
    case 49:
      return ue(e, 1, 9999, Ni, 3, r);
    case 35:
      return ue(e, 1, 9999, Ni, 3, r).toLowerCase();
    case 13:
      return V(e, 2534, 2543, !0, r);
    case 14:
    case 30:
      return V(e, 6112, 6121, !0, r);
    case 15:
      return ee(e, "子丑寅卯辰巳午未申酉戌亥", n);
    case 16:
      return ee(e, "甲乙丙丁戊己庚辛壬癸", n);
    case 17:
    case 48:
      return MA(e, "零一二三四五六七八九", Pi, "負", n, XA | JA | Me);
    case 47:
      return MA(e, "零壹貳參肆伍陸柒捌玖", ki, "負", n, fe | XA | JA | Me);
    case 42:
      return MA(e, "零一二三四五六七八九", Pi, "负", n, XA | JA | Me);
    case 41:
      return MA(e, "零壹贰叁肆伍陆柒捌玖", ki, "负", n, fe | XA | JA | Me);
    case 26:
      return MA(e, "〇一二三四五六七八九", "十百千万", Vi, n, 0);
    case 25:
      return MA(e, "零壱弐参四伍六七八九", "拾百千万", Vi, n, fe | XA | JA);
    case 31:
      return MA(e, "영일이삼사오육칠팔구", "십백천만", Lr, i, fe | XA | JA);
    case 33:
      return MA(e, "零一二三四五六七八九", "十百千萬", Lr, i, 0);
    case 32:
      return MA(e, "零壹貳參四五六七八九", "拾百千", Lr, i, fe | XA | JA);
    case 18:
      return V(e, 2406, 2415, !0, r);
    case 20:
      return ue(e, 1, 19999, qu, 3, r);
    case 21:
      return V(e, 2790, 2799, !0, r);
    case 22:
      return V(e, 2662, 2671, !0, r);
    case 22:
      return ue(e, 1, 10999, Zu, 3, r);
    case 23:
      return ee(e, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
    case 24:
      return ee(e, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
    case 27:
      return V(e, 3302, 3311, !0, r);
    case 28:
      return ee(e, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", n);
    case 29:
      return ee(e, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", n);
    case 34:
      return V(e, 3792, 3801, !0, r);
    case 37:
      return V(e, 6160, 6169, !0, r);
    case 38:
      return V(e, 4160, 4169, !0, r);
    case 39:
      return V(e, 2918, 2927, !0, r);
    case 40:
      return V(e, 1776, 1785, !0, r);
    case 43:
      return V(e, 3046, 3055, !0, r);
    case 44:
      return V(e, 3174, 3183, !0, r);
    case 45:
      return V(e, 3664, 3673, !0, r);
    case 46:
      return V(e, 3872, 3881, !0, r);
    case 3:
    default:
      return V(e, 48, 57, !0, r);
  }
}, Ba = "data-html2canvas-ignore", Xi = (
  /** @class */
  function() {
    function e(A, t, r) {
      if (this.context = A, this.options = r, this.scrolledElements = [], this.referenceElement = t, this.counters = new Yu(), this.quoteDepth = 0, !t.ownerDocument)
        throw new Error("Cloned element does not have an owner document");
      this.documentElement = this.cloneNode(t.ownerDocument.documentElement, !1);
    }
    return e.prototype.toIFrame = function(A, t) {
      var r = this, n = zu(A, t);
      if (!n.contentWindow)
        return Promise.reject("Unable to find iframe window");
      var i = A.defaultView.pageXOffset, s = A.defaultView.pageYOffset, a = n.contentWindow, o = a.document, B = Ag(n).then(function() {
        return nA(r, void 0, void 0, function() {
          var l, u;
          return tA(this, function(c) {
            switch (c.label) {
              case 0:
                return this.scrolledElements.forEach(ng), a && (a.scrollTo(t.left, t.top), /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (a.scrollY !== t.top || a.scrollX !== t.left) && (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(a.scrollX - t.left, a.scrollY - t.top, 0, 0))), l = this.options.onclone, u = this.clonedReferenceElement, typeof u > "u" ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : o.fonts && o.fonts.ready ? [4, o.fonts.ready] : [3, 2];
              case 1:
                c.sent(), c.label = 2;
              case 2:
                return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, $u(o)] : [3, 4];
              case 3:
                c.sent(), c.label = 4;
              case 4:
                return typeof l == "function" ? [2, Promise.resolve().then(function() {
                  return l(o, u);
                }).then(function() {
                  return n;
                })] : [2, n];
            }
          });
        });
      });
      return o.open(), o.write(tg(document.doctype) + "<html></html>"), rg(this.referenceElement.ownerDocument, i, s), o.replaceChild(o.adoptNode(this.documentElement), o.documentElement), o.close(), B;
    }, e.prototype.createElementClone = function(A) {
      if (rn(
        A,
        2
        /* CLONE */
      ))
        debugger;
      if (ia(A))
        return this.createCanvasClone(A);
      if (Ri(A))
        return this.createVideoClone(A);
      if (Mi(A))
        return this.createStyleClone(A);
      var t = A.cloneNode(!1);
      return on(t) && (on(A) && A.currentSrc && A.currentSrc !== A.src && (t.src = A.currentSrc, t.srcset = ""), t.loading === "lazy" && (t.loading = "eager")), _i(t) ? this.createCustomElementClone(t) : t;
    }, e.prototype.createCustomElementClone = function(A) {
      var t = document.createElement("html2canvascustomelement");
      return Tr(A.style, t), t;
    }, e.prototype.createStyleClone = function(A) {
      try {
        var t = A.sheet;
        if (t && t.cssRules) {
          var r = [].slice.call(t.cssRules, 0).reduce(function(i, s) {
            return s && typeof s.cssText == "string" ? i + s.cssText : i;
          }, ""), n = A.cloneNode(!1);
          return n.textContent = r, n;
        }
      } catch (i) {
        if (this.context.logger.error("Unable to access cssRules property", i), i.name !== "SecurityError")
          throw i;
      }
      return A.cloneNode(!1);
    }, e.prototype.createCanvasClone = function(A) {
      var t;
      if (this.options.inlineImages && A.ownerDocument) {
        var r = A.ownerDocument.createElement("img");
        try {
          return r.src = A.toDataURL(), r;
        } catch {
          this.context.logger.info("Unable to inline canvas contents, canvas is tainted", A);
        }
      }
      var n = A.cloneNode(!1);
      try {
        n.width = A.width, n.height = A.height;
        var i = A.getContext("2d"), s = n.getContext("2d");
        if (s)
          if (!this.options.allowTaint && i)
            s.putImageData(i.getImageData(0, 0, A.width, A.height), 0, 0);
          else {
            var a = (t = A.getContext("webgl2")) !== null && t !== void 0 ? t : A.getContext("webgl");
            if (a) {
              var o = a.getContextAttributes();
              (o == null ? void 0 : o.preserveDrawingBuffer) === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", A);
            }
            s.drawImage(A, 0, 0);
          }
        return n;
      } catch {
        this.context.logger.info("Unable to clone canvas as it is tainted", A);
      }
      return n;
    }, e.prototype.createVideoClone = function(A) {
      var t = A.ownerDocument.createElement("canvas");
      t.width = A.offsetWidth, t.height = A.offsetHeight;
      var r = t.getContext("2d");
      try {
        return r && (r.drawImage(A, 0, 0, t.width, t.height), this.options.allowTaint || r.getImageData(0, 0, t.width, t.height)), t;
      } catch {
        this.context.logger.info("Unable to clone video as it is tainted", A);
      }
      var n = A.ownerDocument.createElement("canvas");
      return n.width = A.offsetWidth, n.height = A.offsetHeight, n;
    }, e.prototype.appendChildNode = function(A, t, r) {
      (!Ce(t) || !Wu(t) && !t.hasAttribute(Ba) && (typeof this.options.ignoreElements != "function" || !this.options.ignoreElements(t))) && (!this.options.copyStyles || !Ce(t) || !Mi(t)) && A.appendChild(this.cloneNode(t, r));
    }, e.prototype.cloneChildNodes = function(A, t, r) {
      for (var n = this, i = A.shadowRoot ? A.shadowRoot.firstChild : A.firstChild; i; i = i.nextSibling)
        if (Ce(i) && aa(i) && typeof i.assignedNodes == "function") {
          var s = i.assignedNodes();
          s.length && s.forEach(function(a) {
            return n.appendChildNode(t, a, r);
          });
        } else
          this.appendChildNode(t, i, r);
    }, e.prototype.cloneNode = function(A, t) {
      if (ra(A))
        return document.createTextNode(A.data);
      if (!A.ownerDocument)
        return A.cloneNode(!1);
      var r = A.ownerDocument.defaultView;
      if (r && Ce(A) && (an(A) || xt(A))) {
        var n = this.createElementClone(A);
        n.style.transitionProperty = "none";
        var i = r.getComputedStyle(A), s = r.getComputedStyle(A, ":before"), a = r.getComputedStyle(A, ":after");
        this.referenceElement === A && an(n) && (this.clonedReferenceElement = n), mn(n) && ag(n);
        var o = this.counters.parse(new pi(this.context, i)), B = this.resolvePseudoContent(A, n, s, Ve.BEFORE);
        _i(A) && (t = !0), Ri(A) || this.cloneChildNodes(A, n, t), B && n.insertBefore(B, n.firstChild);
        var l = this.resolvePseudoContent(A, n, a, Ve.AFTER);
        return l && n.appendChild(l), this.counters.pop(o), (i && (this.options.copyStyles || xt(A)) && !sa(A) || t) && Tr(i, n), (A.scrollTop !== 0 || A.scrollLeft !== 0) && this.scrolledElements.push([n, A.scrollLeft, A.scrollTop]), (Pt(A) || kt(A)) && (Pt(n) || kt(n)) && (n.value = A.value), n;
      }
      return A.cloneNode(!1);
    }, e.prototype.resolvePseudoContent = function(A, t, r, n) {
      var i = this;
      if (r) {
        var s = r.content, a = t.ownerDocument;
        if (!(!a || !s || s === "none" || s === "-moz-alt-content" || r.display === "none")) {
          this.counters.parse(new pi(this.context, r));
          var o = new kl(this.context, r), B = a.createElement("html2canvaspseudoelement");
          Tr(r, B), o.content.forEach(function(u) {
            if (u.type === 0)
              B.appendChild(a.createTextNode(u.value));
            else if (u.type === 22) {
              var c = a.createElement("img");
              c.src = u.value, c.style.opacity = "1", B.appendChild(c);
            } else if (u.type === 18) {
              if (u.name === "attr") {
                var f = u.values.filter(M);
                f.length && B.appendChild(a.createTextNode(A.getAttribute(f[0].value) || ""));
              } else if (u.name === "counter") {
                var g = u.values.filter(de), w = g[0], Q = g[1];
                if (w && M(w)) {
                  var d = i.counters.getCounterValue(w.value), p = Q && M(Q) ? tn.parse(i.context, Q.value) : 3;
                  B.appendChild(a.createTextNode(Ze(d, p, !1)));
                }
              } else if (u.name === "counters") {
                var E = u.values.filter(de), w = E[0], U = E[1], Q = E[2];
                if (w && M(w)) {
                  var m = i.counters.getCounterValues(w.value), C = Q && M(Q) ? tn.parse(i.context, Q.value) : 3, L = U && U.type === 0 ? U.value : "", T = m.map(function(z) {
                    return Ze(z, C, !1);
                  }).join(L);
                  B.appendChild(a.createTextNode(T));
                }
              }
            } else if (u.type === 20)
              switch (u.value) {
                case "open-quote":
                  B.appendChild(a.createTextNode(Fi(o.quotes, i.quoteDepth++, !0)));
                  break;
                case "close-quote":
                  B.appendChild(a.createTextNode(Fi(o.quotes, --i.quoteDepth, !1)));
                  break;
                default:
                  B.appendChild(a.createTextNode(u.value));
              }
          }), B.className = Bn + " " + cn;
          var l = n === Ve.BEFORE ? " " + Bn : " " + cn;
          return xt(t) ? t.className.baseValue += l : t.className += l, B;
        }
      }
    }, e.destroy = function(A) {
      return A.parentNode ? (A.parentNode.removeChild(A), !0) : !1;
    }, e;
  }()
), Ve;
(function(e) {
  e[e.BEFORE = 0] = "BEFORE", e[e.AFTER = 1] = "AFTER";
})(Ve || (Ve = {}));
var zu = function(e, A) {
  var t = e.createElement("iframe");
  return t.className = "html2canvas-container", t.style.visibility = "hidden", t.style.position = "fixed", t.style.left = "-10000px", t.style.top = "0px", t.style.border = "0", t.width = A.width.toString(), t.height = A.height.toString(), t.scrolling = "no", t.setAttribute(Ba, "true"), e.body.appendChild(t), t;
}, ju = function(e) {
  return new Promise(function(A) {
    if (e.complete) {
      A();
      return;
    }
    if (!e.src) {
      A();
      return;
    }
    e.onload = A, e.onerror = A;
  });
}, $u = function(e) {
  return Promise.all([].slice.call(e.images, 0).map(ju));
}, Ag = function(e) {
  return new Promise(function(A, t) {
    var r = e.contentWindow;
    if (!r)
      return t("No window assigned for iframe");
    var n = r.document;
    r.onload = e.onload = function() {
      r.onload = e.onload = null;
      var i = setInterval(function() {
        n.body.childNodes.length > 0 && n.readyState === "complete" && (clearInterval(i), A(e));
      }, 50);
    };
  });
}, eg = [
  "all",
  "d",
  "content"
  // Safari shows pseudoelements if content is set
], Tr = function(e, A) {
  for (var t = e.length - 1; t >= 0; t--) {
    var r = e.item(t);
    eg.indexOf(r) === -1 && A.style.setProperty(r, e.getPropertyValue(r));
  }
  return A;
}, tg = function(e) {
  var A = "";
  return e && (A += "<!DOCTYPE ", e.name && (A += e.name), e.internalSubset && (A += e.internalSubset), e.publicId && (A += '"' + e.publicId + '"'), e.systemId && (A += '"' + e.systemId + '"'), A += ">"), A;
}, rg = function(e, A, t) {
  e && e.defaultView && (A !== e.defaultView.pageXOffset || t !== e.defaultView.pageYOffset) && e.defaultView.scrollTo(A, t);
}, ng = function(e) {
  var A = e[0], t = e[1], r = e[2];
  A.scrollLeft = t, A.scrollTop = r;
}, ig = ":before", sg = ":after", Bn = "___html2canvas___pseudoelement_before", cn = "___html2canvas___pseudoelement_after", Ji = `{
    content: "" !important;
    display: none !important;
}`, ag = function(e) {
  og(e, "." + Bn + ig + Ji + `
         .` + cn + sg + Ji);
}, og = function(e, A) {
  var t = e.ownerDocument;
  if (t) {
    var r = t.createElement("style");
    r.textContent = A, e.appendChild(r);
  }
}, ca = (
  /** @class */
  function() {
    function e() {
    }
    return e.getOrigin = function(A) {
      var t = e._link;
      return t ? (t.href = A, t.href = t.href, t.protocol + t.hostname + t.port) : "about:blank";
    }, e.isSameOrigin = function(A) {
      return e.getOrigin(A) === e._origin;
    }, e.setContext = function(A) {
      e._link = A.document.createElement("a"), e._origin = e.getOrigin(A.location.href);
    }, e._origin = "about:blank", e;
  }()
), Bg = (
  /** @class */
  function() {
    function e(A, t) {
      this.context = A, this._options = t, this._cache = {};
    }
    return e.prototype.addImage = function(A) {
      var t = Promise.resolve();
      return this.has(A) || (xr(A) || gg(A)) && (this._cache[A] = this.loadImage(A)).catch(function() {
      }), t;
    }, e.prototype.match = function(A) {
      return this._cache[A];
    }, e.prototype.loadImage = function(A) {
      return nA(this, void 0, void 0, function() {
        var t, r, n, i, s = this;
        return tA(this, function(a) {
          switch (a.label) {
            case 0:
              return t = ca.isSameOrigin(A), r = !Kr(A) && this._options.useCORS === !0 && $.SUPPORT_CORS_IMAGES && !t, n = !Kr(A) && !t && !xr(A) && typeof this._options.proxy == "string" && $.SUPPORT_CORS_XHR && !r, !t && this._options.allowTaint === !1 && !Kr(A) && !xr(A) && !n && !r ? [
                2
                /*return*/
              ] : (i = A, n ? [4, this.proxy(i)] : [3, 2]);
            case 1:
              i = a.sent(), a.label = 2;
            case 2:
              return this.context.logger.debug("Added image " + A.substring(0, 256)), [4, new Promise(function(o, B) {
                var l = new Image();
                l.onload = function() {
                  return o(l);
                }, l.onerror = B, (wg(i) || r) && (l.crossOrigin = "anonymous"), l.src = i, l.complete === !0 && setTimeout(function() {
                  return o(l);
                }, 500), s._options.imageTimeout > 0 && setTimeout(function() {
                  return B("Timed out (" + s._options.imageTimeout + "ms) loading image");
                }, s._options.imageTimeout);
              })];
            case 3:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.has = function(A) {
      return typeof this._cache[A] < "u";
    }, e.prototype.keys = function() {
      return Promise.resolve(Object.keys(this._cache));
    }, e.prototype.proxy = function(A) {
      var t = this, r = this._options.proxy;
      if (!r)
        throw new Error("No proxy defined");
      var n = A.substring(0, 256);
      return new Promise(function(i, s) {
        var a = $.SUPPORT_RESPONSE_TYPE ? "blob" : "text", o = new XMLHttpRequest();
        o.onload = function() {
          if (o.status === 200)
            if (a === "text")
              i(o.response);
            else {
              var u = new FileReader();
              u.addEventListener("load", function() {
                return i(u.result);
              }, !1), u.addEventListener("error", function(c) {
                return s(c);
              }, !1), u.readAsDataURL(o.response);
            }
          else
            s("Failed to proxy resource " + n + " with status code " + o.status);
        }, o.onerror = s;
        var B = r.indexOf("?") > -1 ? "&" : "?";
        if (o.open("GET", "" + r + B + "url=" + encodeURIComponent(A) + "&responseType=" + a), a !== "text" && o instanceof XMLHttpRequest && (o.responseType = a), t._options.imageTimeout) {
          var l = t._options.imageTimeout;
          o.timeout = l, o.ontimeout = function() {
            return s("Timed out (" + l + "ms) proxying " + n);
          };
        }
        o.send();
      });
    }, e;
  }()
), cg = /^data:image\/svg\+xml/i, lg = /^data:image\/.*;base64,/i, ug = /^data:image\/.*/i, gg = function(e) {
  return $.SUPPORT_SVG_DRAWING || !fg(e);
}, Kr = function(e) {
  return ug.test(e);
}, wg = function(e) {
  return lg.test(e);
}, xr = function(e) {
  return e.substr(0, 4) === "blob";
}, fg = function(e) {
  return e.substr(-3).toLowerCase() === "svg" || cg.test(e);
}, F = (
  /** @class */
  function() {
    function e(A, t) {
      this.type = 0, this.x = A, this.y = t;
    }
    return e.prototype.add = function(A, t) {
      return new e(this.x + A, this.y + t);
    }, e;
  }()
), ge = function(e, A, t) {
  return new F(e.x + (A.x - e.x) * t, e.y + (A.y - e.y) * t);
}, mt = (
  /** @class */
  function() {
    function e(A, t, r, n) {
      this.type = 1, this.start = A, this.startControl = t, this.endControl = r, this.end = n;
    }
    return e.prototype.subdivide = function(A, t) {
      var r = ge(this.start, this.startControl, A), n = ge(this.startControl, this.endControl, A), i = ge(this.endControl, this.end, A), s = ge(r, n, A), a = ge(n, i, A), o = ge(s, a, A);
      return t ? new e(this.start, r, s, o) : new e(o, a, i, this.end);
    }, e.prototype.add = function(A, t) {
      return new e(this.start.add(A, t), this.startControl.add(A, t), this.endControl.add(A, t), this.end.add(A, t));
    }, e.prototype.reverse = function() {
      return new e(this.end, this.endControl, this.startControl, this.start);
    }, e;
  }()
), fA = function(e) {
  return e.type === 1;
}, Qg = (
  /** @class */
  function() {
    function e(A) {
      var t = A.styles, r = A.bounds, n = Oe(t.borderTopLeftRadius, r.width, r.height), i = n[0], s = n[1], a = Oe(t.borderTopRightRadius, r.width, r.height), o = a[0], B = a[1], l = Oe(t.borderBottomRightRadius, r.width, r.height), u = l[0], c = l[1], f = Oe(t.borderBottomLeftRadius, r.width, r.height), g = f[0], w = f[1], Q = [];
      Q.push((i + o) / r.width), Q.push((g + u) / r.width), Q.push((s + w) / r.height), Q.push((B + c) / r.height);
      var d = Math.max.apply(Math, Q);
      d > 1 && (i /= d, s /= d, o /= d, B /= d, u /= d, c /= d, g /= d, w /= d);
      var p = r.width - o, E = r.height - c, U = r.width - u, m = r.height - w, C = t.borderTopWidth, L = t.borderRightWidth, T = t.borderBottomWidth, H = t.borderLeftWidth, _ = N(t.paddingTop, A.bounds.width), z = N(t.paddingRight, A.bounds.width), eA = N(t.paddingBottom, A.bounds.width), K = N(t.paddingLeft, A.bounds.width);
      this.topLeftBorderDoubleOuterBox = i > 0 || s > 0 ? P(r.left + H / 3, r.top + C / 3, i - H / 3, s - C / 3, O.TOP_LEFT) : new F(r.left + H / 3, r.top + C / 3), this.topRightBorderDoubleOuterBox = i > 0 || s > 0 ? P(r.left + p, r.top + C / 3, o - L / 3, B - C / 3, O.TOP_RIGHT) : new F(r.left + r.width - L / 3, r.top + C / 3), this.bottomRightBorderDoubleOuterBox = u > 0 || c > 0 ? P(r.left + U, r.top + E, u - L / 3, c - T / 3, O.BOTTOM_RIGHT) : new F(r.left + r.width - L / 3, r.top + r.height - T / 3), this.bottomLeftBorderDoubleOuterBox = g > 0 || w > 0 ? P(r.left + H / 3, r.top + m, g - H / 3, w - T / 3, O.BOTTOM_LEFT) : new F(r.left + H / 3, r.top + r.height - T / 3), this.topLeftBorderDoubleInnerBox = i > 0 || s > 0 ? P(r.left + H * 2 / 3, r.top + C * 2 / 3, i - H * 2 / 3, s - C * 2 / 3, O.TOP_LEFT) : new F(r.left + H * 2 / 3, r.top + C * 2 / 3), this.topRightBorderDoubleInnerBox = i > 0 || s > 0 ? P(r.left + p, r.top + C * 2 / 3, o - L * 2 / 3, B - C * 2 / 3, O.TOP_RIGHT) : new F(r.left + r.width - L * 2 / 3, r.top + C * 2 / 3), this.bottomRightBorderDoubleInnerBox = u > 0 || c > 0 ? P(r.left + U, r.top + E, u - L * 2 / 3, c - T * 2 / 3, O.BOTTOM_RIGHT) : new F(r.left + r.width - L * 2 / 3, r.top + r.height - T * 2 / 3), this.bottomLeftBorderDoubleInnerBox = g > 0 || w > 0 ? P(r.left + H * 2 / 3, r.top + m, g - H * 2 / 3, w - T * 2 / 3, O.BOTTOM_LEFT) : new F(r.left + H * 2 / 3, r.top + r.height - T * 2 / 3), this.topLeftBorderStroke = i > 0 || s > 0 ? P(r.left + H / 2, r.top + C / 2, i - H / 2, s - C / 2, O.TOP_LEFT) : new F(r.left + H / 2, r.top + C / 2), this.topRightBorderStroke = i > 0 || s > 0 ? P(r.left + p, r.top + C / 2, o - L / 2, B - C / 2, O.TOP_RIGHT) : new F(r.left + r.width - L / 2, r.top + C / 2), this.bottomRightBorderStroke = u > 0 || c > 0 ? P(r.left + U, r.top + E, u - L / 2, c - T / 2, O.BOTTOM_RIGHT) : new F(r.left + r.width - L / 2, r.top + r.height - T / 2), this.bottomLeftBorderStroke = g > 0 || w > 0 ? P(r.left + H / 2, r.top + m, g - H / 2, w - T / 2, O.BOTTOM_LEFT) : new F(r.left + H / 2, r.top + r.height - T / 2), this.topLeftBorderBox = i > 0 || s > 0 ? P(r.left, r.top, i, s, O.TOP_LEFT) : new F(r.left, r.top), this.topRightBorderBox = o > 0 || B > 0 ? P(r.left + p, r.top, o, B, O.TOP_RIGHT) : new F(r.left + r.width, r.top), this.bottomRightBorderBox = u > 0 || c > 0 ? P(r.left + U, r.top + E, u, c, O.BOTTOM_RIGHT) : new F(r.left + r.width, r.top + r.height), this.bottomLeftBorderBox = g > 0 || w > 0 ? P(r.left, r.top + m, g, w, O.BOTTOM_LEFT) : new F(r.left, r.top + r.height), this.topLeftPaddingBox = i > 0 || s > 0 ? P(r.left + H, r.top + C, Math.max(0, i - H), Math.max(0, s - C), O.TOP_LEFT) : new F(r.left + H, r.top + C), this.topRightPaddingBox = o > 0 || B > 0 ? P(r.left + Math.min(p, r.width - L), r.top + C, p > r.width + L ? 0 : Math.max(0, o - L), Math.max(0, B - C), O.TOP_RIGHT) : new F(r.left + r.width - L, r.top + C), this.bottomRightPaddingBox = u > 0 || c > 0 ? P(r.left + Math.min(U, r.width - H), r.top + Math.min(E, r.height - T), Math.max(0, u - L), Math.max(0, c - T), O.BOTTOM_RIGHT) : new F(r.left + r.width - L, r.top + r.height - T), this.bottomLeftPaddingBox = g > 0 || w > 0 ? P(r.left + H, r.top + Math.min(m, r.height - T), Math.max(0, g - H), Math.max(0, w - T), O.BOTTOM_LEFT) : new F(r.left + H, r.top + r.height - T), this.topLeftContentBox = i > 0 || s > 0 ? P(r.left + H + K, r.top + C + _, Math.max(0, i - (H + K)), Math.max(0, s - (C + _)), O.TOP_LEFT) : new F(r.left + H + K, r.top + C + _), this.topRightContentBox = o > 0 || B > 0 ? P(r.left + Math.min(p, r.width + H + K), r.top + C + _, p > r.width + H + K ? 0 : o - H + K, B - (C + _), O.TOP_RIGHT) : new F(r.left + r.width - (L + z), r.top + C + _), this.bottomRightContentBox = u > 0 || c > 0 ? P(r.left + Math.min(U, r.width - (H + K)), r.top + Math.min(E, r.height + C + _), Math.max(0, u - (L + z)), c - (T + eA), O.BOTTOM_RIGHT) : new F(r.left + r.width - (L + z), r.top + r.height - (T + eA)), this.bottomLeftContentBox = g > 0 || w > 0 ? P(r.left + H + K, r.top + m, Math.max(0, g - (H + K)), w - (T + eA), O.BOTTOM_LEFT) : new F(r.left + H + K, r.top + r.height - (T + eA));
    }
    return e;
  }()
), O;
(function(e) {
  e[e.TOP_LEFT = 0] = "TOP_LEFT", e[e.TOP_RIGHT = 1] = "TOP_RIGHT", e[e.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", e[e.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
})(O || (O = {}));
var P = function(e, A, t, r, n) {
  var i = 4 * ((Math.sqrt(2) - 1) / 3), s = t * i, a = r * i, o = e + t, B = A + r;
  switch (n) {
    case O.TOP_LEFT:
      return new mt(new F(e, B), new F(e, B - a), new F(o - s, A), new F(o, A));
    case O.TOP_RIGHT:
      return new mt(new F(e, A), new F(e + s, A), new F(o, B - a), new F(o, B));
    case O.BOTTOM_RIGHT:
      return new mt(new F(o, A), new F(o, A + a), new F(e + s, B), new F(e, B));
    case O.BOTTOM_LEFT:
    default:
      return new mt(new F(o, B), new F(o - s, B), new F(e, A + a), new F(e, A));
  }
}, Vt = function(e) {
  return [e.topLeftBorderBox, e.topRightBorderBox, e.bottomRightBorderBox, e.bottomLeftBorderBox];
}, hg = function(e) {
  return [
    e.topLeftContentBox,
    e.topRightContentBox,
    e.bottomRightContentBox,
    e.bottomLeftContentBox
  ];
}, Xt = function(e) {
  return [
    e.topLeftPaddingBox,
    e.topRightPaddingBox,
    e.bottomRightPaddingBox,
    e.bottomLeftPaddingBox
  ];
}, Cg = (
  /** @class */
  function() {
    function e(A, t, r) {
      this.offsetX = A, this.offsetY = t, this.matrix = r, this.type = 0, this.target = 6;
    }
    return e;
  }()
), It = (
  /** @class */
  function() {
    function e(A, t) {
      this.path = A, this.target = t, this.type = 1;
    }
    return e;
  }()
), Ug = (
  /** @class */
  function() {
    function e(A) {
      this.opacity = A, this.type = 2, this.target = 6;
    }
    return e;
  }()
), dg = function(e) {
  return e.type === 0;
}, la = function(e) {
  return e.type === 1;
}, Fg = function(e) {
  return e.type === 2;
}, Wi = function(e, A) {
  return e.length === A.length ? e.some(function(t, r) {
    return t === A[r];
  }) : !1;
}, pg = function(e, A, t, r, n) {
  return e.map(function(i, s) {
    switch (s) {
      case 0:
        return i.add(A, t);
      case 1:
        return i.add(A + r, t);
      case 2:
        return i.add(A + r, t + n);
      case 3:
        return i.add(A, t + n);
    }
    return i;
  });
}, ua = (
  /** @class */
  function() {
    function e(A) {
      this.element = A, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
    }
    return e;
  }()
), ga = (
  /** @class */
  function() {
    function e(A, t) {
      if (this.container = A, this.parent = t, this.effects = [], this.curves = new Qg(this.container), this.container.styles.opacity < 1 && this.effects.push(new Ug(this.container.styles.opacity)), this.container.styles.transform !== null) {
        var r = this.container.bounds.left + this.container.styles.transformOrigin[0].number, n = this.container.bounds.top + this.container.styles.transformOrigin[1].number, i = this.container.styles.transform;
        this.effects.push(new Cg(r, n, i));
      }
      if (this.container.styles.overflowX !== 0) {
        var s = Vt(this.curves), a = Xt(this.curves);
        Wi(s, a) ? this.effects.push(new It(
          s,
          6
          /* CONTENT */
        )) : (this.effects.push(new It(
          s,
          2
          /* BACKGROUND_BORDERS */
        )), this.effects.push(new It(
          a,
          4
          /* CONTENT */
        )));
      }
    }
    return e.prototype.getEffects = function(A) {
      for (var t = [
        2,
        3
        /* FIXED */
      ].indexOf(this.container.styles.position) === -1, r = this.parent, n = this.effects.slice(0); r; ) {
        var i = r.effects.filter(function(o) {
          return !la(o);
        });
        if (t || r.container.styles.position !== 0 || !r.parent) {
          if (n.unshift.apply(n, i), t = [
            2,
            3
            /* FIXED */
          ].indexOf(r.container.styles.position) === -1, r.container.styles.overflowX !== 0) {
            var s = Vt(r.curves), a = Xt(r.curves);
            Wi(s, a) || n.unshift(new It(
              a,
              6
              /* CONTENT */
            ));
          }
        } else
          n.unshift.apply(n, i);
        r = r.parent;
      }
      return n.filter(function(o) {
        return Z(o.target, A);
      });
    }, e;
  }()
), ln = function(e, A, t, r) {
  e.container.elements.forEach(function(n) {
    var i = Z(
      n.flags,
      4
      /* CREATES_REAL_STACKING_CONTEXT */
    ), s = Z(
      n.flags,
      2
      /* CREATES_STACKING_CONTEXT */
    ), a = new ga(n, e);
    Z(
      n.styles.display,
      2048
      /* LIST_ITEM */
    ) && r.push(a);
    var o = Z(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) ? [] : r;
    if (i || s) {
      var B = i || n.styles.isPositioned() ? t : A, l = new ua(a);
      if (n.styles.isPositioned() || n.styles.opacity < 1 || n.styles.isTransformed()) {
        var u = n.styles.zIndex.order;
        if (u < 0) {
          var c = 0;
          B.negativeZIndex.some(function(g, w) {
            return u > g.element.container.styles.zIndex.order ? (c = w, !1) : c > 0;
          }), B.negativeZIndex.splice(c, 0, l);
        } else if (u > 0) {
          var f = 0;
          B.positiveZIndex.some(function(g, w) {
            return u >= g.element.container.styles.zIndex.order ? (f = w + 1, !1) : f > 0;
          }), B.positiveZIndex.splice(f, 0, l);
        } else
          B.zeroOrAutoZIndexOrTransformedOrOpacity.push(l);
      } else
        n.styles.isFloating() ? B.nonPositionedFloats.push(l) : B.nonPositionedInlineLevel.push(l);
      ln(a, l, i ? l : t, o);
    } else
      n.styles.isInlineLevel() ? A.inlineLevel.push(a) : A.nonInlineLevel.push(a), ln(a, A, t, o);
    Z(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) && wa(n, o);
  });
}, wa = function(e, A) {
  for (var t = e instanceof sn ? e.start : 1, r = e instanceof sn ? e.reversed : !1, n = 0; n < A.length; n++) {
    var i = A[n];
    i.container instanceof zs && typeof i.container.value == "number" && i.container.value !== 0 && (t = i.container.value), i.listValue = Ze(t, i.container.styles.listStyleType, !0), t += r ? -1 : 1;
  }
}, Eg = function(e) {
  var A = new ga(e, null), t = new ua(A), r = [];
  return ln(A, t, t, r), wa(A.container, r), t;
}, Yi = function(e, A) {
  switch (A) {
    case 0:
      return hA(e.topLeftBorderBox, e.topLeftPaddingBox, e.topRightBorderBox, e.topRightPaddingBox);
    case 1:
      return hA(e.topRightBorderBox, e.topRightPaddingBox, e.bottomRightBorderBox, e.bottomRightPaddingBox);
    case 2:
      return hA(e.bottomRightBorderBox, e.bottomRightPaddingBox, e.bottomLeftBorderBox, e.bottomLeftPaddingBox);
    case 3:
    default:
      return hA(e.bottomLeftBorderBox, e.bottomLeftPaddingBox, e.topLeftBorderBox, e.topLeftPaddingBox);
  }
}, vg = function(e, A) {
  switch (A) {
    case 0:
      return hA(e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox, e.topRightBorderBox, e.topRightBorderDoubleOuterBox);
    case 1:
      return hA(e.topRightBorderBox, e.topRightBorderDoubleOuterBox, e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox);
    case 2:
      return hA(e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox, e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox);
    case 3:
    default:
      return hA(e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox, e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox);
  }
}, mg = function(e, A) {
  switch (A) {
    case 0:
      return hA(e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox, e.topRightBorderDoubleInnerBox, e.topRightPaddingBox);
    case 1:
      return hA(e.topRightBorderDoubleInnerBox, e.topRightPaddingBox, e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox);
    case 2:
      return hA(e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox, e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox);
    case 3:
    default:
      return hA(e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox, e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox);
  }
}, Ig = function(e, A) {
  switch (A) {
    case 0:
      return Ht(e.topLeftBorderStroke, e.topRightBorderStroke);
    case 1:
      return Ht(e.topRightBorderStroke, e.bottomRightBorderStroke);
    case 2:
      return Ht(e.bottomRightBorderStroke, e.bottomLeftBorderStroke);
    case 3:
    default:
      return Ht(e.bottomLeftBorderStroke, e.topLeftBorderStroke);
  }
}, Ht = function(e, A) {
  var t = [];
  return fA(e) ? t.push(e.subdivide(0.5, !1)) : t.push(e), fA(A) ? t.push(A.subdivide(0.5, !0)) : t.push(A), t;
}, hA = function(e, A, t, r) {
  var n = [];
  return fA(e) ? n.push(e.subdivide(0.5, !1)) : n.push(e), fA(t) ? n.push(t.subdivide(0.5, !0)) : n.push(t), fA(r) ? n.push(r.subdivide(0.5, !0).reverse()) : n.push(r), fA(A) ? n.push(A.subdivide(0.5, !1).reverse()) : n.push(A), n;
}, fa = function(e) {
  var A = e.bounds, t = e.styles;
  return A.add(t.borderLeftWidth, t.borderTopWidth, -(t.borderRightWidth + t.borderLeftWidth), -(t.borderTopWidth + t.borderBottomWidth));
}, Jt = function(e) {
  var A = e.styles, t = e.bounds, r = N(A.paddingLeft, t.width), n = N(A.paddingRight, t.width), i = N(A.paddingTop, t.width), s = N(A.paddingBottom, t.width);
  return t.add(r + A.borderLeftWidth, i + A.borderTopWidth, -(A.borderRightWidth + A.borderLeftWidth + r + n), -(A.borderTopWidth + A.borderBottomWidth + i + s));
}, Hg = function(e, A) {
  return e === 0 ? A.bounds : e === 2 ? Jt(A) : fa(A);
}, yg = function(e, A) {
  return e === 0 ? A.bounds : e === 2 ? Jt(A) : fa(A);
}, Sr = function(e, A, t) {
  var r = Hg(Qe(e.styles.backgroundOrigin, A), e), n = yg(Qe(e.styles.backgroundClip, A), e), i = bg(Qe(e.styles.backgroundSize, A), t, r), s = i[0], a = i[1], o = Oe(Qe(e.styles.backgroundPosition, A), r.width - s, r.height - a), B = Lg(Qe(e.styles.backgroundRepeat, A), o, i, r, n), l = Math.round(r.left + o[0]), u = Math.round(r.top + o[1]);
  return [B, l, u, s, a];
}, we = function(e) {
  return M(e) && e.value === Ue.AUTO;
}, yt = function(e) {
  return typeof e == "number";
}, bg = function(e, A, t) {
  var r = A[0], n = A[1], i = A[2], s = e[0], a = e[1];
  if (!s)
    return [0, 0];
  if (J(s) && a && J(a))
    return [N(s, t.width), N(a, t.height)];
  var o = yt(i);
  if (M(s) && (s.value === Ue.CONTAIN || s.value === Ue.COVER)) {
    if (yt(i)) {
      var B = t.width / t.height;
      return B < i != (s.value === Ue.COVER) ? [t.width, t.width / i] : [t.height * i, t.height];
    }
    return [t.width, t.height];
  }
  var l = yt(r), u = yt(n), c = l || u;
  if (we(s) && (!a || we(a))) {
    if (l && u)
      return [r, n];
    if (!o && !c)
      return [t.width, t.height];
    if (c && o) {
      var f = l ? r : n * i, g = u ? n : r / i;
      return [f, g];
    }
    var w = l ? r : t.width, Q = u ? n : t.height;
    return [w, Q];
  }
  if (o) {
    var d = 0, p = 0;
    return J(s) ? d = N(s, t.width) : J(a) && (p = N(a, t.height)), we(s) ? d = p * i : (!a || we(a)) && (p = d / i), [d, p];
  }
  var E = null, U = null;
  if (J(s) ? E = N(s, t.width) : a && J(a) && (U = N(a, t.height)), E !== null && (!a || we(a)) && (U = l && u ? E / r * n : t.height), U !== null && we(s) && (E = l && u ? U / n * r : t.width), E !== null && U !== null)
    return [E, U];
  throw new Error("Unable to calculate background-size for element");
}, Qe = function(e, A) {
  var t = e[A];
  return typeof t > "u" ? e[0] : t;
}, Lg = function(e, A, t, r, n) {
  var i = A[0], s = A[1], a = t[0], o = t[1];
  switch (e) {
    case 2:
      return [
        new F(Math.round(r.left), Math.round(r.top + s)),
        new F(Math.round(r.left + r.width), Math.round(r.top + s)),
        new F(Math.round(r.left + r.width), Math.round(o + r.top + s)),
        new F(Math.round(r.left), Math.round(o + r.top + s))
      ];
    case 3:
      return [
        new F(Math.round(r.left + i), Math.round(r.top)),
        new F(Math.round(r.left + i + a), Math.round(r.top)),
        new F(Math.round(r.left + i + a), Math.round(r.height + r.top)),
        new F(Math.round(r.left + i), Math.round(r.height + r.top))
      ];
    case 1:
      return [
        new F(Math.round(r.left + i), Math.round(r.top + s)),
        new F(Math.round(r.left + i + a), Math.round(r.top + s)),
        new F(Math.round(r.left + i + a), Math.round(r.top + s + o)),
        new F(Math.round(r.left + i), Math.round(r.top + s + o))
      ];
    default:
      return [
        new F(Math.round(n.left), Math.round(n.top)),
        new F(Math.round(n.left + n.width), Math.round(n.top)),
        new F(Math.round(n.left + n.width), Math.round(n.height + n.top)),
        new F(Math.round(n.left), Math.round(n.height + n.top))
      ];
  }
}, Tg = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", Zi = "Hidden Text", Kg = (
  /** @class */
  function() {
    function e(A) {
      this._data = {}, this._document = A;
    }
    return e.prototype.parseMetrics = function(A, t) {
      var r = this._document.createElement("div"), n = this._document.createElement("img"), i = this._document.createElement("span"), s = this._document.body;
      r.style.visibility = "hidden", r.style.fontFamily = A, r.style.fontSize = t, r.style.margin = "0", r.style.padding = "0", r.style.whiteSpace = "nowrap", s.appendChild(r), n.src = Tg, n.width = 1, n.height = 1, n.style.margin = "0", n.style.padding = "0", n.style.verticalAlign = "baseline", i.style.fontFamily = A, i.style.fontSize = t, i.style.margin = "0", i.style.padding = "0", i.appendChild(this._document.createTextNode(Zi)), r.appendChild(i), r.appendChild(n);
      var a = n.offsetTop - i.offsetTop + 2;
      r.removeChild(i), r.appendChild(this._document.createTextNode(Zi)), r.style.lineHeight = "normal", n.style.verticalAlign = "super";
      var o = n.offsetTop - r.offsetTop + 2;
      return s.removeChild(r), { baseline: a, middle: o };
    }, e.prototype.getMetrics = function(A, t) {
      var r = A + " " + t;
      return typeof this._data[r] > "u" && (this._data[r] = this.parseMetrics(A, t)), this._data[r];
    }, e;
  }()
), Qa = (
  /** @class */
  function() {
    function e(A, t) {
      this.context = A, this.options = t;
    }
    return e;
  }()
), xg = 1e4, Sg = (
  /** @class */
  function(e) {
    EA(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n._activeEffects = [], n.canvas = r.canvas ? r.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), r.canvas || (n.canvas.width = Math.floor(r.width * r.scale), n.canvas.height = Math.floor(r.height * r.scale), n.canvas.style.width = r.width + "px", n.canvas.style.height = r.height + "px"), n.fontMetrics = new Kg(document), n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-r.x, -r.y), n.ctx.textBaseline = "bottom", n._activeEffects = [], n.context.logger.debug("Canvas renderer initialized (" + r.width + "x" + r.height + ") with scale " + r.scale), n;
    }
    return A.prototype.applyEffects = function(t) {
      for (var r = this; this._activeEffects.length; )
        this.popEffect();
      t.forEach(function(n) {
        return r.applyEffect(n);
      });
    }, A.prototype.applyEffect = function(t) {
      this.ctx.save(), Fg(t) && (this.ctx.globalAlpha = t.opacity), dg(t) && (this.ctx.translate(t.offsetX, t.offsetY), this.ctx.transform(t.matrix[0], t.matrix[1], t.matrix[2], t.matrix[3], t.matrix[4], t.matrix[5]), this.ctx.translate(-t.offsetX, -t.offsetY)), la(t) && (this.path(t.path), this.ctx.clip()), this._activeEffects.push(t);
    }, A.prototype.popEffect = function() {
      this._activeEffects.pop(), this.ctx.restore();
    }, A.prototype.renderStack = function(t) {
      return nA(this, void 0, void 0, function() {
        var r;
        return tA(this, function(n) {
          switch (n.label) {
            case 0:
              return r = t.element.container.styles, r.isVisible() ? [4, this.renderStackContent(t)] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderNode = function(t) {
      return nA(this, void 0, void 0, function() {
        return tA(this, function(r) {
          switch (r.label) {
            case 0:
              if (Z(
                t.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return t.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(t)] : [3, 3];
            case 1:
              return r.sent(), [4, this.renderNodeContent(t)];
            case 2:
              r.sent(), r.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderTextWithLetterSpacing = function(t, r, n) {
      var i = this;
      if (r === 0)
        this.ctx.fillText(t.text, t.bounds.left, t.bounds.top + n);
      else {
        var s = En(t.text);
        s.reduce(function(a, o) {
          return i.ctx.fillText(o, a, t.bounds.top + n), a + i.ctx.measureText(o).width;
        }, t.bounds.left);
      }
    }, A.prototype.createFontStyle = function(t) {
      var r = t.fontVariant.filter(function(s) {
        return s === "normal" || s === "small-caps";
      }).join(""), n = _g(t.fontFamily).join(", "), i = je(t.fontSize) ? "" + t.fontSize.number + t.fontSize.unit : t.fontSize.number + "px";
      return [
        [t.fontStyle, r, t.fontWeight, i, n].join(" "),
        n,
        i
      ];
    }, A.prototype.renderTextNode = function(t, r) {
      return nA(this, void 0, void 0, function() {
        var n, i, s, a, o, B, l, u, c = this;
        return tA(this, function(f) {
          return n = this.createFontStyle(r), i = n[0], s = n[1], a = n[2], this.ctx.font = i, this.ctx.direction = r.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", o = this.fontMetrics.getMetrics(s, a), B = o.baseline, l = o.middle, u = r.paintOrder, t.textBounds.forEach(function(g) {
            u.forEach(function(w) {
              switch (w) {
                case 0:
                  c.ctx.fillStyle = q(r.color), c.renderTextWithLetterSpacing(g, r.letterSpacing, B);
                  var Q = r.textShadow;
                  Q.length && g.text.trim().length && (Q.slice(0).reverse().forEach(function(d) {
                    c.ctx.shadowColor = q(d.color), c.ctx.shadowOffsetX = d.offsetX.number * c.options.scale, c.ctx.shadowOffsetY = d.offsetY.number * c.options.scale, c.ctx.shadowBlur = d.blur.number, c.renderTextWithLetterSpacing(g, r.letterSpacing, B);
                  }), c.ctx.shadowColor = "", c.ctx.shadowOffsetX = 0, c.ctx.shadowOffsetY = 0, c.ctx.shadowBlur = 0), r.textDecorationLine.length && (c.ctx.fillStyle = q(r.textDecorationColor || r.color), r.textDecorationLine.forEach(function(d) {
                    switch (d) {
                      case 1:
                        c.ctx.fillRect(g.bounds.left, Math.round(g.bounds.top + B), g.bounds.width, 1);
                        break;
                      case 2:
                        c.ctx.fillRect(g.bounds.left, Math.round(g.bounds.top), g.bounds.width, 1);
                        break;
                      case 3:
                        c.ctx.fillRect(g.bounds.left, Math.ceil(g.bounds.top + l), g.bounds.width, 1);
                        break;
                    }
                  }));
                  break;
                case 1:
                  r.webkitTextStrokeWidth && g.text.trim().length && (c.ctx.strokeStyle = q(r.webkitTextStrokeColor), c.ctx.lineWidth = r.webkitTextStrokeWidth, c.ctx.lineJoin = window.chrome ? "miter" : "round", c.ctx.strokeText(g.text, g.bounds.left, g.bounds.top + B)), c.ctx.strokeStyle = "", c.ctx.lineWidth = 0, c.ctx.lineJoin = "miter";
                  break;
              }
            });
          }), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.renderReplacedElement = function(t, r, n) {
      if (n && t.intrinsicWidth > 0 && t.intrinsicHeight > 0) {
        var i = Jt(t), s = Xt(r);
        this.path(s), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(n, 0, 0, t.intrinsicWidth, t.intrinsicHeight, i.left, i.top, i.width, i.height), this.ctx.restore();
      }
    }, A.prototype.renderNodeContent = function(t) {
      return nA(this, void 0, void 0, function() {
        var r, n, i, s, a, o, p, p, B, l, u, c, U, f, g, m, w, Q, d, p, E, U, m;
        return tA(this, function(C) {
          switch (C.label) {
            case 0:
              this.applyEffects(t.getEffects(
                4
                /* CONTENT */
              )), r = t.container, n = t.curves, i = r.styles, s = 0, a = r.textNodes, C.label = 1;
            case 1:
              return s < a.length ? (o = a[s], [4, this.renderTextNode(o, i)]) : [3, 4];
            case 2:
              C.sent(), C.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              if (!(r instanceof Ys))
                return [3, 8];
              C.label = 5;
            case 5:
              return C.trys.push([5, 7, , 8]), [4, this.context.cache.match(r.src)];
            case 6:
              return p = C.sent(), this.renderReplacedElement(r, n, p), [3, 8];
            case 7:
              return C.sent(), this.context.logger.error("Error loading image " + r.src), [3, 8];
            case 8:
              if (r instanceof Zs && this.renderReplacedElement(r, n, r.canvas), !(r instanceof qs))
                return [3, 12];
              C.label = 9;
            case 9:
              return C.trys.push([9, 11, , 12]), [4, this.context.cache.match(r.svg)];
            case 10:
              return p = C.sent(), this.renderReplacedElement(r, n, p), [3, 12];
            case 11:
              return C.sent(), this.context.logger.error("Error loading svg " + r.svg.substring(0, 255)), [3, 12];
            case 12:
              return r instanceof Aa && r.tree ? (B = new A(this.context, {
                scale: this.options.scale,
                backgroundColor: r.backgroundColor,
                x: 0,
                y: 0,
                width: r.width,
                height: r.height
              }), [4, B.render(r.tree)]) : [3, 14];
            case 13:
              l = C.sent(), r.width && r.height && this.ctx.drawImage(l, 0, 0, r.width, r.height, r.bounds.left, r.bounds.top, r.bounds.width, r.bounds.height), C.label = 14;
            case 14:
              if (r instanceof vn && (u = Math.min(r.bounds.width, r.bounds.height), r.type === Gt ? r.checked && (this.ctx.save(), this.path([
                new F(r.bounds.left + u * 0.39363, r.bounds.top + u * 0.79),
                new F(r.bounds.left + u * 0.16, r.bounds.top + u * 0.5549),
                new F(r.bounds.left + u * 0.27347, r.bounds.top + u * 0.44071),
                new F(r.bounds.left + u * 0.39694, r.bounds.top + u * 0.5649),
                new F(r.bounds.left + u * 0.72983, r.bounds.top + u * 0.23),
                new F(r.bounds.left + u * 0.84, r.bounds.top + u * 0.34085),
                new F(r.bounds.left + u * 0.39363, r.bounds.top + u * 0.79)
              ]), this.ctx.fillStyle = q(Oi), this.ctx.fill(), this.ctx.restore()) : r.type === Nt && r.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(r.bounds.left + u / 2, r.bounds.top + u / 2, u / 4, 0, Math.PI * 2, !0), this.ctx.fillStyle = q(Oi), this.ctx.fill(), this.ctx.restore())), Dg(r) && r.value.length) {
                switch (c = this.createFontStyle(i), U = c[0], f = c[1], g = this.fontMetrics.getMetrics(U, f).baseline, this.ctx.font = U, this.ctx.fillStyle = q(i.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = Rg(r.styles.textAlign), m = Jt(r), w = 0, r.styles.textAlign) {
                  case 1:
                    w += m.width / 2;
                    break;
                  case 2:
                    w += m.width;
                    break;
                }
                Q = m.add(w, 0, 0, -m.height / 2 + 1), this.ctx.save(), this.path([
                  new F(m.left, m.top),
                  new F(m.left + m.width, m.top),
                  new F(m.left + m.width, m.top + m.height),
                  new F(m.left, m.top + m.height)
                ]), this.ctx.clip(), this.renderTextWithLetterSpacing(new ke(r.value, Q), i.letterSpacing, g), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
              }
              if (!Z(
                r.styles.display,
                2048
                /* LIST_ITEM */
              ))
                return [3, 20];
              if (r.styles.listStyleImage === null)
                return [3, 19];
              if (d = r.styles.listStyleImage, d.type !== 0)
                return [3, 18];
              p = void 0, E = d.url, C.label = 15;
            case 15:
              return C.trys.push([15, 17, , 18]), [4, this.context.cache.match(E)];
            case 16:
              return p = C.sent(), this.ctx.drawImage(p, r.bounds.left - (p.width + 10), r.bounds.top), [3, 18];
            case 17:
              return C.sent(), this.context.logger.error("Error loading list-style-image " + E), [3, 18];
            case 18:
              return [3, 20];
            case 19:
              t.listValue && r.styles.listStyleType !== -1 && (U = this.createFontStyle(i)[0], this.ctx.font = U, this.ctx.fillStyle = q(i.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", m = new NA(r.bounds.left, r.bounds.top + N(r.styles.paddingTop, r.bounds.width), r.bounds.width, Ui(i.lineHeight, i.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new ke(t.listValue, m), i.letterSpacing, Ui(i.lineHeight, i.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), C.label = 20;
            case 20:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderStackContent = function(t) {
      return nA(this, void 0, void 0, function() {
        var r, n, d, i, s, d, a, o, d, B, l, d, u, c, d, f, g, d, w, Q, d;
        return tA(this, function(p) {
          switch (p.label) {
            case 0:
              if (Z(
                t.element.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return [4, this.renderNodeBackgroundAndBorders(t.element)];
            case 1:
              p.sent(), r = 0, n = t.negativeZIndex, p.label = 2;
            case 2:
              return r < n.length ? (d = n[r], [4, this.renderStack(d)]) : [3, 5];
            case 3:
              p.sent(), p.label = 4;
            case 4:
              return r++, [3, 2];
            case 5:
              return [4, this.renderNodeContent(t.element)];
            case 6:
              p.sent(), i = 0, s = t.nonInlineLevel, p.label = 7;
            case 7:
              return i < s.length ? (d = s[i], [4, this.renderNode(d)]) : [3, 10];
            case 8:
              p.sent(), p.label = 9;
            case 9:
              return i++, [3, 7];
            case 10:
              a = 0, o = t.nonPositionedFloats, p.label = 11;
            case 11:
              return a < o.length ? (d = o[a], [4, this.renderStack(d)]) : [3, 14];
            case 12:
              p.sent(), p.label = 13;
            case 13:
              return a++, [3, 11];
            case 14:
              B = 0, l = t.nonPositionedInlineLevel, p.label = 15;
            case 15:
              return B < l.length ? (d = l[B], [4, this.renderStack(d)]) : [3, 18];
            case 16:
              p.sent(), p.label = 17;
            case 17:
              return B++, [3, 15];
            case 18:
              u = 0, c = t.inlineLevel, p.label = 19;
            case 19:
              return u < c.length ? (d = c[u], [4, this.renderNode(d)]) : [3, 22];
            case 20:
              p.sent(), p.label = 21;
            case 21:
              return u++, [3, 19];
            case 22:
              f = 0, g = t.zeroOrAutoZIndexOrTransformedOrOpacity, p.label = 23;
            case 23:
              return f < g.length ? (d = g[f], [4, this.renderStack(d)]) : [3, 26];
            case 24:
              p.sent(), p.label = 25;
            case 25:
              return f++, [3, 23];
            case 26:
              w = 0, Q = t.positiveZIndex, p.label = 27;
            case 27:
              return w < Q.length ? (d = Q[w], [4, this.renderStack(d)]) : [3, 30];
            case 28:
              p.sent(), p.label = 29;
            case 29:
              return w++, [3, 27];
            case 30:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.mask = function(t) {
      this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(t.slice(0).reverse()), this.ctx.closePath();
    }, A.prototype.path = function(t) {
      this.ctx.beginPath(), this.formatPath(t), this.ctx.closePath();
    }, A.prototype.formatPath = function(t) {
      var r = this;
      t.forEach(function(n, i) {
        var s = fA(n) ? n.start : n;
        i === 0 ? r.ctx.moveTo(s.x, s.y) : r.ctx.lineTo(s.x, s.y), fA(n) && r.ctx.bezierCurveTo(n.startControl.x, n.startControl.y, n.endControl.x, n.endControl.y, n.end.x, n.end.y);
      });
    }, A.prototype.renderRepeat = function(t, r, n, i) {
      this.path(t), this.ctx.fillStyle = r, this.ctx.translate(n, i), this.ctx.fill(), this.ctx.translate(-n, -i);
    }, A.prototype.resizeImage = function(t, r, n) {
      var i;
      if (t.width === r && t.height === n)
        return t;
      var s = (i = this.canvas.ownerDocument) !== null && i !== void 0 ? i : document, a = s.createElement("canvas");
      a.width = Math.max(1, r), a.height = Math.max(1, n);
      var o = a.getContext("2d");
      return o.drawImage(t, 0, 0, t.width, t.height, 0, 0, r, n), a;
    }, A.prototype.renderBackgroundImage = function(t) {
      return nA(this, void 0, void 0, function() {
        var r, n, i, s, a, o;
        return tA(this, function(B) {
          switch (B.label) {
            case 0:
              r = t.styles.backgroundImage.length - 1, n = function(l) {
                var u, c, f, _, W, Y, K, k, T, g, _, W, Y, K, k, w, Q, d, p, E, U, m, C, L, T, H, _, z, eA, K, k, vA, W, Y, mA, iA, uA, IA, gA, sA, HA, aA;
                return tA(this, function(yA) {
                  switch (yA.label) {
                    case 0:
                      if (l.type !== 0)
                        return [3, 5];
                      u = void 0, c = l.url, yA.label = 1;
                    case 1:
                      return yA.trys.push([1, 3, , 4]), [4, i.context.cache.match(c)];
                    case 2:
                      return u = yA.sent(), [3, 4];
                    case 3:
                      return yA.sent(), i.context.logger.error("Error loading background-image " + c), [3, 4];
                    case 4:
                      return u && (f = Sr(t, r, [
                        u.width,
                        u.height,
                        u.width / u.height
                      ]), _ = f[0], W = f[1], Y = f[2], K = f[3], k = f[4], T = i.ctx.createPattern(i.resizeImage(u, K, k), "repeat"), i.renderRepeat(_, T, W, Y)), [3, 6];
                    case 5:
                      dc(l) ? (g = Sr(t, r, [null, null, null]), _ = g[0], W = g[1], Y = g[2], K = g[3], k = g[4], w = fc(l.angle, K, k), Q = w[0], d = w[1], p = w[2], E = w[3], U = w[4], m = document.createElement("canvas"), m.width = K, m.height = k, C = m.getContext("2d"), L = C.createLinearGradient(d, E, p, U), hi(l.stops, Q).forEach(function(OA) {
                        return L.addColorStop(OA.stop, q(OA.color));
                      }), C.fillStyle = L, C.fillRect(0, 0, K, k), K > 0 && k > 0 && (T = i.ctx.createPattern(m, "repeat"), i.renderRepeat(_, T, W, Y))) : Fc(l) && (H = Sr(t, r, [
                        null,
                        null,
                        null
                      ]), _ = H[0], z = H[1], eA = H[2], K = H[3], k = H[4], vA = l.position.length === 0 ? [dn] : l.position, W = N(vA[0], K), Y = N(vA[vA.length - 1], k), mA = Qc(l, W, Y, K, k), iA = mA[0], uA = mA[1], iA > 0 && uA > 0 && (IA = i.ctx.createRadialGradient(z + W, eA + Y, 0, z + W, eA + Y, iA), hi(l.stops, iA * 2).forEach(function(OA) {
                        return IA.addColorStop(OA.stop, q(OA.color));
                      }), i.path(_), i.ctx.fillStyle = IA, iA !== uA ? (gA = t.bounds.left + 0.5 * t.bounds.width, sA = t.bounds.top + 0.5 * t.bounds.height, HA = uA / iA, aA = 1 / HA, i.ctx.save(), i.ctx.translate(gA, sA), i.ctx.transform(1, 0, 0, HA, 0, 0), i.ctx.translate(-gA, -sA), i.ctx.fillRect(z, aA * (eA - sA) + sA, K, k * aA), i.ctx.restore()) : i.ctx.fill())), yA.label = 6;
                    case 6:
                      return r--, [
                        2
                        /*return*/
                      ];
                  }
                });
              }, i = this, s = 0, a = t.styles.backgroundImage.slice(0).reverse(), B.label = 1;
            case 1:
              return s < a.length ? (o = a[s], [5, n(o)]) : [3, 4];
            case 2:
              B.sent(), B.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderSolidBorder = function(t, r, n) {
      return nA(this, void 0, void 0, function() {
        return tA(this, function(i) {
          return this.path(Yi(n, r)), this.ctx.fillStyle = q(t), this.ctx.fill(), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.renderDoubleBorder = function(t, r, n, i) {
      return nA(this, void 0, void 0, function() {
        var s, a;
        return tA(this, function(o) {
          switch (o.label) {
            case 0:
              return r < 3 ? [4, this.renderSolidBorder(t, n, i)] : [3, 2];
            case 1:
              return o.sent(), [
                2
                /*return*/
              ];
            case 2:
              return s = vg(i, n), this.path(s), this.ctx.fillStyle = q(t), this.ctx.fill(), a = mg(i, n), this.path(a), this.ctx.fill(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderNodeBackgroundAndBorders = function(t) {
      return nA(this, void 0, void 0, function() {
        var r, n, i, s, a, o, B, l, u = this;
        return tA(this, function(c) {
          switch (c.label) {
            case 0:
              return this.applyEffects(t.getEffects(
                2
                /* BACKGROUND_BORDERS */
              )), r = t.container.styles, n = !$A(r.backgroundColor) || r.backgroundImage.length, i = [
                { style: r.borderTopStyle, color: r.borderTopColor, width: r.borderTopWidth },
                { style: r.borderRightStyle, color: r.borderRightColor, width: r.borderRightWidth },
                { style: r.borderBottomStyle, color: r.borderBottomColor, width: r.borderBottomWidth },
                { style: r.borderLeftStyle, color: r.borderLeftColor, width: r.borderLeftWidth }
              ], s = Og(Qe(r.backgroundClip, 0), t.curves), n || r.boxShadow.length ? (this.ctx.save(), this.path(s), this.ctx.clip(), $A(r.backgroundColor) || (this.ctx.fillStyle = q(r.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(t.container)]) : [3, 2];
            case 1:
              c.sent(), this.ctx.restore(), r.boxShadow.slice(0).reverse().forEach(function(f) {
                u.ctx.save();
                var g = Vt(t.curves), w = f.inset ? 0 : xg, Q = pg(g, -w + (f.inset ? 1 : -1) * f.spread.number, (f.inset ? 1 : -1) * f.spread.number, f.spread.number * (f.inset ? -2 : 2), f.spread.number * (f.inset ? -2 : 2));
                f.inset ? (u.path(g), u.ctx.clip(), u.mask(Q)) : (u.mask(g), u.ctx.clip(), u.path(Q)), u.ctx.shadowOffsetX = f.offsetX.number + w, u.ctx.shadowOffsetY = f.offsetY.number, u.ctx.shadowColor = q(f.color), u.ctx.shadowBlur = f.blur.number, u.ctx.fillStyle = f.inset ? q(f.color) : "rgba(0,0,0,1)", u.ctx.fill(), u.ctx.restore();
              }), c.label = 2;
            case 2:
              a = 0, o = 0, B = i, c.label = 3;
            case 3:
              return o < B.length ? (l = B[o], l.style !== 0 && !$A(l.color) && l.width > 0 ? l.style !== 2 ? [3, 5] : [4, this.renderDashedDottedBorder(
                l.color,
                l.width,
                a,
                t.curves,
                2
                /* DASHED */
              )] : [3, 11]) : [3, 13];
            case 4:
              return c.sent(), [3, 11];
            case 5:
              return l.style !== 3 ? [3, 7] : [4, this.renderDashedDottedBorder(
                l.color,
                l.width,
                a,
                t.curves,
                3
                /* DOTTED */
              )];
            case 6:
              return c.sent(), [3, 11];
            case 7:
              return l.style !== 4 ? [3, 9] : [4, this.renderDoubleBorder(l.color, l.width, a, t.curves)];
            case 8:
              return c.sent(), [3, 11];
            case 9:
              return [4, this.renderSolidBorder(l.color, a, t.curves)];
            case 10:
              c.sent(), c.label = 11;
            case 11:
              a++, c.label = 12;
            case 12:
              return o++, [3, 3];
            case 13:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderDashedDottedBorder = function(t, r, n, i, s) {
      return nA(this, void 0, void 0, function() {
        var a, o, B, l, u, c, f, g, w, Q, d, p, E, U, m, C, m, C;
        return tA(this, function(L) {
          return this.ctx.save(), a = Ig(i, n), o = Yi(i, n), s === 2 && (this.path(o), this.ctx.clip()), fA(o[0]) ? (B = o[0].start.x, l = o[0].start.y) : (B = o[0].x, l = o[0].y), fA(o[1]) ? (u = o[1].end.x, c = o[1].end.y) : (u = o[1].x, c = o[1].y), n === 0 || n === 2 ? f = Math.abs(B - u) : f = Math.abs(l - c), this.ctx.beginPath(), s === 3 ? this.formatPath(a) : this.formatPath(o.slice(0, 2)), g = r < 3 ? r * 3 : r * 2, w = r < 3 ? r * 2 : r, s === 3 && (g = r, w = r), Q = !0, f <= g * 2 ? Q = !1 : f <= g * 2 + w ? (d = f / (2 * g + w), g *= d, w *= d) : (p = Math.floor((f + w) / (g + w)), E = (f - p * g) / (p - 1), U = (f - (p + 1) * g) / p, w = U <= 0 || Math.abs(w - E) < Math.abs(w - U) ? E : U), Q && (s === 3 ? this.ctx.setLineDash([0, g + w]) : this.ctx.setLineDash([g, w])), s === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = r) : this.ctx.lineWidth = r * 2 + 1.1, this.ctx.strokeStyle = q(t), this.ctx.stroke(), this.ctx.setLineDash([]), s === 2 && (fA(o[0]) && (m = o[3], C = o[0], this.ctx.beginPath(), this.formatPath([new F(m.end.x, m.end.y), new F(C.start.x, C.start.y)]), this.ctx.stroke()), fA(o[1]) && (m = o[1], C = o[2], this.ctx.beginPath(), this.formatPath([new F(m.end.x, m.end.y), new F(C.start.x, C.start.y)]), this.ctx.stroke())), this.ctx.restore(), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.render = function(t) {
      return nA(this, void 0, void 0, function() {
        var r;
        return tA(this, function(n) {
          switch (n.label) {
            case 0:
              return this.options.backgroundColor && (this.ctx.fillStyle = q(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), r = Eg(t), [4, this.renderStack(r)];
            case 1:
              return n.sent(), this.applyEffects([]), [2, this.canvas];
          }
        });
      });
    }, A;
  }(Qa)
), Dg = function(e) {
  return e instanceof $s || e instanceof js ? !0 : e instanceof vn && e.type !== Nt && e.type !== Gt;
}, Og = function(e, A) {
  switch (e) {
    case 0:
      return Vt(A);
    case 2:
      return hg(A);
    case 1:
    default:
      return Xt(A);
  }
}, Rg = function(e) {
  switch (e) {
    case 1:
      return "center";
    case 2:
      return "right";
    case 0:
    default:
      return "left";
  }
}, Mg = ["-apple-system", "system-ui"], _g = function(e) {
  return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? e.filter(function(A) {
    return Mg.indexOf(A) === -1;
  }) : e;
}, Gg = (
  /** @class */
  function(e) {
    EA(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.canvas = r.canvas ? r.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), n.options = r, n.canvas.width = Math.floor(r.width * r.scale), n.canvas.height = Math.floor(r.height * r.scale), n.canvas.style.width = r.width + "px", n.canvas.style.height = r.height + "px", n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-r.x, -r.y), n.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + r.width + "x" + r.height + " at " + r.x + "," + r.y + ") with scale " + r.scale), n;
    }
    return A.prototype.render = function(t) {
      return nA(this, void 0, void 0, function() {
        var r, n;
        return tA(this, function(i) {
          switch (i.label) {
            case 0:
              return r = nn(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, t), [4, Ng(r)];
            case 1:
              return n = i.sent(), this.options.backgroundColor && (this.ctx.fillStyle = q(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(n, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
          }
        });
      });
    }, A;
  }(Qa)
), Ng = function(e) {
  return new Promise(function(A, t) {
    var r = new Image();
    r.onload = function() {
      A(r);
    }, r.onerror = t, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(e));
  });
}, Pg = (
  /** @class */
  function() {
    function e(A) {
      var t = A.id, r = A.enabled;
      this.id = t, this.enabled = r, this.start = Date.now();
    }
    return e.prototype.debug = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug.apply(console, st([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, e.prototype.getTime = function() {
      return Date.now() - this.start;
    }, e.prototype.info = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info.apply(console, st([this.id, this.getTime() + "ms"], A));
    }, e.prototype.warn = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn.apply(console, st([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, e.prototype.error = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error.apply(console, st([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, e.instances = {}, e;
  }()
), kg = (
  /** @class */
  function() {
    function e(A, t) {
      var r;
      this.windowBounds = t, this.instanceName = "#" + e.instanceCount++, this.logger = new Pg({ id: this.instanceName, enabled: A.logging }), this.cache = (r = A.cache) !== null && r !== void 0 ? r : new Bg(this, A);
    }
    return e.instanceCount = 1, e;
  }()
), Vg = function(e, A) {
  return A === void 0 && (A = {}), Xg(e, A);
};
typeof window < "u" && ca.setContext(window);
var Xg = function(e, A) {
  return nA(void 0, void 0, void 0, function() {
    var t, r, n, i, s, a, o, B, l, u, c, f, g, w, Q, d, p, E, U, m, L, C, L, T, H, _, z, eA, K, k, vA, W, Y, mA, iA, uA, IA, gA, sA, HA;
    return tA(this, function(aA) {
      switch (aA.label) {
        case 0:
          if (!e || typeof e != "object")
            return [2, Promise.reject("Invalid element provided as first argument")];
          if (t = e.ownerDocument, !t)
            throw new Error("Element is not attached to a Document");
          if (r = t.defaultView, !r)
            throw new Error("Document is not attached to a Window");
          return n = {
            allowTaint: (T = A.allowTaint) !== null && T !== void 0 ? T : !1,
            imageTimeout: (H = A.imageTimeout) !== null && H !== void 0 ? H : 15e3,
            proxy: A.proxy,
            useCORS: (_ = A.useCORS) !== null && _ !== void 0 ? _ : !1
          }, i = kr({ logging: (z = A.logging) !== null && z !== void 0 ? z : !0, cache: A.cache }, n), s = {
            windowWidth: (eA = A.windowWidth) !== null && eA !== void 0 ? eA : r.innerWidth,
            windowHeight: (K = A.windowHeight) !== null && K !== void 0 ? K : r.innerHeight,
            scrollX: (k = A.scrollX) !== null && k !== void 0 ? k : r.pageXOffset,
            scrollY: (vA = A.scrollY) !== null && vA !== void 0 ? vA : r.pageYOffset
          }, a = new NA(s.scrollX, s.scrollY, s.windowWidth, s.windowHeight), o = new kg(i, a), B = (W = A.foreignObjectRendering) !== null && W !== void 0 ? W : !1, l = {
            allowTaint: (Y = A.allowTaint) !== null && Y !== void 0 ? Y : !1,
            onclone: A.onclone,
            ignoreElements: A.ignoreElements,
            inlineImages: B,
            copyStyles: B
          }, o.logger.debug("Starting document clone with size " + a.width + "x" + a.height + " scrolled to " + -a.left + "," + -a.top), u = new Xi(o, e, l), c = u.clonedReferenceElement, c ? [4, u.toIFrame(t, a)] : [2, Promise.reject("Unable to find element in cloned iframe")];
        case 1:
          return f = aA.sent(), g = mn(c) || Ju(c) ? po(c.ownerDocument) : zt(o, c), w = g.width, Q = g.height, d = g.left, p = g.top, E = Jg(o, c, A.backgroundColor), U = {
            canvas: A.canvas,
            backgroundColor: E,
            scale: (iA = (mA = A.scale) !== null && mA !== void 0 ? mA : r.devicePixelRatio) !== null && iA !== void 0 ? iA : 1,
            x: ((uA = A.x) !== null && uA !== void 0 ? uA : 0) + d,
            y: ((IA = A.y) !== null && IA !== void 0 ? IA : 0) + p,
            width: (gA = A.width) !== null && gA !== void 0 ? gA : Math.ceil(w),
            height: (sA = A.height) !== null && sA !== void 0 ? sA : Math.ceil(Q)
          }, B ? (o.logger.debug("Document cloned, using foreign object rendering"), L = new Gg(o, U), [4, L.render(c)]) : [3, 3];
        case 2:
          return m = aA.sent(), [3, 5];
        case 3:
          return o.logger.debug("Document cloned, element located at " + d + "," + p + " with size " + w + "x" + Q + " using computed rendering"), o.logger.debug("Starting DOM parsing"), C = ta(o, c), E === C.styles.backgroundColor && (C.styles.backgroundColor = GA.TRANSPARENT), o.logger.debug("Starting renderer for element at " + U.x + "," + U.y + " with size " + U.width + "x" + U.height), L = new Sg(o, U), [4, L.render(C)];
        case 4:
          m = aA.sent(), aA.label = 5;
        case 5:
          return (!((HA = A.removeContainer) !== null && HA !== void 0) || HA) && (Xi.destroy(f) || o.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore")), o.logger.debug("Finished rendering"), [2, m];
      }
    });
  });
}, Jg = function(e, A, t) {
  var r = A.ownerDocument, n = r.documentElement ? Ne(e, getComputedStyle(r.documentElement).backgroundColor) : GA.TRANSPARENT, i = r.body ? Ne(e, getComputedStyle(r.body).backgroundColor) : GA.TRANSPARENT, s = typeof t == "string" ? Ne(e, t) : t === null ? GA.TRANSPARENT : 4294967295;
  return A === r.documentElement ? $A(n) ? $A(i) ? s : i : n : s;
};
const Wg = "https://api.perceptpixel.com/v1/media", Yg = "pxl_kmqK.s2UApaYj1vqBNygDD90hCDOSX4mBNTJQ";
class Zg {
  constructor() {
    h(this, "token");
    h(this, "screenshotBlob");
    h(this, "pageLoadTimer");
    h(this, "checkScreenshotExists", async (A) => {
      try {
        if (!this.token)
          return !0;
        let t = St();
        const r = Xe(this.token);
        return (await (await fetch(
          `${Or}?screenType=${t}&pathname=${A}&hostname=${location.host}`,
          {
            method: "GET",
            headers: { ...r }
          }
        )).json()).found;
      } catch {
        return I.error("[PI] screenshot check api failed"), !1;
      }
    });
    h(this, "uploadScreenshotUrlToPI", async (A, t) => {
      if (!this.token)
        return;
      const r = {
        hostname: location.host,
        pathname: A,
        screenshotURL: t.cdn_url,
        screenType: St(),
        clientWidth: document.body.clientWidth,
        clientHeight: document.body.clientHeight,
        storageVendor: "Pixel",
        vendorImageId: t.uid,
        imageSize: t.file_size,
        imageHeight: t.height,
        imageWidth: t.width
      };
      try {
        const n = Xe(this.token);
        await fetch(Or, {
          method: "POST",
          headers: { ...n },
          body: JSON.stringify(r)
        }), I.log(`[PI] screenshot url updated in pi for ${A}`);
      } catch {
        I.error("[PI] screenshot url upload to pi failed");
      }
    });
    h(this, "uploadScreenshotToPixel", async (A) => {
      const t = Date.now(), r = new FormData(), n = `${location.href}_${document.title}_${t}.png`;
      r.append("file", A, n), r.append("name", n);
      try {
        return await (await fetch(Wg, {
          method: "POST",
          headers: {
            Authorization: `Api-Key ${Yg}`
          },
          body: r
        })).json();
      } catch {
        return I.error("[PI] screenshot upload to pixel failed"), null;
      }
    });
    h(this, "captureScreenshot", async (A) => {
      if (this.token) {
        I.log(`[PI] capture screenshot for ${A}`);
        try {
          (await Vg(document.body, {
            useCORS: !0,
            logging: !1,
            scrollX: 0,
            scrollY: 0
          })).toBlob(async (r) => {
            if (!r) {
              I.log("[PI] capture screenshot blob not created");
              return;
            }
            this.uploadScreenshotBlob(A, r);
          });
        } catch (t) {
          I.error("[PI] screenshot capture failed: ", t);
        }
      }
    });
    h(this, "uploadScreenshotBlob", async (A, t) => {
      if (!this.token)
        return;
      const r = await this.uploadScreenshotToPixel(t);
      r && (I.log(`[PI] screenshot media uploaded for ${A}`), this.uploadScreenshotUrlToPI(A, r)), this.screenshotBlob = null;
    });
    // uploadPendingScreenshot = () => {
    //   if (this.screenshotBlob && this.currentPath) {
    //     this.uploadScreenshotBlob(this.currentPath);
    //   }
    // };
    h(this, "waitForImagesToLoad", async () => {
      try {
        return I.log("[PI] image count: ", document.images), await Promise.all(
          Array.from(document.images).filter((A) => !A.complete).map(
            (A) => new Promise((t) => {
              A.onload = A.onerror = t;
            })
          )
        ), !0;
      } catch {
        return !0;
      }
    });
    h(this, "routeChanged", async (A) => {
      !this.token || (this.pageLoadTimer && clearTimeout(this.pageLoadTimer), I.log("[PI] route change detected in screenshot utils"), await this.checkScreenshotExists(A)) || (I.log("[PI] screenshot does not exist. triggering timer"), this.pageLoadTimer = setTimeout(async () => {
        I.log("[PI] capturing now"), this.captureScreenshot(A);
      }, 12e3));
    });
  }
  init(A) {
    this.token = A;
  }
}
const qi = new Zg();
class qg {
  constructor() {
    h(this, "lastScrollTop", 0);
    // private _lastScrollTime = Date.now();
    h(this, "tracker");
    h(this, "sendScrollData", (A, t) => {
      const r = A > this.lastScrollTop ? "down" : "up", n = {
        pi_scroll_depth: t,
        pi_scroll_top: A,
        pi_scroll_direction: r
      };
      this.tracker(pA.SCROLL, n);
    });
    h(this, "captureScrollData", (A = !1) => {
      const t = rs(), r = (window.scrollY || document.documentElement.scrollTop) * t.yPosFactor;
      let n = (document.documentElement.scrollHeight - window.innerHeight) * t.yPosFactor, i = n * 0.2;
      if (A || Math.abs(r - this.lastScrollTop) > i) {
        const s = Math.floor(r / n * 20) * 5;
        this.sendScrollData(r, s), this.lastScrollTop = r;
      }
    });
    h(this, "heatmapScrollListener", _a((A) => {
      this.captureScrollData();
    }, 300));
    h(this, "addListener", () => {
      window.addEventListener("scroll", this.heatmapScrollListener, {
        capture: !0
      }), I.log("[PI] heatmap inititalised. Listener added");
    });
    h(this, "reset", () => {
      this.lastScrollTop = 0, window.removeEventListener("scroll", this.heatmapScrollListener);
    });
  }
  init(A) {
    this.reset(), this.tracker = A, this.addListener(), this.captureScrollData(!0);
  }
}
const Dr = new qg();
class zg {
  constructor() {
    h(this, "clickThreshold", 3);
    // Number of clicks to consider as rage click
    h(this, "clickInterval", 1e3);
    // Time interval in milliseconds to consider as rage click
    h(this, "clickHistory", []);
    h(this, "tracker");
    h(this, "addListener", () => {
      window.addEventListener("click", this.captureClick, { capture: !0 });
    });
    h(this, "captureClick", (A) => {
      I.log("[PI] capturing click");
      const t = this.getClickDataProperties(A);
      let { clickHistory: r, clickThreshold: n, clickInterval: i } = this;
      if (r.push({
        x: A.clientX,
        y: A.clientY,
        timestamp: Date.now()
      }), r = r.filter(
        (s) => Date.now() - s.timestamp < i
      ), r.length >= n) {
        const s = r.slice(-n), a = s[0], o = s[s.length - 1], B = o.timestamp - a.timestamp, l = Math.sqrt(
          Math.pow(o.x - a.x, 2) + Math.pow(o.y - a.y, 2)
        );
        B < i && l < 10 && (t.pi_isRageClick = !0);
      }
      this.tracker(pA.CLICK, t);
    });
    h(this, "getClickDataProperties", (A) => {
      const t = A.target, r = this.getNormalizedCoordinates(
        A.clientX,
        A.clientY + window.scrollY
      );
      return {
        pi_htmlElement: (t == null ? void 0 : t.tagName) || "unknown",
        pi_htmlElementText: (t == null ? void 0 : t.innerText) || "",
        pi_xPos: A.clientX,
        pi_yPos: A.clientY + window.scrollY,
        pi_pageTitle: document.title,
        pi_isRageClick: !1,
        ...r
      };
    });
    h(this, "getNormalizedCoordinates", (A, t) => {
      let r = rs();
      return {
        pi_xPos_normalized: A * r.xPosFactor,
        pi_yPos_normalized: t * r.yPosFactor
      };
    });
    h(this, "reset", () => {
      this.clickHistory = [], window.removeEventListener("click", this.captureClick);
    });
  }
  init(A) {
    this.tracker = A, this.reset(), this.addListener();
  }
}
const zi = new zg();
class jg {
  constructor() {
    h(this, "isSDKInitialized", !1);
    h(this, "timeThresholdMilliseconds");
    h(this, "batchSize");
    h(this, "batchCheckTimer");
    h(this, "token");
    h(this, "userId");
    h(this, "batchedEventRequests");
    h(this, "deviceProperties");
    h(this, "uniqueId");
    h(this, "tempEventQueue");
    h(this, "globalProerties", {});
    h(this, "domObserver");
    h(this, "isExperimentEnabled", !1);
    // private sessionStartTimestamp: number | undefined;
    h(this, "shouldCaptureScreenshot", !1);
    h(this, "isHeatmapEnabled", !1);
    h(this, "isPageviewCaptureEnabled", !1);
    this.timeThresholdMilliseconds = 5e3, this.batchSize = 50, this.batchCheckTimer = null, this.batchedEventRequests = [], this.tempEventQueue = [];
  }
  init(A, t = {}) {
    if (I.setIsEnabled(!!(t != null && t.enableLogs)), this.isSDKInitialized) {
      I.warn(
        "Percept SDK has already been initialized. This call will be ignored"
      );
      return;
    }
    if (!A)
      throw new Error("Percept token is mandatory for initializing the SDK");
    this.token = A, Yn.init(A), Pa(A);
    let r = {
      ...ya,
      ...t
    };
    this.batchSize = r.autoFlushBatchSize ? r.autoFlushBatchSize : this.batchSize, this.timeThresholdMilliseconds = r.autoFlushThresholdMs ? r.autoFlushThresholdMs : this.timeThresholdMilliseconds, this.isExperimentEnabled = r.enableExperiment, this.shouldCaptureScreenshot = r.enableHeatmap || r.enableHotspot, this.isHeatmapEnabled = r.enableHeatmap, this.isPageviewCaptureEnabled = r.autoTrackPageviews;
    try {
      qn.init(), this.deviceProperties = qn.getDeviceProperties(), it.init();
    } catch (i) {
      this.deviceProperties = {}, I.error("[PI]: error fetching device properties"), I.error(i);
    }
    this.addListeners(r), this.isSDKInitialized = !0;
    const n = this.capture.bind(this);
    if (this.setUpAutoPageViewTracking(), r.autoTrackWebvitals && co.init(n), this.shouldCaptureScreenshot && qi.init(this.token), go.init(n, {
      autoTrackApiCalls: r.autoTrackApiCalls,
      autoTrackStaticResourceCalls: r.autoTrackStaticResourceCalls,
      blocklist: r.apiTrackingBlocklist
    }), this.isExperimentEnabled) {
      const i = {
        processTempEventQueue: this.processTempEventQueue.bind(this),
        captureEvent: this.capture.bind(this),
        getUniqueId: this.getUniqueId.bind(this),
        getUserId: this.getUserId.bind(this)
      };
      TA.init(this.token, r, i);
    }
    r.autoAppOpened && this.capture(pA.APP_OPENED), r.enableHeatmap && Dr.init(n), (r.autoCaptureClicks || r.enableHotspot) && zi.init(n), I.log("[PI] initialised");
  }
  async getExperiment(A) {
    return TA.getExperiment(A);
  }
  async getAllActiveExperiments() {
    return TA.getAllActiveExperiments();
  }
  async getExperimentUserType() {
    return TA.getExperimentUserType();
  }
  clear() {
    var A;
    try {
      oA.clear(), (A = window == null ? void 0 : window.sessionStorage) == null || A.clear(), this.isExperimentEnabled && TA.clearRefetchTimer();
    } catch (t) {
      I.error("[PI]: error clearing device properties"), I.error(t);
    }
  }
  async setUserId(A, t = {}) {
    if (this.canProcessRequests()) {
      if (!A) {
        I.warn("[PI]: user id can not be empty");
        return;
      }
      this.userId = A;
      try {
        oA.setItem(cA.USER_ID_KEY, A);
        const r = [this.setUserProperties(t)];
        this.isExperimentEnabled && r.push(TA.fetchExperimentData()), await Promise.all(r);
      } catch (r) {
        I.error("[PI]: error setting user id"), I.error(r);
      }
    }
  }
  async setUserProperties(A) {
    if (!this.canProcessRequests())
      return;
    let t = this.getUserId();
    if (!t) {
      I.warn(
        "[PI] can not set user properties without user id. Please call setUserId method to set userId first"
      );
      return;
    }
    let r = cr({
      ...A,
      unique_id: this.getUniqueId()
    });
    await Ja(
      {
        userId: t,
        ...r
      },
      this.token
    );
  }
  timeEvent(A) {
    Jn.setEventTimer(A, (/* @__PURE__ */ new Date()).getTime());
  }
  async capture(A, t = {}) {
    if (this.canProcessRequests()) {
      if (!A) {
        I.warn("[PI]: event name cannot be empty");
        return;
      }
      try {
        let n = {
          user_id: this.getUserId(),
          unique_id: this.getUniqueId(),
          pi_client_ts: Date.now(),
          pi_client_unique_event_id: "EI-" + Sn()
        }, i = this.getAllGlobalProperties(), s = it.getParams(), a = it.getCompleteReferrerDataForTracking(), o = it.getSearchInfo(), B = Ra(), l = Ma({
          ...t,
          ...n,
          ...i,
          ...this.deviceProperties || {},
          ...s,
          ...a,
          ...o,
          ...B
        }), u = Jn.removeEventTimer(A);
        if (u) {
          var r = (/* @__PURE__ */ new Date()).getTime() - u;
          l[ba] = parseFloat(
            (r / 1e3).toFixed(3)
          );
        }
        if (!this.isExperimentEnabled) {
          this._flushModifiedEvent(A, l);
          return;
        }
        if (TA.getIsExperimentDataResolved()) {
          const c = TA.getExperimentProperties(), f = {
            ...l,
            ...c
          };
          this._flushModifiedEvent(A, f);
        } else
          this.tempEventQueue.push({ name: A, propertiesToSend: l });
      } catch (n) {
        I.error("[PI]: error capturing event"), I.error(n);
      }
    }
  }
  setGlobalProperty(A, t) {
    if (!this.canProcessRequests())
      return;
    let r = `${Ie}${A}`;
    try {
      oA.setItem(r, t);
    } catch (n) {
      I.error(`[PI]: error setting global property: ${A}`), I.error(n);
    }
  }
  removeGlobalProperty(A) {
    if (this.canProcessRequests())
      try {
        oA.removeItem(`${Ie}${A}`);
      } catch (t) {
        I.error(`[PI]: error removing global property: ${A}`), I.error(t);
      }
  }
  getAllGlobalProperties() {
    if (!this.canProcessRequests())
      return {};
    try {
      let A = oA.getAll(), t = Object.keys(A).filter(
        (i) => i.startsWith(Ie)
      );
      if (Object.keys(this.globalProerties).length === t.length)
        return this.globalProerties;
      let r = {}, n = Ie.length;
      return t.forEach((i) => {
        let s = i.slice(n);
        i.indexOf(Ie) === 0 && (r[s] = A[i]);
      }), this.globalProerties = { ...r }, this.globalProerties;
    } catch (A) {
      return I.error("[PI]: error fetching global properties"), I.error(A), {};
    }
  }
  async _flushModifiedEvent(A, t = {}) {
    const r = cr(t);
    this.batchedEventRequests.push({
      name: A,
      ...r
    }), this.batchedEventRequests.length >= this.batchSize ? await this.sendBatchedApiCallsWithRetry() : this.startTimer();
  }
  processTempEventQueue() {
    for (; this.tempEventQueue.length > 0 && this.isExperimentEnabled; ) {
      const { name: A, propertiesToSend: t } = this.tempEventQueue.shift(), r = TA.getExperimentProperties(), n = {
        ...t,
        ...r
      }, i = cr(n);
      this.batchedEventRequests.push({
        name: A,
        ...i
      });
    }
    this.batchedEventRequests.length >= this.batchSize ? this.sendBatchedApiCallsWithRetry() : this.startTimer();
  }
  getUserId() {
    if (this.userId)
      return this.userId;
    try {
      let A = oA.getItem(
        cA.USER_ID_KEY
      );
      A != null && (this.userId = A);
    } catch {
    } finally {
      return this.userId;
    }
  }
  createAndSetUniqueid() {
    this.uniqueId = Sn();
    try {
      oA.setItem(cA.UNIQUE_ID_KEY, this.uniqueId);
    } catch (A) {
      I.error("[PI]: error setting unique id"), I.error(A);
    }
  }
  getUniqueId() {
    if (this.uniqueId)
      return this.uniqueId;
    try {
      let A = oA.getItem(
        cA.UNIQUE_ID_KEY
      );
      if (A != null)
        return this.uniqueId = A, this.uniqueId;
      this.createAndSetUniqueid();
    } catch {
      this.createAndSetUniqueid();
    } finally {
      return this.uniqueId;
    }
  }
  isInitializedWithToken() {
    return !!(this.isSDKInitialized && this.token);
  }
  canProcessRequests() {
    return this.isInitializedWithToken() || I.warn(
      "Percept token is missing. You might have missed initializing the SDK"
    ), !0;
  }
  isSameUrl() {
    let A = _r();
    return Oa() === A;
  }
  triggerPostPageSwitchTasks() {
    I.log("[PI] triggering post route changes tasks"), this.shouldCaptureScreenshot && qi.routeChanged(location.pathname), this.isHeatmapEnabled && Dr.init(this.capture.bind(this));
  }
  capturePageView() {
    if (this.isSameUrl())
      return;
    let A = _r();
    this.isPageviewCaptureEnabled && (I.log("[PI] capturing page view"), this.capture(pA.PAGE_VIEW)), Da(A), this.triggerPostPageSwitchTasks();
  }
  setUpAutoPageViewTracking() {
    let A = !1;
    requestAnimationFrame(() => {
      this.capturePageView(), A = !0;
    }), this.domObserver = new MutationObserver(() => {
      A && this.capturePageView();
    });
    const t = { subtree: !0, childList: !0 };
    this.domObserver.observe(document, t);
  }
  addListeners(A) {
    const t = () => {
      this.flushOnUnload();
    }, r = () => {
      document.visibilityState === "hidden" && this.flushOnUnload();
    }, n = () => {
      var s;
      (s = this.domObserver) == null || s.disconnect(), window.removeEventListener("pagehide", t), window.removeEventListener("visibilitychange", r), Dr.reset(), zi.reset(), this.flushOnUnload();
    }, i = (s, a, o, B, l) => {
      var u;
      this.capture(pA.UNHANDLED_ERROR, {
        [VA.UNHANDLED_ERROR_EVENT]: s.toString(),
        [VA.UNHANDLED_ERROR_URL]: a,
        [VA.UNHANDLED_ERROR_LINE]: o,
        [VA.UNHANDLED_ERROR_COL]: B,
        [VA.UNHANDLED_ERROR_STACK]: (u = l == null ? void 0 : l.stack) == null ? void 0 : u.toString(),
        [VA.UNHANDLED_ERROR_MSG]: l == null ? void 0 : l.message,
        [VA.UNHANDLED_ERROR_NAME]: l == null ? void 0 : l.name
      });
    };
    window.addEventListener("pagehide", t, { capture: !0 }), window.addEventListener("visibilitychange", r, {
      capture: !0
    }), window.addEventListener("beforeunload", n, {
      capture: !0
    }), A != null && A.autoTrackRuntimeErrors && (window.onerror = i);
  }
  flushOnUnload() {
    this.batchCheckTimer && clearTimeout(this.batchCheckTimer), !(this.batchedEventRequests.length < 1) && (Na(this.batchedEventRequests, this.token), this.batchedEventRequests = [], this.isExperimentEnabled && TA.clearRefetchTimer());
  }
  startTimer() {
    this.batchCheckTimer && clearTimeout(this.batchCheckTimer), this.batchCheckTimer = setTimeout(() => {
      this.sendBatchedApiCallsWithRetry();
    }, this.timeThresholdMilliseconds);
  }
  async sendBatchedApiCallsWithRetry() {
    if (!this.token) {
      I.warn(
        "Percept token is missing. You might have missed initializing the SDK"
      );
      return;
    }
    return new Promise(async (A) => {
      let t = [...this.batchedEventRequests];
      this.batchedEventRequests = [];
      try {
        this.batchCheckTimer && clearTimeout(this.batchCheckTimer), await Xa(t, this.token);
      } catch {
        Yn.schedule();
      } finally {
        A(null);
      }
    });
  }
}
const ha = new jg();
Object.seal(ha);
typeof window < "u" && (window.percept = ha);
export {
  La as PerceptUserPropertyKeys,
  ha as default
};
